import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import differenceInHours from 'date-fns/difference_in_hours'
import setYear from 'date-fns/set_year'
import addMonths from 'date-fns/add_months';
import lastDayOfMonth from 'date-fns/last_day_of_month';
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'
import differenceInCalendarMonths from 'date-fns/difference_in_calendar_months'
import differenceInCalendarYears from 'date-fns/difference_in_calendar_years'
import startOfWeek from 'date-fns/start_of_week'
import {globalfunc} from '../globalfunc.js'
import moment from 'moment';
import axios from 'axios';
import subMonths from 'date-fns/sub_months';
import endOfMonth from 'date-fns/end_of_month';
import { getUserAll, getCompany, getTeamByCompany, getEngagementIndexDay } from './core/cacheService'
export default {
  namespaced: true,
  state: {
    membersall: [],
    memberKey: [],
    teamHeight: '',
    teamkeys: {},
    datalist: [],
    datalistAll: [],
    datalistSearchAll: [],
    teamList: [],
    teamSelected: "all",
    statusSelected: "all",
    waitTypingSearchBox: false,
    loadingManager: true,
    loadingManagerOverview: true,
    loadingManagerInsight: true,
    _activeOverview: {},
    loadingCoaching: true,
    insightsOpenRateSetting: {
      active: 0,
      passive: 0
    },
    feedbackReplyRateSetting: {
      active: 40,
      passive: 10
    },
    size_page: 10,
    inputSearchManager: "",
    managerResults: 0,
    managerPage: 1,
    managerSortField: "",
    managerSortOrder: "",
    managerTypingStatus: null,
    activeOverview: {
      active:0,
      all:0,
      compareactive:0,
      compareinactive:0,
      comparepassive:0,
      inactive:0,
      passive:0,},
    insightToday: [],
    criticalAllTeam: [],
    directReportByKey: [],
    showSnackbar: false,
    dataexportall: [],
    modalCoachingData: [],
    tabManager:false,
    nudgesAll:{},
    superfeedbackAll:{},
    ReplyQualityAll:{},
    openEndedFeedbackAll:{},
    boss:{},
    loadingManagerNudges: true,
    nudges:0,
    teamOneLevel:[],
    pastActivity:{},
    nudgesData:{},
    dataAllByTeam:[],
    insight:{
      ['insight']:{
        feedback:{
          thirty:0,
          compare:0
        }
      }
    },
  responseAll:{},
  response:{},
  loadingresponse:true,
  organization:{},
  dataQualitybyTeam:{},
  dataQualitybyTeamToday:{},
  insightresponse:{},
  responseToday:{},
  label:[],
  weeklyData:[],
  dataToday:{},
  proactivityAll:{},
  standards_data:{open_rate:{active:0,passive:0},feedback_rate:{active:0,passive:0},status:false},
  memberbyteam:0,
  user_placeholder:{},
  peerFeedbackHistory:{},
  dataThisMonth:{},
  selectedteam:'',
    performanceBoostEnabled: true,
    companyData: null,
    bossDirectory: {},
    // Manager To-do List state
    managerTodoList: {} as { [email: string]: { [weekDate: string]: { todoList: any[], headline: string } } },
  managerTodoSelectedWeek: {} as { [email: string]: string },
  managerTodoAvailableWeeks: {} as { [email: string]: string[] },
  loadingManagerTodos: true,
  // Manager Responsiveness Trend state
  weeklyResponsivenessData: [] as Array<{ weekKey: string; weekLabel: string; active: number; passive: number; inactive: number; total: number }>,
  weeklyResponsivenessCacheKey: '' as string
  },
  mutations: {
    setTeamHeight(state: any, value: any) {
      state.teamHeight = value
    },
    setMemberKey(state: any, result: any) {
      state.memberKey = result
    },
    
    setDataList(state: any, result: any) {
      state.datalist = result || [];
    },
    setDataListAll(state: any, result: any) {
      state.datalistAll = result || [];
    },
    setDataListSearchAll(state: any, result: any) {
      state.datalistSearchAll = result || [];
    },
    setTeamList(state: any, result: any) {
      state.teamList = result || [];
    },
    setTeamSelected(state: any, value: any) {
      state.teamSelected = value || "all";
    },
    setStatusSelected(state: any, value: any) {
      state.statusSelected = value || "all";
    },
    setInputSearchManager(state: any, text: any) {
      state.inputSearchManager = text || "";
    },
    setWaitTypingSearchBox(state: any, status: any) {
      state.waitTypingSearchBox = status || false;
    },
    setInsightsOpenRateSetting(state: any, setting: any) {
      if (setting.active !== undefined && setting.passive !== undefined) {
        state.insightsOpenRateSetting = setting;
      }
    },
    setFeedbackReplyRateSetting(state: any, setting: any) {
      if (setting.active !== undefined && setting.passive !== undefined) {
        state.feedbackReplyRateSetting = setting;
      }
    },
    setPerformanceBoostEnabled(state: any, value: boolean) {
      state.performanceBoostEnabled = value;
    },
    setCompanyData(state: any, value: any) {
      state.companyData = value || null;
    },
    setBossDirectory(state: any, value: any) {
      state.bossDirectory = value || {};
    },
    loadingManager(state: any, status: any) {
      state.loadingManager = status;
    },
    loadingCoaching(state: any, status: any) {
      state.loadingCoaching = status;
    },
    setManagerResults(state: any, result: any) {
      state.managerResults = result
    },
    setManagerPage(state: any, result: any) {
      state.managerPage = result
    },
    setManagerSortField(state: any, result: any) {
      state.managerSortField = result
    },
    setManagerSortOrder(state: any, result: any) {
      state.managerSortOrder = result
    },
    setManagerTypingStatus(state: any, status: any) {
      state.managerTypingStatus = status
    },
    setActiveOverview(state: any, result: any) {
      state.activeOverview = result
    },
    setInsightToday(state: any, result: any) {
      state.insightToday = result
    },
    setCriticalAllTeam(state: any, result: any) {
      state.criticalAllTeam = result
    },
    setDirectReportByKey(state: any, result: any) {
      state.directReportByKey = result
    },
    setSnackbar(state: any, value: any) {
      state.showSnackbar = value
    },
    setDataExportAll(state: any, value: any) {
      state.dataexportall = value
    },
    setModalCoachingData(state: any, value: any) {
      state.modalCoachingData = value
    },
    setTabManager(state: any, status: any) {
      state.tabManager = status
    },
    set_activeOverview(state: any, status: any) {
      state._activeOverview = status
    },
    setLoadingManagerOverview(state: any, status: any) {
      state.loadingManagerOverview = status
    },
    setNudgesAll(state: any, status: any) {
      state.nudgesAll = status
    },
    setSuperfeedbackAll(state: any, status: any) {
      state.superfeedbackAll = status
    },
    setReplyQualityAll(state: any, status: any){
      state.ReplyQualityAll = status
    },
    setOpenEndedFeedbackAll(state: any, status: any){
      state.openEndedFeedbackAll = status
    },
    setDataAllByTeam(state: any, status: any){
      state.dataAllByTeam = status
    },
    setBoss(state: any, status: any){
      state.boss = status
    },
    setNudges(state: any, status: any){
      state.nudges = status
    },
    setPastActivity(state: any, status: any){
      state.pastActivity = status
    },
    setInsight(state: any, status: any){
      state.insight = status
    },
    setloadingManagerInsight(state: any, status: any){
      state.loadingManagerInsight = status
    },
    setNudgesData(state: any, status: any){
      state.nudgesData = status
    },
    setResponseAll(state: any, status: any){
      state.responseAll = status
    },
    setResponse(state: any, status: any){
      state.response = status
    },
    setloadingresponse(state: any, status: any){
      state.loadingresponse = status
    },
    setdataQualitybyTeam(state: any, status: any){
      state.dataQualitybyTeam= status
    },
    setInsightresponse(state: any, status: any){
      state.insightresponse= status
    },
    setLabel(state: any, status: any){
      state.label= status
    },
    setweeklyData(state: any, status: any){
      state.weeklyData= status
    },
    setDataToday(state: any, status: any){
      state.dataToday= status
    },
    setStandards(state: any, status: any){
      state.standards_data= status
    },
    setmemberbyteam(state: any, status: any){
      state.memberbyteam= status
    },
    setUserPlaceholder(state: any, status: any){
      state.user_placeholder= status
    },
    setMemberall(state:any, result:any) {
      state.membersall = result
    },
    setPeerFeedbackHistory(state: any, status: any){
      state.peerFeedbackHistory = status
    },
    setDataThisMonth(state: any, status: any){
      state.dataThisMonth = status
    },
    setSelectedteam(state: any, status: any){
      state.selectedteam = status
    },
    // Manager To-do List mutations
    setManagerTodoList(state: any, payload: { email: string, weekDate: string, data: any }) {
      if (!state.managerTodoList[payload.email]) {
        Vue.set(state.managerTodoList, payload.email, {});
      }
      Vue.set(state.managerTodoList[payload.email], payload.weekDate, payload.data);
    },
    setManagerTodoSelectedWeek(state: any, payload: { email: string, weekDate: string }) {
      Vue.set(state.managerTodoSelectedWeek, payload.email, payload.weekDate);
    },
    setManagerTodoAvailableWeeks(state: any, payload: { email: string, weeks: string[] }) {
      Vue.set(state.managerTodoAvailableWeeks, payload.email, payload.weeks);
    },
    addManagerTodoAvailableWeek(state: any, payload: { email: string, weekDate: string }) {
      if (!state.managerTodoAvailableWeeks[payload.email]) {
        Vue.set(state.managerTodoAvailableWeeks, payload.email, []);
      }
      if (!state.managerTodoAvailableWeeks[payload.email].includes(payload.weekDate)) {
        const updatedWeeks = [...state.managerTodoAvailableWeeks[payload.email], payload.weekDate].sort().reverse();
        Vue.set(state.managerTodoAvailableWeeks, payload.email, updatedWeeks);
      }
    },
    setLoadingManagerTodos(state: any, status: boolean) {
      state.loadingManagerTodos = status;
    },
    clearManagerTodoList(state: any) {
      state.managerTodoList = {};
      state.managerTodoSelectedWeek = {};
      state.managerTodoAvailableWeeks = {};
    },
    // Manager Responsiveness Trend mutation
    setWeeklyResponsivenessData(state: any, payload: any) {
      if (Array.isArray(payload)) {
        state.weeklyResponsivenessData = payload;
        state.weeklyResponsivenessCacheKey = '';
      } else {
        state.weeklyResponsivenessData = payload.data || [];
        state.weeklyResponsivenessCacheKey = payload.cacheKey || '';
      }
    },
  },
  actions: {
    resetState({ commit }: any) {
      const data: Array<any> = [];
      data['user'] = new Array()
      data['user'].firstname = ''
      data['user'].lastname = ''
      data['user'].team_name = ''
      data['coaching'] = new Array()
      commit('setModalCoachingData', data)
    },
    
    /**
     * Calculate Psychological Safety using behavioral indicators only
     * 
     * This algorithm measures psychological safety through observable behaviors:
     * 
     * PARTICIPATION INDEX (55% weight):
     * - Participation Rate (60%): % of people answering open-ended questions
     * - Skip Penalty (40%): Non-linear penalty for "I'd rather not say" responses
     * 
     * VOICE SAFETY INDEX (45% weight):
     * - Direct inverse of anonymous feedback rate (100 - anonymousPercent)
     * - Higher score = more people comfortable giving non-anonymous feedback
     * 
     * @param params Object containing openEndedFeedback, notToSayRatio, anonymousPercent, superFeedbackRate
     * @returns Psychological Safety score (0-100)
     */
    calculatePsychologicalSafety({ commit, dispatch, rootState, state }: any, params: any): number {
      const { openEndedFeedback, notToSayRatio, anonymousPercent, superFeedbackRate } = params

      // Step 1: Compute raw sub-scores (0-100)
      const participation = Math.min(100, openEndedFeedback) // Already a percentage
      const skipPenalty = Math.max(0, 100 - Math.min(100, notToSayRatio * 2)) // Non-linear penalty
      const recognition = Math.min(100, superFeedbackRate) // Already a percentage

      // Step 2: Convert to component indices
      const participationIdx = (0.6 * participation) + (0.4 * skipPenalty)
      const voiceSafetyIdx = Math.max(0, Math.min(100, 100 - anonymousPercent)) // Direct inverse of anonymous rate

      // Step 3: Aggregate with weights
      let safetyRating = (0.55 * participationIdx) + (0.45 * voiceSafetyIdx)
      
      // Step 4: Apply bounds and handle edge cases
      safetyRating = Math.max(0, Math.min(100, safetyRating))
      return isNaN(safetyRating) ? 0 : safetyRating
    },
    
    async getDataAll({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      commit('loadingManager', true);
      commit('setloadingManagerInsight', true);
      commit('setLoadingManagerOverview', true);
      commit('setloadingresponse', true);
      let _selectTeam=selectTeam
      state.loadingManagerNudges=true
      const memberAndTeam = rootState.dashboard.memberAndTeam || {}
      if(!memberAndTeam.users || !memberAndTeam.teams){
       await dispatch("dashboard/getMemberAndTeam", rootState.authen.user,{root:true})
      }
      const dashboardData = rootState.dashboard.memberAndTeam || {}
      const allUser = dashboardData.users || {}
      let teams = dashboardData.teams || {}
      if(!teams || Object.keys(teams).length === 0){
        teams = await getTeamByCompany(rootState.authen.user.company)
      }
      let company = state.companyData
      if(!company || Object.keys(company).length === 0){
        company = await getCompany(rootState.authen.user.company)
        commit('setCompanyData', company)
      }

      // Populate teamkeys from team data
      if (rootState.team.teamsfixedall.length > 0 && rootState.team.teamsall.length > 0) {
        _.forEach(rootState.team.teamsall, (value) => {
          state.teamkeys[value.key] = value
        });
      } else {
        // Fallback to API teams data
        _.forEach(teams, (value, key) => {
          state.teamkeys[key] = value
        });
      }
      if (!selectTeam) {
        if(rootState.authen.user.user_type == 'leadership'){
          selectTeam = rootState.authen.user.team
          commit('setTeamHeight', selectTeam)
        }else{
          if (!state.teamHeight) {
            if (rootState.team.teamsfixedall.length > 0) {
              let topmostArr: Array<any> = [];
              _.forEach(rootState.team.teamsfixedall, (value) => {
                if(value.parent == ''){
                  topmostArr.push(value.key)
                }
              });
              selectTeam = topmostArr[0]
              if(topmostArr.length > 1){
                selectTeam = _.find(topmostArr, (value) => {
                  const chk_topmost = _.find(rootState.team.teamsfixedall, { parent: value });
                  return !!chk_topmost;
                });
              }
              commit('setTeamHeight', selectTeam)
            } else {
              let topmostArr: Array<any> = [];
              for(const x in teams){
                if(!teams[x].parent){
                  topmostArr.push(x)
                }
              }
              selectTeam = topmostArr[0]
              if(topmostArr.length > 1){
                selectTeam = _.find(topmostArr, (value) => {
                  const chk_topmost = _.find(teams, { parent: value });
                  return !!chk_topmost;
                });
              }
              
              //   snapshot.forEach((doc): any => {
              //     if (!doc.val().parent) {
              //       selectTeam = doc.key
              //     }
              //   });
              // });
              commit('setTeamHeight', selectTeam)
            }
          } else {
            selectTeam = state.teamHeight
          }
        }
      }
      if(_selectTeam==''||_selectTeam==undefined){
        _selectTeam = state.teamHeight
      }
      
      let allTeam:any={}
        const _teams:Array<any> = [];
        const teams_temp:Array<any> = [];
        let chk_teams_master:Array<any> = [];
        const parent:{ [key: string]: string} = {};
      for(const x in teams){
            const team = teams[x]
            team.key = x
            team.key_temp = x
            team.value = teams[x].name
            _teams.push(team)
            teams_temp[team.key] = team
            allTeam[team.key] = team
            if(x) parent[x] =teams[x].name
      }
        const teamData=_.groupBy(_teams, 'parent')
        for(const x in teamData){
          teamData[x].push(teams[x])
        }
        state.organization=teamData
        _.forEach(_teams, (value,key)=> {
            if(value.parent){
              _teams[key].parent_name = parent[value.parent]
              teams_temp[value.key].parent_name = parent[value.parent]
            }else{
              _teams[key].parent_name = '';
              teams_temp[value.key].parent_name = '';
              if(chk_teams_master['count'] == undefined){
                  chk_teams_master['count'] = 1
              }else{
                  chk_teams_master['count'] += 1
              }
              if(chk_teams_master['team'] == undefined){
                  chk_teams_master['team'] = new Array()
              }
              chk_teams_master['team'].push(value.key)
            }
        });

        if(chk_teams_master['count'] == 1){
          let chkUser = _.filter(allUser, { 'team': chk_teams_master['team'][0] });
          if(chkUser.length > 0){
          }else if(_selectTeam!=undefined&&_selectTeam!=''){}else{
            let chkTeam:any = _.filter(allTeam, { 'parent': chk_teams_master['team'][0] });
            if(chkTeam && chkTeam.length > 0){
              const chkTeamNextLevel:Array<any> = [];
              let chkCount = 0
              _.forEach(chkTeam, (value, key) => {
                  chkTeamNextLevel.push(value.key)
              });
              if(chkTeamNextLevel.length == 1){
                  for(const x in teams_temp){
                      if(chk_teams_master['team'][0] == teams_temp[x].key){
                          selectTeam = chkTeamNextLevel[0]
                          if(_selectTeam==''){
                            _selectTeam = selectTeam
                          }
                          if(_selectTeam==undefined){
                            commit('setTeamHeight', selectTeam)
                          }
                      }
                  }
              } else {
                  const chkUserInTeam:Array<any> = [];
                  _.forEach(chkTeamNextLevel, (value, key) => {
                      let chkUser = _.filter(allUser, { team: value });
                      if(chkUser.length > 0){
                          chkUserInTeam.push(value)
                          chkCount++
                      }
                  });
                  if(chkCount == 1){
                      for(const x in teams_temp){
                          if(chk_teams_master['team'][0] == teams_temp[x].key){
                              selectTeam = chkUserInTeam[0]
                              if(_selectTeam==''){
                                _selectTeam = selectTeam
                              }
                              if(_selectTeam==undefined){
                                commit('setTeamHeight', selectTeam)
                              }
                          }
                      }
                  }
              }
            }
          }
        }

    
      if (state.datalistAll.length == 0) {
        // Set performance boost enabled flag from this company's settings
        const perfBoostEnabledFromCompany = company && company.performance_review ? company.performance_review.enabled !== false : true
        commit('setPerformanceBoostEnabled', perfBoostEnabledFromCompany)
        let dateNow = new Date()
        let thisYear = parseInt(format(dateNow, 'YYYY'))
        const users: Array<any> = [];
        const arrusers: Array<any> = [];
        const userSub:Array<any> = [];
        for(const x in allUser){
          const u = allUser[x];
          u.key = x
          // Store original profilepic before overwriting
          const originalProfilepic = u.profilepic;
          
          // Assign thumbnail/small images for list view (prioritize smaller for performance)
          if(u.profilepic_small){
            u.profilepic = u.profilepic_small;
            u.pic = u.profilepic_small;
          }else if (u.profilepic_crop){
            u.profilepic = u.profilepic_crop;
            u.pic = u.profilepic_crop;
          }else if (u.profilepic){
            u.profilepic = u.profilepic;
            u.pic = u.profilepic;
          }else {
            u.profilepic = "";
            u.pic = "";
          }
          
          // Assign large image for modal view (prioritize highest resolution)
          if(originalProfilepic) {
            u.large_pic = originalProfilepic
          }else if(u.profilepic_crop) {
            u.large_pic = u.profilepic_crop
          }else if(u.profilepic_small){
            u.large_pic = u.profilepic_small
          }else {
            u.large_pic = ""
          }
          if(u.tutorial && u.tutorial == 'Y'){
            let dayActive = differenceInCalendarDays(dateNow, u.updated)
            if(dayActive > 30){
              u.status = 'inactive'
              u.to_now = format(u.updated,'MMM D, YYYY')
            }else{
              u.status = 'active'
              u.to_now = globalfunc.timeSince(u.updated)
            }
          }else if(u.invited){
            u.status = 'invited'
            u.to_now = globalfunc.timeSince(u.invited)
          }else{
            u.status = 'new'
          }
          u.medalCount = 0
          if(company.medal && u.medal){
              _.forEach(u.medal, (value,key)=> {
                  u.medal[key] = company.medal[key]
                  u.medalCount += value
              });
          }
          if(u.joined_tooltips === undefined){
            u.joined_tooltips = new Array()
          }
          if(u.workdate){
            u.joined = format(u.workdate,'MMMM D, YYYY')
            let arrJoined:Array<any> = [];
            arrJoined['year'] = differenceInCalendarYears(dateNow, u.workdate)
            let month = differenceInCalendarMonths(dateNow, setYear(u.workdate,thisYear))
            if(month < 0){
                arrJoined['month'] = month + 12
                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
            }else{
                arrJoined['month'] = month
            }
            let day = parseInt(format(dateNow,'DD')) - parseInt(format(u.workdate,'DD'))
            if(day < 0){
                arrJoined['day'] = day + parseInt(format(lastDayOfMonth(addMonths(dateNow, -1)),'DD'));
                if(arrJoined['month'] > 0){
                arrJoined['month'] = arrJoined['month'] - 1
                }else{
                arrJoined['month'] = 12
                arrJoined['year'] = (arrJoined['year'] > 0) ? arrJoined['year'] - 1 : 0
                }
            }else{
                arrJoined['day'] = day
            }
            u.joined_tooltips.push(arrJoined)
        }
          u.fullname = u.firstname + ' ' + u.lastname
          u.shortname = u.firstname.charAt(0) + u.lastname.charAt(0)
          if(u.team) {
            const teamData = state.teamkeys[u.team]
            u.team_name = teamData && teamData.name ? teamData.name : ''
            u.team_color = teamData && teamData.color ? teamData.color : ''
          } else {
            u.team_name = ''
            u.team_color = ''
          }
          // users.push(u)
          if(u.boss){
            if(userSub[u.boss] === undefined){
              userSub[u.boss] = new Array()
            }
            userSub[u.boss].push(u)
          }
          users[u.email] = u
          arrusers.push(u)
        }
        let _users:Array<any> = [];
        _users = _.sortBy(arrusers, [function(o:any) { return o.workdate; }])
        let orderJoin = 1
        _.forEach(_users, (item,key)=> {
            if(item.workdate){
                users[item.email].order_join = orderJoin
                orderJoin++
            }
        });
        // console.log("users",users)
        // console.log("userSub",userSub)
        commit('setMemberall', users)
        commit('setMemberKey', users);
        commit('setDirectReportByKey',userSub)
        dispatch('getMemberTeam', selectTeam).then(()=>{
        dispatch('getDataTable', selectTeam).then(()=>{
            if(!_selectTeam){
              dispatch('getrespornse', selectTeam).then(()=>{
              dispatch('getDataOverview', selectTeam)
              //console.log('ii7898789')
            })
          }else{
            dispatch('getDataOverview', _selectTeam)
            }
            
          })
         
        })
        
        // await firebase.database().ref('users').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', async snapshot => {
        //   snapshot.forEach((arrData): any => {
        //     const u = arrData.val()
        //     u.key = arrData.key
        //     if(u.profilepic_small){
        //       u.profilepic = u.profilepic_small;
        //     }else if (u.profilepic_crop){
        //       u.profilepic = u.profilepic_crop;
        //     }else if (u.profilepic){
        //       u.profilepic = u.profilepic;
        //     }else {
        //       u.profilepic = "";
        //     }
        //     u.fullname = u.firstname + ' ' + u.lastname
        //     u.shortname = u.firstname.charAt(0) + u.lastname.charAt(0)
        //     if(u.team) u.team_name = (state.teamkeys[u.team]!=undefined)?state.teamkeys[u.team]["name"]:''
        //     // users.push(u)
        //     if(u.boss){
        //       if(userSub[u.boss] === undefined){
        //         userSub[u.boss] = new Array()
        //       }
        //       userSub[u.boss].push(u)
        //     }
        //     users[u.email] = u
        //   });
        //   commit('setMemberKey', users);
        //   commit('setDirectReportByKey',userSub)
        //   dispatch('getDataTable', selectTeam)
        // });
      }else{
       
        //dispatch('getDataTable', selectTeam)]

        dispatch('getMemberTeam', _selectTeam).then(()=>{
          dispatch('getDataTable', _selectTeam)
          dispatch('changeTeam', _selectTeam)
        })
      }
    },
    async getDataTable({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      // console.log('getDataTable', selectTeam)
      // console.log('teamHeight', state.teamHeight)
      let subTeam:any = {}
      subTeam[selectTeam] = true
      let organization1level = (state.teamOneLevel && state.teamOneLevel.parent && state.teamOneLevel.parent) ? state.teamOneLevel.parent : subTeam
      let company = state.companyData
      if(!company || Object.keys(company).length === 0){
        company = await getCompany(rootState.authen.user.company)
        commit('setCompanyData', company)
      }
      const manager_classification = company ? company.manager_classification : null//(await firebase.database().ref(`company/${rootState.authen.user.company}/manager_classification`).once('value')).val()
      let allUser = rootState.dashboard.memberAndTeam && rootState.dashboard.memberAndTeam.users
      if(!allUser || Object.keys(allUser).length === 0){
        const memberAndTeam = await dispatch("dashboard/getMemberAndTeam", rootState.authen.user,{root:true})
        allUser = memberAndTeam.users || {}
      }
      let act_open_rate = manager_classification ? manager_classification.active_open_rate : state.insightsOpenRateSetting.active
      let act_feedback_rate = manager_classification ? manager_classification.active_feedback_rate : state.feedbackReplyRateSetting.active
      let pass_open_rate = manager_classification ? manager_classification.passive_open_rate : state.insightsOpenRateSetting.passive
      let pass_feedback_rate = manager_classification ? manager_classification.passive_feedback_rate : state.feedbackReplyRateSetting.passive
      commit('setStandards',{open_rate:{active:act_open_rate,passive:pass_open_rate},feedback_rate:{active:act_feedback_rate,passive:pass_feedback_rate},status:manager_classification ? true : false})
      let listData: Array<any> = []
      let countAll = 0
      let countAct = 0
      let countPas = 0
      let countInact = 0
      let _countAct = 0
      let _countPas = 0
      let _countInact = 0
      const insightTeams: any = [];
      const criticalTeams: any = [];
      const receive:any = []
      let boss=state.boss
       let teamOneLevel: any =state.teamOneLevel
      var promise1 = new Promise(async function(resolve, reject) {
        if(state.criticalAllTeam && Object.keys(state.criticalAllTeam).length > 0){
          resolve(state.criticalAllTeam);
        }else{
          const _data:any=[]
          firebase.firestore().collection('report_weekly_manager_direct_all').where('company', '==', rootState.authen.user.company).where('date', '>', format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              _data.push(doc.data())
              if (insightTeams[doc.data().quest_id + '==' + doc.data().email] === undefined) {
                insightTeams[doc.data().quest_id + '==' + doc.data().email] = [];
              }
              insightTeams[doc.data().quest_id + '==' + doc.data().email].push(doc.data());
            });

            const color = ['red', 'yellow'];
            for (const x in insightTeams) {
              const questions = x.split('==');
              if (questions[0] === '-L1QWPtZvax_KlJgpNxF' && insightTeams[x].length > 1) {//feedback
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Feedback'] = 'Feedback';
                }
              } else if (questions[0] === '-L1Qug-PhtzVOR2Dr5q7' && insightTeams[x].length > 1) {//real manager
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Rel. Manager'] = 'Rel. Manager';
                }
              } else if (questions[0] === '-L36rxTgLhZTL4mq4SV1' && insightTeams[x].length > 1) {//wellness
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Wellness'] = 'Wellness';
                }
              } else if (questions[0] === '-L0J5FFsGQYVkfcGujWo' && insightTeams[x].length > 1) {//recognition
                const lastweek = insightTeams[x][insightTeams[x].length - 2];
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(lastweek.color) || color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Recognition'] = 'Recognition';
                }
              } else if (questions[0] === '-L1FmpFO-v8IZc_B5EB7') {//satisfaction
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Satisfaction'] = 'Satisfaction';
                }
              } else if (questions[0] === '-Kgs549ClADmNQwoNbbG') {//Rel. Colleagues
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Rel. Colleagues'] = 'Rel. Colleagues';
                }
              } else if (questions[0] === '-Kgn7oxLPPWlbM_ZDc_h') {//Personal Growth
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Personal Growth'] = 'Personal Growth';
                }
              } else if (questions[0] === '-LtOL_iR1N-ev2b_8Tmg') {//Company Alignment
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Company Alignment'] = 'Company Alignment';
                }
              } else if (questions[0] === '-L2ycGiBDo3rDGjLNKwW') {//Ambassadorship
                const thisweek = insightTeams[x][insightTeams[x].length - 1];
                if (color.includes(thisweek.color)) {
                  if (criticalTeams[questions[1]] === undefined) {
                    criticalTeams[questions[1]] = [];
                  }
                  criticalTeams[questions[1]]['Ambassadorship'] = 'Ambassadorship';
                }
              }
            }
            //('_datam',_data.length)
            commit('setCriticalAllTeam', criticalTeams);
            resolve(criticalTeams);
          });
        }
      });
     
      // var promise2 = new Promise(function(resolve, reject) {
      //   const data2:Array<any> = []
      //   firebase.firestore().collection('insight_manager_today').where('company', '==', rootState.authen.user.company).where("date", ">=", format(addDays(new Date(), -30), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //       const data = doc.data()
      //       if(organization1level[data.team]){
      //         if (data2[data.email] === undefined) {
      //           data2[data.email] = {}
      //         }
      //         data2[data.email].team = doc.data().team;
      //         // sometime data error read > receive
      //         if(data.read > data.receive){
      //           data.read = data.receive
      //         }
      //         if(doc.data().type=="feedback"){
      //           if(data2[data.email].read_feedback === undefined) data2[data.email].read_feedback = 0
      //           if(data2[data.email].receive_feedback === undefined) data2[data.email].receive_feedback = 0
      //           data2[data.email].read_feedback += data.read
      //           data2[data.email].receive_feedback += data.receive
      //         }else if(doc.data().type=="report_daily_boss"){
      //           if(data2[data.email].read_report_daily_boss === undefined) data2[data.email].read_report_daily_boss = 0
      //           if(data2[data.email].receive_report_daily_boss === undefined) data2[data.email].receive_report_daily_boss = 0
      //           data2[data.email].read_report_daily_boss += data.read
      //           data2[data.email].receive_report_daily_boss += data.receive
      //         }else if(doc.data().type=="report_weekly_boss"){
      //           if(data2[data.email].read_report_weekly_boss === undefined) data2[data.email].read_report_weekly_boss = 0
      //           if(data2[data.email].receive_report_weekly_boss === undefined) data2[data.email].receive_report_weekly_boss = 0
      //           data2[data.email].read_report_weekly_boss += data.read
      //           data2[data.email].receive_report_weekly_boss += data.receive
      //         }
      //       }
      //     });

      //     for(const email in data2){
      //     let report_daily_boss=0
      //     let feedback=0
      //     let report_weekly_boss=0
      //       if(data2[email]){
      //         if(data2[email].receive_feedback>0){
      //           feedback = (data2[email].read_feedback/data2[email].receive_feedback)*100
      //           if(feedback > 100 ) feedback = 100;
      //           data2[email].feedback = (feedback) ? Math.round(feedback) : 0
      //         }else{
      //           feedback = 100
      //           data2[email].feedback = '-'
      //         }
              
            
      //         if(data2[email].receive_report_weekly_boss>0) report_weekly_boss = (data2[email].read_report_weekly_boss/data2[email].receive_report_weekly_boss)*100;
      //         if(data2[email].receive_report_daily_boss>0)  report_daily_boss = (data2[email].read_report_daily_boss/data2[email].receive_report_daily_boss)*100;
      //         if(report_daily_boss > 100 ) report_daily_boss = 100;
      //         if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //         let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //         let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //         let open_rate = ((dailyData * 5 + weeklyData))/6
      //         data2[email].open_rate = open_rate
      //         if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //           data2[email].active = 'Y'
      //           data2[email].status = 'active'
      //           countAct += 1
                
      //         }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //           data2[email].passive = 'Y'
      //           data2[email].status = 'passive'
      //           countPas += 1
                
      //         }else{
      //           data2[email].inactive = 'Y'
      //           data2[email].status = 'inactive'
      //           countInact += 1
      //         }
      //         data2[email].daily = (report_daily_boss) ? Math.round(report_daily_boss) : 0
      //         data2[email].weekly = (report_weekly_boss) ? Math.round(report_weekly_boss) : 0
              
      //         data2[email].open_rate = open_rate
      //         if(open_rate >= act_open_rate){
      //           data2[email].insights_opened_check = 'Y'
      //         }else{
      //           data2[email].insights_opened_check = 'N'
      //         }
      //         if(feedback >= act_feedback_rate){
      //           data2[email].feedback_check = 'Y'
      //         }else{
      //           data2[email].feedback_check = 'N'
      //         }
      //       }
      //     }
      //     resolve(data2);
      //   });
      // });

      // var promise3 = new Promise(function(resolve, reject) {
      //   const data3:Array<any> = []
      //   const data_2:Array<any> = []
      //   let dataThirty :Array<any> = []
      //   let dataSixty :Array<any> = []
      //   let dataAllTeamThirty :Array<any> = []
      //   let checkfeedbackThirty :Array<any> = []
      //   let checkfeedbackSixty :Array<any> = []
      //   dataAllTeamThirty['report_daily_boss'] = new Array()
      //   dataAllTeamThirty['report_weekly_boss'] = new Array()
      //   dataAllTeamThirty['feedback'] = new Array()
      //   dataAllTeamThirty['report_daily_boss'] = new Array()
      //   dataAllTeamThirty['report_weekly_boss'] = new Array()
      //   dataAllTeamThirty['feedback'] = new Array()

      //   let dataAllTeamSixty :Array<any> = []
      //   dataAllTeamSixty['report_daily_boss'] = new Array()
      //   dataAllTeamSixty['report_weekly_boss'] = new Array()
      //   dataAllTeamSixty['feedback'] = new Array()
      //   dataAllTeamSixty['report_daily_boss'] = new Array()
      //   dataAllTeamSixty['report_weekly_boss'] = new Array()
      //   dataAllTeamSixty['feedback'] = new Array()
      //   let sixtyDate = format(addDays(new Date(), -60), 'YYYY-MM-DD')
      //   let thirtyDate = format(addDays(new Date(), -30), 'YYYY-MM-DD')
      //   if(state.teamHeight !== selectTeam){
      //   for(const email in state.pastActivity){
           
      //       let report_daily_boss=0
      //       let feedback=0
      //       let report_weekly_boss=0
      //       if(teamOneLevel){
      //         _.forEach(teamOneLevel.parent, (value,key)=> {
      //           if(state.pastActivity[email].team==key){
      //             if(state.pastActivity[email].receive_feedback>0){
      //               feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
      //             }else{
      //               feedback = 100
      //             }
      //             if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
      //             if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
      //             if(report_daily_boss > 100 ) report_daily_boss = 100;
      //             if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //             if(feedback > 100 ) feedback = 100;
      //             let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //             let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //             let open_rate = ((dailyData * 5 + weeklyData))/6
      //             state.pastActivity[email].open_rate = open_rate
      //             if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //               _countAct += 1
      //             }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //               _countPas += 1
      //             }else{
      //               _countInact += 1
      //             }
      //           }
      //         })

      //       }else{

      //           if(state.pastActivity[email].team===selectTeam){

      //             if(state.pastActivity[email].receive_feedback>0){
      //               feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
      //             }else{
      //               feedback = 100
      //             }
      //             if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
      //             if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
      //             if(report_daily_boss > 100 ) report_daily_boss = 100;
      //             if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //             if(feedback > 100 ) feedback = 100;
      //             let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //             let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //             let open_rate = ((dailyData * 5 + weeklyData))/6
      //             state.pastActivity[email].open_rate = open_rate
      //             if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //               _countAct += 1
      //             }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //               _countPas += 1
      //             }else{
      //               _countInact += 1
      //             }
      //           }

              


      //       }
            

      //   }
      //   }else{
      //     if(state.pastActivity){
      //       for(const email in state.pastActivity){
         
      //         let report_daily_boss=0
      //         let feedback=0
      //         let report_weekly_boss=0
      //         if(teamOneLevel){
      //           _.forEach(teamOneLevel.parent, (value,key)=> {
      //             if(state.pastActivity[email].team==key){
      //               if(state.pastActivity[email].receive_feedback>0){
      //                 feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
      //               }else{
      //                 feedback = 100
      //               }
      //               if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
      //               if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
      //               if(report_daily_boss > 100 ) report_daily_boss = 100;
      //               if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //               if(feedback > 100 ) feedback = 100;
      //               let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //               let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //               let open_rate = ((dailyData * 5 + weeklyData))/6
      //               state.pastActivity[email].open_rate = open_rate
      //               if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //                 _countAct += 1
      //               }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //                 _countPas += 1
      //               }else{
      //                 _countInact += 1
      //               }
      //             }
      //           })

      //         }else{
      //             if(state.pastActivity[email].team==selectTeam){
      //               if(state.pastActivity[email].receive_feedback>0){
      //                 feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
      //               }else{
      //                 feedback = 100
      //               }
      //               if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
      //               if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
      //               if(report_daily_boss > 100 ) report_daily_boss = 100;
      //               if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //               if(feedback > 100 ) feedback = 100;
      //               let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //               let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //               let open_rate = ((dailyData * 5 + weeklyData))/6
      //               state.pastActivity[email].open_rate = open_rate
      //               if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //                 _countAct += 1
      //               }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //                 _countPas += 1
      //               }else{
      //                 _countInact += 1
      //               }
      //             }

                


      //         }
              

      //       }

                        
      //     }
      //   }
      //   if(state.insightToday && state.insightToday.thirty){
      //     dataThirty = state.insightToday.thirty
      //     dataSixty = state.insightToday.sixty
      //     if(teamOneLevel){
      //       _.forEach(teamOneLevel.parent, (value,key)=> {
      //         let teamId:any = key
      //         let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
      //         if(arrDataThirty.length > 0){
      //           _.forEach(arrDataThirty, (item,index)=> {
      //             dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
      //             dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
      //           });
      //         }
      //         let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
      //         if(arrDataSixty.length > 0){
      //           _.forEach(arrDataSixty, (item,index)=> {
      //             dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
      //             dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
      //           });
      //         }
      //       });
      //     }else{
      //       let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
      //         if(arrDataThirty.length > 0){
      //           _.forEach(arrDataThirty, (item,index)=> {
      //             dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
      //             dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
      //           });
      //         }
      //         let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
      //         if(arrDataSixty.length > 0){
      //           _.forEach(arrDataSixty, (item,index)=> {
      //             dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
      //             dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
      //           });
      //         }
      //     }
      //     data3['report_daily_boss'] = {
      //       thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
      //       sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
      //     }
      //     data3['report_weekly_boss'] = {
      //       thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
      //       sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
      //     }
      //     data3['feedback'] = {
      //       thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
      //       sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
      //     }
      //     data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
      //     data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
      //     data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
      //     let setResultsData :Array<any> = []
      //     setResultsData['thirty'] = dataThirty
      //     setResultsData['sixty'] = dataSixty
      //     commit('setInsightToday', setResultsData);
      //     resolve(data3);
      //   }else{
      //     firebase.firestore().collection('insight_manager_today').where('company', '==', rootState.authen.user.company).where("date", ">=", format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("date", "<=", format(new Date(), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
      //       querySnapshot.forEach((doc) => {
      //         const data = doc.data()
      //         // sometime data error read > receive
      //         if(data.read > data.receive){
      //           data.read = data.receive
      //         }
      //         if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -60), 'YYYY-MM-DD')&&format(new Date(data.date), 'YYYY-MM-DD')<=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
      //           if (data_2[data.email] === undefined) {
      //             data_2[data.email] = {}
      //           }
      //           data_2[data.email].team = doc.data().team;
      //           if(doc.data().type=="feedback"){
      //             if(data_2[data.email].read_feedback === undefined) data_2[data.email].read_feedback = 0
      //             if(data_2[data.email].receive_feedback === undefined) data_2[data.email].receive_feedback = 0
      //             data_2[data.email].read_feedback += data.read
      //             data_2[data.email].receive_feedback += data.receive
      //           }else if(doc.data().type=="report_daily_boss"){
      //             if(data_2[data.email].read_report_daily_boss === undefined) data_2[data.email].read_report_daily_boss = 0
      //             if(data_2[data.email].receive_report_daily_boss === undefined) data_2[data.email].receive_report_daily_boss = 0
      //             data_2[data.email].read_report_daily_boss += data.read
      //             data_2[data.email].receive_report_daily_boss += data.receive
      //           }else if(doc.data().type=="report_weekly_boss"){
      //             if(data_2[data.email].read_report_weekly_boss === undefined) data_2[data.email].read_report_weekly_boss = 0
      //             if(data_2[data.email].receive_report_weekly_boss === undefined) data_2[data.email].receive_report_weekly_boss = 0
      //             data_2[data.email].read_report_weekly_boss += data.read
      //             data_2[data.email].receive_report_weekly_boss += data.receive
      //           }
      //           if(checkfeedbackSixty[data.email] == undefined){
      //             checkfeedbackSixty[data.email] = new Array()
      //           }
      //           if(data.type && data.type == 'feedback'){
      //             checkfeedbackSixty[data.email].push(data)
      //           }
      //           dataSixty.push(data)
      //         }else if(format(new Date(data.date), 'YYYY-MM-DD') >= format(addDays(new Date(), -30), 'YYYY-MM-DD')){
      //           if(organization1level[data.team]){
      //             if(checkfeedbackThirty[data.email] == undefined){
      //               checkfeedbackThirty[data.email] = new Array()
      //             }
      //             if(data.type && data.type == 'feedback'){
      //               checkfeedbackThirty[data.email].push(data)
      //             }
      //             dataThirty.push(data)
      //           }
      //         }
      //       });


      //       for(const email in data_2){              
      //       let report_daily_boss=0
      //       let feedback=0
      //       let report_weekly_boss=0
      //       if(data_2[email].receive_feedback>0){
      //         feedback = (data_2[email].read_feedback/data_2[email].receive_feedback)*100
      //       }else{
      //         feedback = 100
      //       }
      //       if(data_2[email].receive_report_weekly_boss>0) report_weekly_boss = (data_2[email].read_report_weekly_boss/data_2[email].receive_report_weekly_boss)*100;
      //       if(data_2[email].receive_report_daily_boss>0)  report_daily_boss = (data_2[email].read_report_daily_boss/data_2[email].receive_report_daily_boss)*100;
      //       if(report_daily_boss > 100 ) report_daily_boss = 100;
      //       if(report_weekly_boss > 100 ) report_weekly_boss = 100;
      //       if(feedback > 100 ) feedback = 100;
      //       let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
      //       let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
      //       let open_rate = ((dailyData * 5 + weeklyData))/6

      //       data_2[email].open_rate = open_rate
      //       if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
      //         _countAct += 1
      //       }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
      //         _countPas += 1
      //       }else{
      //         _countInact += 1
      //       }
      //       }
    
      //       if(teamOneLevel){
      //         _.forEach(teamOneLevel.parent, (value,key)=> {
      //           let teamId:any = key
      //           let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
      //           if(arrDataThirty.length > 0){
      //             _.forEach(arrDataThirty, (item,index)=> {
      //               dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
      //               dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
      //             });
      //           }
      //           let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
      //           if(arrDataSixty.length > 0){
      //             _.forEach(arrDataSixty, (item,index)=> {
      //               dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
      //               dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
      //             });
      //           }
      //         });
      //       }else{
      //         let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
      //           if(arrDataThirty.length > 0){
      //             _.forEach(arrDataThirty, (item,index)=> {
      //               dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
      //               dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
      //             });
      //           }
      //           let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
      //           if(arrDataSixty.length > 0){
      //             _.forEach(arrDataSixty, (item,index)=> {
      //               dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
      //               dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
      //             });
      //           }
      //       }
      //       data3['report_daily_boss'] = {
      //         thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
      //         sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
      //       }
      //       data3['report_weekly_boss'] = {
      //         thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
      //         sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
      //       }
      //       data3['feedback'] = {
      //         thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
      //         sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
      //       }
      //       data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
      //       data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
      //       data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
      //       let setResultsData :Array<any> = []
      //       setResultsData['thirty'] = dataThirty
      //       setResultsData['sixty'] = dataSixty
            
      //       commit("setPastActivity",data_2)
      //       commit('setInsightToday', setResultsData);
      //       resolve(data3);
      //     });
      //   }
      // });
      var pormise_1=new Promise(async function(resolve, reject){
        const data3:Array<any> = []
        const data2:Array<any> = []
        const data_2:Array<any> = []
        let dataThirty :Array<any> = []
        let dataSixty :Array<any> = []
        let dataAllTeamThirty :Array<any> = []
        let checkfeedbackThirty :Array<any> = []
        let checkfeedbackSixty :Array<any> = []
        dataAllTeamThirty['report_daily_boss'] = new Array()
        dataAllTeamThirty['report_weekly_boss'] = new Array()
        dataAllTeamThirty['feedback'] = new Array()
        dataAllTeamThirty['report_daily_boss'] = new Array()
        dataAllTeamThirty['report_weekly_boss'] = new Array()
        dataAllTeamThirty['feedback'] = new Array()

        let dataAllTeamSixty :Array<any> = []
        dataAllTeamSixty['report_daily_boss'] = new Array()
        dataAllTeamSixty['report_weekly_boss'] = new Array()
        dataAllTeamSixty['feedback'] = new Array()
        dataAllTeamSixty['report_daily_boss'] = new Array()
        dataAllTeamSixty['report_weekly_boss'] = new Array()
        dataAllTeamSixty['feedback'] = new Array()
        let sixtyDate = format(addDays(new Date(), -60), 'YYYY-MM-DD')
        let thirtyDate = format(addDays(new Date(), -30), 'YYYY-MM-DD')
        // if(state.teamHeight !== selectTeam){
        //   for(const email in state.pastActivity){
             
        //       let report_daily_boss=0
        //       let feedback=0
        //       let report_weekly_boss=0
        //       if(teamOneLevel){
        //         _.forEach(teamOneLevel.parent, (value,key)=> {
        //           if(state.pastActivity[email].team==key){
        //             if(state.pastActivity[email].receive_feedback>0){
        //               feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
        //             }else{
        //               feedback = 100
        //             }
        //             if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
        //             if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
        //             if(report_daily_boss > 100 ) report_daily_boss = 100;
        //             if(report_weekly_boss > 100 ) report_weekly_boss = 100;
        //             if(feedback > 100 ) feedback = 100;
        //             let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
        //             let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
        //             let open_rate = ((dailyData * 5 + weeklyData))/6
        //             state.pastActivity[email].open_rate = open_rate
        //             if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
        //               // if(data2[email].feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
        //               //   _countPas += 1
        //               // }else{
        //               //   _countAct += 1
        //               // }
        //             }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
        //               _countPas += 1
        //             }else{
        //               _countInact += 1
        //             }
        //           }
        //         })
  
        //       }else{
        //           let _feedback=''
        //           if(state.pastActivity[email].team===selectTeam){
  
        //             if(state.pastActivity[email].receive_feedback>0){
        //               feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
        //             }else{
        //               feedback = 100
        //               _feedback='-'
        //             }
        //             if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
        //             if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
        //             if(report_daily_boss > 100 ) report_daily_boss = 100;
        //             if(report_weekly_boss > 100 ) report_weekly_boss = 100;
        //             if(feedback > 100 ) feedback = 100;
        //             let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
        //             let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
        //             let open_rate = ((dailyData * 5 + weeklyData))/6
        //             state.pastActivity[email].open_rate = open_rate
        //             if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
        //               if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
        //                 _countPas += 1
        //               }else{
        //                 _countAct += 1
        //               }
        //             }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
        //               _countPas += 1
        //             }else{
        //               _countInact += 1
        //             }
        //           }
  
                
  
  
        //       }
              
  
        //   }
        // }else{
        //     if(state.pastActivity){
        //       for(const email in state.pastActivity){
           
        //         let report_daily_boss=0
        //         let feedback=0
        //         let report_weekly_boss=0
        //         if(teamOneLevel){
        //           _.forEach(teamOneLevel.parent, (value,key)=> {
        //             let _feedback=''
        //             if(state.pastActivity[email].team==key){
        //               if(state.pastActivity[email].receive_feedback>0){
        //                 feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
        //               }else{
        //                 feedback = 100
        //                 _feedback='-'
        //               }
        //               if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
        //               if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
        //               if(report_daily_boss > 100 ) report_daily_boss = 100;
        //               if(report_weekly_boss > 100 ) report_weekly_boss = 100;
        //               if(feedback > 100 ) feedback = 100;
        //               let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
        //               let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
        //               let open_rate = ((dailyData * 5 + weeklyData))/6
        //               state.pastActivity[email].open_rate = open_rate
        //               if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
        //                 if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
        //                   _countPas += 1
        //                 }else{
        //                   _countAct += 1
        //                 }
        //               }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
        //                 _countPas += 1
        //               }else{
        //                 _countInact += 1
        //               }
        //             }
        //           })
  
        //         }else{
        //             let _feedback=''
        //             if(state.pastActivity[email].team==selectTeam){
        //               if(state.pastActivity[email].receive_feedback>0){
        //                 feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
        //               }else{
        //                 feedback = 100
        //                 _feedback='-'
        //               }
        //               if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
        //               if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
        //               if(report_daily_boss > 100 ) report_daily_boss = 100;
        //               if(report_weekly_boss > 100 ) report_weekly_boss = 100;
        //               if(feedback > 100 ) feedback = 100;
        //               let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
        //               let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
        //               let open_rate = ((dailyData * 5 + weeklyData))/6
        //               state.pastActivity[email].open_rate = open_rate
        //               if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
        //                 if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
        //                   _countPas += 1
        //                 }else{
        //                   _countAct += 1
        //                 }
        //               }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
        //                 _countPas += 1
        //               }else{
        //                 _countInact += 1
        //               }
        //             }
  
                  
  
  
        //         }
                
  
        //       }
  
                          
        //     }
        // }
        if(state.teamHeight !== selectTeam){
         //console.log('eee')
        for(const email in state.pastActivity){
          //console.log('oooo')
            let report_daily_boss=0
            let feedback=0
            let report_weekly_boss=0
            
            if(teamOneLevel){
              //console.log('teamOneLevel',teamOneLevel)
              _.forEach(teamOneLevel.parent, (value,key)=> {
                //console.log('eeeeessssss---',state.pastActivity[email].team)
                if(state.pastActivity[email].team==key){
                  //console.log('eeeeessssss')
                  let _feedback=''
                  if(state.pastActivity[email].receive_feedback>0){
                    feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
                  }else{
                    feedback = 100
                    _feedback='-'
                  }
                  if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
                  if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
                  if(report_daily_boss > 100 ) report_daily_boss = 100;
                  if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                  if(feedback > 100 ) feedback = 100;
                  let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                  let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                  let open_rate = ((dailyData * 5 + weeklyData))/6
                  state.pastActivity[email].open_rate = open_rate
                  //console.log('state.pastActivity[email].status',state.pastActivity[email].status)
                  if(state.pastActivity[email].status=='inactive'){_countInact += 1}
                  else{

                    if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                      if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                        _countPas += 1
                      }else{
                        _countAct += 1
                      }
                    }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                      _countPas += 1
                    }else{
                      _countInact += 1
                    }

                  }
                
                }
              })

            }else{
                let _feedback=''
                if(state.pastActivity[email].team===selectTeam){

                  if(state.pastActivity[email].receive_feedback>0){
                    feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
                  }else{
                    feedback = 100
                    _feedback='-'
                  }
                  if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
                  if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
                  if(report_daily_boss > 100 ) report_daily_boss = 100;
                  if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                  if(feedback > 100 ) feedback = 100;
                  let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                  let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                  let open_rate = ((dailyData * 5 + weeklyData))/6
                  state.pastActivity[email].open_rate = open_rate
                  if(state.pastActivity[email].status=='inactive'){
                    _countInact+=1

                  }else{

                    if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                      if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                        _countPas += 1
                      }else{
                        _countAct += 1
                      }
                    }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                      _countPas += 1
                    }else{
                      _countInact += 1
                    }

                  }
                  
                }

              


            }
            

        }
        }else{
          if(state.pastActivity){
            for(const email in state.pastActivity){
              
              let _feedback=''
              let report_daily_boss=0
              let feedback=0
              let report_weekly_boss=0

              //console.log('state.pastActivity',teamOneLevel.parent)
            
              if(teamOneLevel){
                if(teamOneLevel.parent[state.pastActivity[email].team]){
                  if(state.pastActivity[email].receive_feedback>0){
                    feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
                  }else{
                    feedback = 100
                    _feedback='-'
                  }
                  if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
                  if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
                  if(report_daily_boss > 100 ) report_daily_boss = 100;
                  if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                  if(feedback > 100 ) feedback = 100;
                  let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                  let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                  let open_rate = ((dailyData * 5 + weeklyData))/6
                  state.pastActivity[email].open_rate = open_rate
                  if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                    if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                      _countPas += 1
                    }else{
                      _countAct += 1
                    }
                  }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                    _countPas += 1
                  }else{
                    _countInact += 1
                  }
                }else{
                  //console.log('state.pastActivity=====',email)
                }

              }else{
                let _feedback=''
                  if(state.pastActivity[email].team==selectTeam){
                    if(state.pastActivity[email].receive_feedback>0){
                      feedback = (state.pastActivity[email].read_feedback/state.pastActivity[email].receive_feedback)*100
                    }else{
                      feedback = 100
                      _feedback='-'
                    }
                    
                    if(state.pastActivity[email].receive_report_weekly_boss>0) report_weekly_boss = (state.pastActivity[email].read_report_weekly_boss/state.pastActivity[email].receive_report_weekly_boss)*100;
                    if(state.pastActivity[email].receive_report_daily_boss>0)  report_daily_boss = (state.pastActivity[email].read_report_daily_boss/state.pastActivity[email].receive_report_daily_boss)*100;
                    if(report_daily_boss > 100 ) report_daily_boss = 100;
                    if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                    if(feedback > 100 ) feedback = 100;
                    let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                    let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                    let open_rate = ((dailyData * 5 + weeklyData))/6
                    state.pastActivity[email].open_rate = open_rate
                    if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                      if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                        _countPas += 1
                      }else{
                        _countAct += 1
                      }
                    }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                      _countPas += 1
                    }else{
                      _countInact += 1
                    }
                  }

                


              }
              

            }

                        
          }
        }

        if(state.insightToday && state.insightToday.thirty){
          dataThirty = state.insightToday.thirty
          dataSixty = state.insightToday.sixty

        if(teamOneLevel){
            _.forEach(teamOneLevel.parent, (value,key)=> {
              let teamId:any = key
              let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
              if(arrDataThirty.length > 0){
                _.forEach(arrDataThirty, (item,index)=> {
                  dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                  dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  const data=item
                    if (data2[data.email] === undefined) {
                      data2[data.email] = {}
                    }
                    data2[data.email].team = data.team;
                    // sometime data error read > receive
                    if(data.read > data.receive){
                      data.read = data.receive
                    }
                    if(data.type=="feedback"){
                      if(data2[data.email].read_feedback === undefined) data2[data.email].read_feedback = 0
                      if(data2[data.email].receive_feedback === undefined) data2[data.email].receive_feedback = 0
                      data2[data.email].read_feedback += data.read
                      data2[data.email].receive_feedback += data.receive
                    }else if(data.type=="report_daily_boss"){
                      if(data2[data.email].read_report_daily_boss === undefined) data2[data.email].read_report_daily_boss = 0
                      if(data2[data.email].receive_report_daily_boss === undefined) data2[data.email].receive_report_daily_boss = 0
                      data2[data.email].read_report_daily_boss += data.read
                      data2[data.email].receive_report_daily_boss += data.receive
                    }else if(data.type=="report_weekly_boss"){
                      if(data2[data.email].read_report_weekly_boss === undefined) data2[data.email].read_report_weekly_boss = 0
                      if(data2[data.email].receive_report_weekly_boss === undefined) data2[data.email].receive_report_weekly_boss = 0
                      data2[data.email].read_report_weekly_boss += data.read
                      data2[data.email].receive_report_weekly_boss += data.receive
                    }
                
                });
              }
              let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
              if(arrDataSixty.length > 0){
                _.forEach(arrDataSixty, (item,index)=> {
                  dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                  dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                });
              }
            });
          }else{
            let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
              if(arrDataThirty.length > 0){
                _.forEach(arrDataThirty, (item,index)=> {
                  dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                  dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  const data=item
                    if (data2[data.email] === undefined) {
                      data2[data.email] = {}
                    }
                    data2[data.email].team = data.team;
                    // sometime data error read > receive
                    if(data.read > data.receive){
                      data.read = data.receive
                    }
                    if(data.type=="feedback"){
                      if(data2[data.email].read_feedback === undefined) data2[data.email].read_feedback = 0
                      if(data2[data.email].receive_feedback === undefined) data2[data.email].receive_feedback = 0
                      data2[data.email].read_feedback += data.read
                      data2[data.email].receive_feedback += data.receive
                    }else if(data.type=="report_daily_boss"){
                      if(data2[data.email].read_report_daily_boss === undefined) data2[data.email].read_report_daily_boss = 0
                      if(data2[data.email].receive_report_daily_boss === undefined) data2[data.email].receive_report_daily_boss = 0
                      data2[data.email].read_report_daily_boss += data.read
                      data2[data.email].receive_report_daily_boss += data.receive
                    }else if(data.type=="report_weekly_boss"){
                      if(data2[data.email].read_report_weekly_boss === undefined) data2[data.email].read_report_weekly_boss = 0
                      if(data2[data.email].receive_report_weekly_boss === undefined) data2[data.email].receive_report_weekly_boss = 0
                      data2[data.email].read_report_weekly_boss += data.read
                      data2[data.email].receive_report_weekly_boss += data.receive
                    }
                  
                });
              }
              let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
              if(arrDataSixty.length > 0){
                _.forEach(arrDataSixty, (item,index)=> {
                  dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                  dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                });
              }
          }
          data3['report_daily_boss'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
          }
          data3['report_weekly_boss'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
          }
          data3['feedback'] = {
            thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
            sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
          }
          data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
          data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
          data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
          let setResultsData :Array<any> = []
          setResultsData['thirty'] = dataThirty
          setResultsData['sixty'] = dataSixty
          commit('setInsightToday', setResultsData);

          for(const email in data2){
            let report_daily_boss=0
            let feedback=0
            let report_weekly_boss=0
              if(data2[email]){
                if(data2[email].receive_feedback>0){
                  feedback = (data2[email].read_feedback/data2[email].receive_feedback)*100
                  if(feedback > 100 ) feedback = 100;
                  data2[email].feedback = (feedback) ? Math.round(feedback) : 0
                }else{
                  feedback = 100
                  data2[email].feedback = '-'
                }
                
              
                if(data2[email].receive_report_weekly_boss>0) report_weekly_boss = (data2[email].read_report_weekly_boss/data2[email].receive_report_weekly_boss)*100;
                if(data2[email].receive_report_daily_boss>0)  report_daily_boss = (data2[email].read_report_daily_boss/data2[email].receive_report_daily_boss)*100;
                if(report_daily_boss > 100 ) report_daily_boss = 100;
                if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                let open_rate = ((dailyData * 5 + weeklyData))/6
                data2[email].open_rate = open_rate
                if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                  if(data2[email].feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                    data2[email].passive = 'Y'
                    data2[email].status = 'passive'
                    countPas += 1
                  }else{
                    data2[email].active = 'Y'
                    data2[email].status = 'active'
                    countAct += 1
                  }
                  
                }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                  data2[email].passive = 'Y'
                  data2[email].status = 'passive'
                  countPas += 1
                }else{
                  data2[email].inactive = 'Y'
                  data2[email].status = 'inactive'
                  countInact += 1
                }
                data2[email].daily = (report_daily_boss) ? Math.round(report_daily_boss) : 0
                data2[email].weekly = (report_weekly_boss) ? Math.round(report_weekly_boss) : 0
                
                data2[email].open_rate = open_rate
                if(open_rate >= act_open_rate){
                  data2[email].insights_opened_check = 'Y'
                }else{
                  data2[email].insights_opened_check = 'N'
                }
                if(feedback >= act_feedback_rate){
                  data2[email].feedback_check = 'Y'
                }else{
                  data2[email].feedback_check = 'N'
                }
              }
          }
          resolve({data3:data3,data2:data2});
        }else{
          firebase.firestore().collection('insight_manager_today').where('company', '==', rootState.authen.user.company).where("date", ">=", format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("date", "<=", format(new Date(), 'YYYY-MM-DD')).orderBy('date').get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              // sometime data error read > receive
              if(data.read > data.receive){
                data.read = data.receive
              }
              const emailKey=data.email.replace(/\./g, '||')
              
              if(allUser[emailKey]&&!allUser[emailKey].placeholder){
                
                if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -60), 'YYYY-MM-DD')&&format(new Date(data.date), 'YYYY-MM-DD')<=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
                  if (data_2[data.email] === undefined) {
                    data_2[data.email] = {}
                  }
                  data_2[data.email].team = doc.data().team;
                  if(doc.data().type=="feedback"){
                    if(data_2[data.email].read_feedback === undefined) data_2[data.email].read_feedback = 0
                    if(data_2[data.email].receive_feedback === undefined) data_2[data.email].receive_feedback = 0
                    data_2[data.email].read_feedback += data.read
                    data_2[data.email].receive_feedback += data.receive
                  }else if(doc.data().type=="report_daily_boss"){
                    if(data_2[data.email].read_report_daily_boss === undefined) data_2[data.email].read_report_daily_boss = 0
                    if(data_2[data.email].receive_report_daily_boss === undefined) data_2[data.email].receive_report_daily_boss = 0
                    data_2[data.email].read_report_daily_boss += data.read
                    data_2[data.email].receive_report_daily_boss += data.receive
                  }else if(doc.data().type=="report_weekly_boss"){
                    if(data_2[data.email].read_report_weekly_boss === undefined) data_2[data.email].read_report_weekly_boss = 0
                    if(data_2[data.email].receive_report_weekly_boss === undefined) data_2[data.email].receive_report_weekly_boss = 0
                    data_2[data.email].read_report_weekly_boss += data.read
                    data_2[data.email].receive_report_weekly_boss += data.receive
                  }
                  if(checkfeedbackSixty[data.email] == undefined){
                    checkfeedbackSixty[data.email] = new Array()
                  }
                  if(data.type && data.type == 'feedback'){
                    checkfeedbackSixty[data.email].push(data)
                  }
                  dataSixty.push(data)
                }
                if(format(new Date(data.date), 'YYYY-MM-DD') >= format(addDays(new Date(), -30), 'YYYY-MM-DD')){
                  
                  if(organization1level[data.team]){
                    if(checkfeedbackThirty[data.email] == undefined){
                      checkfeedbackThirty[data.email] = new Array()
                    }
                    if(data.type && data.type == 'feedback'){
                      checkfeedbackThirty[data.email].push(data)
                    }
                    dataThirty.push(data)
                  }
                  if(organization1level[data.team]){
                    if (data2[data.email] === undefined) {
                      data2[data.email] = {}
                    }
                    data2[data.email].team = doc.data().team;
                    // sometime data error read > receive
                    if(data.read > data.receive){
                      data.read = data.receive
                    }
                    if(doc.data().type=="feedback"){
                      if(data2[data.email].read_feedback === undefined) data2[data.email].read_feedback = 0
                      if(data2[data.email].receive_feedback === undefined) data2[data.email].receive_feedback = 0
                      data2[data.email].read_feedback += data.read
                      data2[data.email].receive_feedback += data.receive
                    }else if(doc.data().type=="report_daily_boss"){
                      if(data2[data.email].read_report_daily_boss === undefined) data2[data.email].read_report_daily_boss = 0
                      if(data2[data.email].receive_report_daily_boss === undefined) data2[data.email].receive_report_daily_boss = 0
                      data2[data.email].read_report_daily_boss += data.read
                      data2[data.email].receive_report_daily_boss += data.receive
                    }else if(doc.data().type=="report_weekly_boss"){
                      if(data2[data.email].read_report_weekly_boss === undefined) data2[data.email].read_report_weekly_boss = 0
                      if(data2[data.email].receive_report_weekly_boss === undefined) data2[data.email].receive_report_weekly_boss = 0
                      data2[data.email].read_report_weekly_boss += data.read
                      data2[data.email].receive_report_weekly_boss += data.receive
                    }
                  }
  
                }

              }
            });

            for(const email in data2){
              
              let report_daily_boss=0
              let feedback=0
              let report_weekly_boss=0
                if(data2[email]){
                  
                  if(data2[email].receive_feedback>0){
                    feedback = (data2[email].read_feedback/data2[email].receive_feedback)*100
                    if(feedback > 100 ) feedback = 100;
                    data2[email].feedback = (feedback) ? Math.round(feedback) : 0
                  }else{
                    feedback = 100
                    data2[email].feedback = '-'
                  }
                  // if(email=='mbr@pandora.net'){
                  //   console.log('data2[email]',data2[email])
                  // }
                
                  if(data2[email].receive_report_weekly_boss>0) report_weekly_boss = (data2[email].read_report_weekly_boss/data2[email].receive_report_weekly_boss)*100;
                  if(data2[email].receive_report_daily_boss>0)  report_daily_boss = (data2[email].read_report_daily_boss/data2[email].receive_report_daily_boss)*100;
                  if(report_daily_boss > 100 ) report_daily_boss = 100;
                  if(report_weekly_boss > 100 ) report_weekly_boss = 100;
                  let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
                  let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
                  let open_rate = ((dailyData * 5 + weeklyData))/6
                  data2[email].open_rate = open_rate
                  if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
                    if(data2[email].feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                      data2[email].passive = 'Y'
                      data2[email].status = 'passive'
                      countPas += 1
                    }else{
                      data2[email].active = 'Y'
                      data2[email].status = 'active'
                      countAct += 1
                    }
                  }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
                    data2[email].passive = 'Y'
                    data2[email].status = 'passive'
                    countPas += 1
                  }else{
                    data2[email].inactive = 'Y'
                    data2[email].status = 'inactive'
                    countInact += 1

                  }
                  data2[email].daily = (report_daily_boss) ? Math.round(report_daily_boss) : 0
                  data2[email].weekly = (report_weekly_boss) ? Math.round(report_weekly_boss) : 0
                  
                  data2[email].open_rate = open_rate
                  if(open_rate >= act_open_rate){
                    data2[email].insights_opened_check = 'Y'
                  }else{
                    data2[email].insights_opened_check = 'N'
                  }
                  if(feedback >= act_feedback_rate){
                    data2[email].feedback_check = 'Y'
                  }else{
                    data2[email].feedback_check = 'N'
                  }
                }
            }

            for(const i in boss){

              if(data_2[boss[i].email]){
                const email = boss[i].email
                let report_daily_boss=0
            let feedback=0
            let report_weekly_boss=0
            let _feedback=''
            if(data_2[email].receive_feedback>0){
              feedback = (data_2[email].read_feedback/data_2[email].receive_feedback)*100
            }else{
              feedback = 100
              _feedback='-'
            }
            if(data_2[email].receive_report_weekly_boss>0) report_weekly_boss = (data_2[email].read_report_weekly_boss/data_2[email].receive_report_weekly_boss)*100;
            if(data_2[email].receive_report_daily_boss>0)  report_daily_boss = (data_2[email].read_report_daily_boss/data_2[email].receive_report_daily_boss)*100;
            if(report_daily_boss > 100 ) report_daily_boss = 100;
            if(report_weekly_boss > 100 ) report_weekly_boss = 100;
            if(feedback > 100 ) feedback = 100;
            let dailyData = report_daily_boss? Math.round(report_daily_boss) : 0 
            let weeklyData = report_weekly_boss?Math.round(report_weekly_boss) : 0;
            let open_rate = ((dailyData * 5 + weeklyData))/6

            data_2[email].open_rate = open_rate
            if(open_rate >= act_open_rate && Math.round(feedback) >= act_feedback_rate){
              if(_feedback == '-'&&act_open_rate==0&&pass_open_rate==0){
                _countPas += 1
              }else{
                _countAct += 1
              }
             
            }else if(open_rate >= pass_open_rate && Math.round(feedback) >= pass_feedback_rate){
              _countPas += 1
            }else{
              _countInact += 1
            }




              }else{
                const email = boss[i].email
                
                if(!data_2[email]){
                  data_2[email]={team:boss[i].team}
                }
                data_2[email].read_feedback=-1
                data_2[email].receive_feedback=-1
                data_2[email].read_report_daily_boss=-1
                data_2[email].receive_report_daily_boss=-1
                data_2[email].read_report_weekly_boss=-1
                data_2[email].receive_report_weekly_boss=-1
                data_2[email].status='inactive'
                
                _countInact++
              }

            }


   
            if(teamOneLevel){
              _.forEach(teamOneLevel.parent, (value,key)=> {
                let teamId:any = key
                let arrDataThirty:any = _.filter(dataThirty, { team: teamId });
                if(arrDataThirty.length > 0){
                  _.forEach(arrDataThirty, (item,index)=> {
                    dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                    dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  });
                }
                let arrDataSixty:any = _.filter(dataSixty, { team: teamId });
                if(arrDataSixty.length > 0){
                  _.forEach(arrDataSixty, (item,index)=> {
                    dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                    dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                  });
                }
              });
            }else{
              let arrDataThirty:any = _.filter(dataThirty, { team: selectTeam });
                if(arrDataThirty.length > 0){
                  _.forEach(arrDataThirty, (item,index)=> {
                    dataAllTeamThirty[item.type].read = dataAllTeamThirty[item.type].read ? dataAllTeamThirty[item.type].read + item.read : item.read
                    dataAllTeamThirty[item.type].receive = dataAllTeamThirty[item.type].receive ? dataAllTeamThirty[item.type].receive + item.receive : item.receive
                  });
                }
                let arrDataSixty:any = _.filter(dataSixty, { team: selectTeam });
                if(arrDataSixty.length > 0){
                  _.forEach(arrDataSixty, (item,index)=> {
                    dataAllTeamSixty[item.type].read = dataAllTeamSixty[item.type].read ? dataAllTeamSixty[item.type].read + item.read : item.read
                    dataAllTeamSixty[item.type].receive = dataAllTeamSixty[item.type].receive ? dataAllTeamSixty[item.type].receive + item.receive : item.receive
                  });
                }
            }
            data3['report_daily_boss'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_daily_boss'].read * 100 / dataAllTeamThirty['report_daily_boss'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_daily_boss'].read * 100 / dataAllTeamSixty['report_daily_boss'].receive)),
            }
            data3['report_weekly_boss'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['report_weekly_boss'].read * 100 / dataAllTeamThirty['report_weekly_boss'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['report_weekly_boss'].read * 100 / dataAllTeamSixty['report_weekly_boss'].receive)),
            }
            data3['feedback'] = {
              thirty: (isNaN(Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamThirty['feedback'].read * 100 / dataAllTeamThirty['feedback'].receive)),
              sixty: (isNaN(Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) ? 0 : ((Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)) > 100) ? 100 : Math.round(dataAllTeamSixty['feedback'].read * 100 / dataAllTeamSixty['feedback'].receive)),
            }
            data3['report_daily_boss'].compare = data3['report_daily_boss'].thirty - data3['report_daily_boss'].sixty
            data3['report_weekly_boss'].compare = data3['report_weekly_boss'].thirty - data3['report_weekly_boss'].sixty
            data3['feedback'].compare = data3['feedback'].thirty - data3['feedback'].sixty
            let setResultsData :Array<any> = []
            setResultsData['thirty'] = dataThirty
            setResultsData['sixty'] = dataSixty
            

            commit("setPastActivity",data_2)
            commit('setInsightToday', setResultsData);
            
            resolve({data3:data3,data2:data2});
          });
        }

      })
      var promise4 = new Promise(async function(resolve, reject) {
        const data4:Array<any> = []
        firebase.firestore().collection('coachinglatest').where("company", "==", rootState.authen.user.company).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            if (data4[data.email] === undefined) {
              data4[data.email] = new Array()
            }
            const _temp = {};
            _temp['date'] = format(data.date, "MMMM D, YYYY")
            _temp['challenges'] = "Boost "+data.quest_type
            if(data.standard){
              _temp['standard'] = data.standard
            }else{
              // set standard for old data
              if(data.quest_type == 'Recognition'){
                _temp['standard'] = [75,50,50]
              }else if(data.quest_type == 'Personal Growth'){
                if(data.quest_follow_id && data.quest_follow_id == '-L0J42xtbRWVbsHdFWWR'){
                  _temp['standard'] = [70,40,40]
                }else{
                  _temp['standard'] = [80,50,50]
                }
              }else if(data.quest_type == 'Feedback'){
                _temp['standard'] = [80,60,60]
              }
            }
            if(data.status == 'open'){
              _temp['score'] = data.previous
              _temp['status'] = 'Pending'
            }else if(data.status == 'accept'){
              _temp['score'] = data.previous
              _temp['status'] = 'Active'
            }else if(data.status == 'congrat'){
              _temp['score'] = data.goal ? data.goal : data.previous
              _temp['status'] = 'Completed'
            }else if(data.status == 'tryagain'){
              _temp['score'] = data.notgoal ? data.notgoal : data.previous
              _temp['status'] = 'Try Again'
            }else if(data.status == 'close'){
              _temp['score'] = data.previous
              _temp['status'] = 'Close'
            }
            _temp['score'] = Math.round(Number(_temp['score'])) > 100 ? 100 : Math.round(Number(_temp['score']))
            data4[data.email] = _temp
          });

          resolve(data4);
        });
      });
      var promise6 = new Promise(async function(resolve, reject) {
        const data6:Array<any> = []
        const data1:Array<any> = []
        let count=0
        let _count=0
        const _data:any=[]
        firebase.firestore().collection('here_point').where("company", "==", rootState.authen.user.company).where("date",">=",format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("type","==","gem").where("statusrow" ,"==", "sendgem").get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            _data.push(data)
            if(data.date>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
              if(data.type=="gem"){
                if (data6[data.sender_email] === undefined) {
                  data6[data.sender_email] = {}
                }
                data6[data.sender_email]=data
              }
            }else{
              if(data.type=="gem"){
                if (data1[data.sender_email] === undefined) {
                  data1[data.sender_email] = {}
                }
                data1[data.sender_email]=data
              }
            }

          });
          for(const v in boss){
            if(data6[boss[v].email]){
              count++
            }
            if(data1[boss[v].email]){
              _count++
            }
          }
          
          let topPerformerRecognition=isNaN(count*100/boss.length)?0:Math.round(count*100/boss.length)
          let _topPerformerRecognition=isNaN(_count*100/boss.length)?0:Math.round(_count*100/boss.length)
          let compare=isNaN(((topPerformerRecognition - _topPerformerRecognition)))?0:Math.round(((topPerformerRecognition - _topPerformerRecognition)))
        //  console.log("promise6")
          resolve({topPerformerRecognition:topPerformerRecognition,compareTopPerformerRecognition:compare});
        });
      });
      var promise7 = new Promise(async function(resolve, reject) {
        const dataAll:any=[]
        const past7month=format(addMonths(new Date(),-7), 'YYYY-MM')
        const reviewActivity={completed:0,pending:0,overdue:0,total:0}
     
        if(state.teamHeight!=selectTeam){
          const  receiver=state.receive
          const _boss=_.filter(boss, { team: selectTeam });
       
          for(const i in organization1level){
            const user=_.filter(allUser, { team: i });
            for(const emailKey in user){
              if(receiver[user[emailKey].email]){
                reviewActivity.total++
                if(_boss.length>0&&_boss[0].email!==user[emailKey].email){
                  const newData =_.orderBy(receiver[user[emailKey].email], function(dateObj) {
                    return new Date(dateObj.createdate);
                  },['desc'])
                  if(newData){
                    
                    const lastData = newData[0]
                    const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                    const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                  if(moment(lastData.createdate).isAfter(moment().add(-time_peding,'months'))){
                    
                    reviewActivity.completed++  
                    }
                  }

                }
              }
            }
          }
          resolve(reviewActivity)
        }else{
          firebase.firestore().collection('send_review_gem').where("company", "==", rootState.authen.user.company).where('createdate','>=',`${past7month}-01`).get()
          .then(function (querySnapshot) {
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              dataAll.push(data)
            })
            
            const  receiver = _.groupBy(dataAll, function (b) {
              return b.receiver;
            })
            state.receive=receiver
            for(const emailKey in allUser){
              reviewActivity.total++
              if(receiver[allUser[emailKey].email]){
                const newData =_.orderBy(receiver[allUser[emailKey].email], function(dateObj) {
                  return new Date(dateObj.createdate);
                },['desc'])
                if(newData){
                  const lastData = newData[0]
                  const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                  const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                if(moment(lastData.createdate).isAfter(moment().add(-time_peding,'months'))){
                  reviewActivity.completed++  
                  }
                }
              }
            }
          
            resolve(reviewActivity)
          })

        }
        
      })
      // var promise8 = new Promise(async function(resolve, reject) {
      //   const dataAll:any=[]
      //   const lastDays=format(addDays(new Date(),-1), 'YYYY-MM-DD')
      //   const company = await getCompany(rootState.authen.user.company)
     
      //   if(state.teamHeight!=selectTeam){
          
      //     resolve(state.proactivityAll[selectTeam])
      //   }else{
      //     firebase.firestore().collection('proactivity_psychological_rating').where("company", "==", rootState.authen.user.company).where('date','==',lastDays).get()
      //     .then(function (querySnapshot) {
      //       querySnapshot.forEach((doc) => {
      //         const data = doc.data()
      //         if(!dataAll[data.team_id]){
      //           dataAll[data.team_id]=data
      //         }

      //       })
            
      //       state.proactivityAll=dataAll
        
      //       resolve(dataAll[state.teamHeight])
          
      //     })

      //   }
        
      // })
  
      Promise.all([promise1, promise4,pormise_1,promise6,promise7]).then((values)=> {
        const data1:any = values[0]
        const data4:any = values[1]
        const data_3:any = values[2]
        const data3= data_3.data3
        const objData:any = data_3.data2
        const data6:any = values[3]
        const data7:any = values[4]
        //const data8:any = values[5]
       // const data7:any = values[4]
        const directReportByKey:any = _.groupBy(allUser, 'boss')
        //console.log('directReportByKey',directReportByKey)
       const review=isNaN(((data7.completed / data7.total) * 100))?0:((data7.completed / data7.total) * 100).toFixed();

    
       for (const i in boss) {
        if (objData[boss[i].email]) {
          const index=boss[i].email
          if(state.memberKey[index]){
            let item = state.memberKey[index]
            //console.log('item',item)
            objData[index].firstname = item.firstname
            objData[index].lastname = item.lastname
            objData[index].email = item.email
            objData[index].shortname = item.shortname
            objData[index].fullname = item.fullname
            objData[index].team_id = item.team
            objData[index].team_name = item.team_name
            objData[index].talent = item.talent
            objData[index].network_type = item.network_type
            objData[index].profilepic = item.profilepic
            objData[index].directMember=objData[index].directMember=directReportByKey[item.email]&&Object.keys(directReportByKey[item.email]).length>0?Object.keys(directReportByKey[item.email]).length:0
            objData[index].directReport = state.directReportByKey[item.email] ? state.directReportByKey[item.email].length : 0
            objData[index].score = (data4[index] && data4[index].score >= 0) ? data4[index].score : -1
            objData[index].standard = (data4[index] && data4[index].standard) ? data4[index].standard : []
            countAll++

            if (data1[index]) {
              objData[index].critical_area = Object.keys(data1[index]).toString();
              objData[index].critical_count = Object.keys(data1[index]).length;
            }
            let dailyData = (objData[index].daily) ? objData[index].daily : 0;
            let weeklyData = (objData[index].weekly) ? objData[index].weekly : 0;
            let feedbackData = (objData[index].feedback||objData[index].feedback==0) ? objData[index].feedback : '-'
           // if(data7[index]){
            //  var superfeedbackData = (data7[index].super_feedback) ? data7[index].super_feedback.total : 0
            //}
           
            let activityType = ''
            if(objData[index].active && objData[index].active == 'Y'){
              activityType = 'Active'
            }else if(objData[index].passive && objData[index].passive == 'Y'){
              activityType = 'Passive'
            }else if(objData[index].inactive && objData[index].inactive == 'Y'){
              activityType = 'Inactive'
            }

            listData.push({
              key: item.key,
              company: item.company,
              boss: item.boss,
              introduce: item.introduce,
              large_pic: item.large_pic,
              pic: item.pic,
              statusActive: item.status,
              to_now: item.to_now,
              medal: item.medal,
              coin: item.coin,
              gem: item.gem,
              house: item.house,
              joined: item.joined,
              joined_tooltips: item.joined_tooltips,
              order_join: item.order_join,
              culture_add_percentile: item.culture_add_percentile,
              
              profilepic: objData[index].profilepic,
              firstname: objData[index].firstname,
              lastname: objData[index].lastname,
              email: objData[index].email,
              shortname: objData[index].shortname,
              fullname: objData[index].fullname,
              team_id: objData[index].team_id,
              team_name: objData[index].team_name,
              daily: dailyData,
              weekly: weeklyData,
              feedback: feedbackData,
              overall_rate:isNaN(Math.round(((dailyData * 5 + weeklyData) / 6)))?0:Math.round((dailyData * 5 + weeklyData) / 6),
              //super_feedback: superfeedbackData,
              talent: objData[index].talent,
              active: (objData[index].active && objData[index].active == 'Y') ? "Y" : "N",
              passive: (objData[index].passive && objData[index].passive == 'Y') ? "Y" : "N",
              inactive: (objData[index].inactive && objData[index].inactive == 'Y') ? "Y" : "N",
              critical_area: (objData[index].critical_area) ? objData[index].critical_area : "",
              critical_count: (objData[index].critical_count) ? objData[index].critical_count : "",
              network_type: (objData[index].network_type) ? objData[index].network_type : "",
              directReport: (objData[index].directReport) ? objData[index].directReport : 0,
              x: feedbackData,
              y: objData[index].open_rate,
              open_rate: objData[index].open_rate,
              activity_type: activityType,
              insights_opened_check: (objData[index].insights_opened_check && objData[index].insights_opened_check == 'Y') ? "Y" : "N",
              feedback_check: (objData[index].feedback_check && objData[index].feedback_check == 'Y') ? "Y" : "N",
              standard: objData[index].standard,
              score: objData[index].score,
              status: objData[index].status,
              directMember:objData[index].directMember
            });
          }


        }else{
      
          
          if(organization1level[boss[i].team]){
            let item = state.memberKey[boss[i].email]
            if(item&&!item.placeholder){
              countInact++
              countAll++
            listData.push({
                    key: item.key,
                    company: item.company,
                    boss: item.boss,
                    introduce: item.introduce,
                    large_pic: item.large_pic,
                    pic: item.pic,
                    statusActive: item.status,
                    to_now: item.to_now,
                    medal: item.medal,
                    coin: item.coin,
                    gem: item.gem,
                    house: item.house,
                    joined: item.joined,
                    joined_tooltips: item.joined_tooltips,
                    order_join: item.order_join,
                    culture_add_percentile: item.culture_add_percentile,
                    active:"N",
                    passive:"N",
                    inactive:"Y",
                    profilepic: item.profilepic,
                    firstname: item.firstname,
                    lastname: item.lastname,
                    email: item.email,
                    shortname:item.shortname,
                    fullname: item.fullname,
                    team_id: item.team_id,
                    team_name: item.team_name,
                    feedback:0,
                    open_rate: 0,
                    overall_rate:0

            })
            }
          }

          // listData.push({
          //   key: item.key,
          //   company: item.company,
          //   boss: item.boss,
          //   introduce: item.introduce,
          //   large_pic: item.large_pic,
          //   pic: item.pic,
          //   statusActive: item.status,
          //   to_now: item.to_now,
          //   medal: item.medal,
          //   coin: item.coin,
          //   gem: item.gem,
          //   house: item.house,
          //   joined: item.joined,
          //   joined_tooltips: item.joined_tooltips,
          //   order_join: item.order_join,
          //   culture_add_percentile: item.culture_add_percentile,
            
          //   profilepic: objData[index].profilepic,
          //   firstname: objData[index].firstname,
          //   lastname: objData[index].lastname,
          //   email: objData[index].email,
          //   shortname: objData[index].shortname,
          //   fullname: objData[index].fullname,
          //   team_id: objData[index].team_id,
          //   team_name: objData[index].team_name,
          //   daily: dailyData,
          //   weekly: weeklyData,
          //   feedback: feedbackData,
          //   overall_rate:isNaN(Math.round(((dailyData * 5 + weeklyData) / 6)))?0:Math.round((dailyData * 5 + weeklyData) / 6),
          //   //super_feedback: superfeedbackData,
          //   talent: objData[index].talent,
          //   active: (objData[index].active && objData[index].active == 'Y') ? "Y" : "N",
          //   passive: (objData[index].passive && objData[index].passive == 'Y') ? "Y" : "N",
          //   inactive: (objData[index].inactive && objData[index].inactive == 'Y') ? "Y" : "N",
          //   critical_area: (objData[index].critical_area) ? objData[index].critical_area : "",
          //   critical_count: (objData[index].critical_count) ? objData[index].critical_count : "",
          //   network_type: (objData[index].network_type) ? objData[index].network_type : "",
          //   directReport: (objData[index].directReport) ? objData[index].directReport : 0,
          //   x: feedbackData,
          //   y: objData[index].open_rate,
          //   open_rate: objData[index].open_rate,
          //   activity_type: activityType,
          //   insights_opened_check: (objData[index].insights_opened_check && objData[index].insights_opened_check == 'Y') ? "Y" : "N",
          //   feedback_check: (objData[index].feedback_check && objData[index].feedback_check == 'Y') ? "Y" : "N",
          //   standard: objData[index].standard,
          //   score: objData[index].score,
          //   status: objData[index].status,
          //   directMember:objData[index].directMember
          // });

        }

       }
       //change boss and used boss
       for(const index in objData){
        const checkboss_old=_.find(listData, function (v) {
          return v.email == index
        });
          
          if(state.memberKey[index]&&!checkboss_old){
            let item = state.memberKey[index]
            //console.log('item',item)
            objData[index].firstname = item.firstname
            objData[index].lastname = item.lastname
            objData[index].email = item.email
            objData[index].shortname = item.shortname
            objData[index].fullname = item.fullname
            objData[index].team_id = item.team
            objData[index].team_name = item.team_name
            objData[index].talent = item.talent
            objData[index].network_type = item.network_type
            objData[index].profilepic = item.profilepic
            objData[index].directMember=objData[index].directMember=directReportByKey[item.email]&&Object.keys(directReportByKey[item.email]).length>0?Object.keys(directReportByKey[item.email]).length:0
            objData[index].directReport = state.directReportByKey[item.email] ? state.directReportByKey[item.email].length : 0
            objData[index].score = (data4[index] && data4[index].score >= 0) ? data4[index].score : -1
            objData[index].standard = (data4[index] && data4[index].standard) ? data4[index].standard : []
            countAll++

            if (data1[index]) {
              objData[index].critical_area = Object.keys(data1[index]).toString();
              objData[index].critical_count = Object.keys(data1[index]).length;
            }
            let dailyData = (objData[index].daily) ? objData[index].daily : 0;
            let weeklyData = (objData[index].weekly) ? objData[index].weekly : 0;
            let feedbackData = (objData[index].feedback||objData[index].feedback==0) ? objData[index].feedback : '-'
           // if(data7[index]){
            //  var superfeedbackData = (data7[index].super_feedback) ? data7[index].super_feedback.total : 0
            //}
           
            let activityType = ''
            if(objData[index].active && objData[index].active == 'Y'){
              activityType = 'Active'
            }else if(objData[index].passive && objData[index].passive == 'Y'){
              activityType = 'Passive'
            }else if(objData[index].inactive && objData[index].inactive == 'Y'){
              activityType = 'Inactive'
            }
  
            listData.push({
              key: item.key,
              company: item.company,
              boss: item.boss,
              introduce: item.introduce,
              large_pic: item.large_pic,
              pic: item.pic,
              statusActive: item.status,
              to_now: item.to_now,
              medal: item.medal,
              coin: item.coin,
              gem: item.gem,
              house: item.house,
              joined: item.joined,
              joined_tooltips: item.joined_tooltips,
              order_join: item.order_join,
              culture_add_percentile: item.culture_add_percentile,
              
              profilepic: objData[index].profilepic,
              firstname: objData[index].firstname,
              lastname: objData[index].lastname,
              email: objData[index].email,
              shortname: objData[index].shortname,
              fullname: objData[index].fullname,
              team_id: objData[index].team_id,
              team_name: objData[index].team_name,
              daily: dailyData,
              weekly: weeklyData,
              feedback: feedbackData,
              overall_rate:isNaN(Math.round(((dailyData * 5 + weeklyData) / 6)))?0:Math.round((dailyData * 5 + weeklyData) / 6),
              //super_feedback: superfeedbackData,
              talent: objData[index].talent,
              active: (objData[index].active && objData[index].active == 'Y') ? "Y" : "N",
              passive: (objData[index].passive && objData[index].passive == 'Y') ? "Y" : "N",
              inactive: (objData[index].inactive && objData[index].inactive == 'Y') ? "Y" : "N",
              critical_area: (objData[index].critical_area) ? objData[index].critical_area : "",
              critical_count: (objData[index].critical_count) ? objData[index].critical_count : "",
              network_type: (objData[index].network_type) ? objData[index].network_type : "",
              directReport: (objData[index].directReport) ? objData[index].directReport : 0,
              x: feedbackData,
              y: objData[index].open_rate,
              open_rate: objData[index].open_rate,
              activity_type: activityType,
              insights_opened_check: (objData[index].insights_opened_check && objData[index].insights_opened_check == 'Y') ? "Y" : "N",
              feedback_check: (objData[index].feedback_check && objData[index].feedback_check == 'Y') ? "Y" : "N",
              standard: objData[index].standard,
              score: objData[index].score,
              status: objData[index].status,
              directMember:objData[index].directMember
            });
          }
        }

        
        let compareActive=isNaN(((countAct - _countAct) / _countAct ) * 100)?0:_countAct>0?Math.round(((countAct - _countAct) / _countAct ) * 100):0
        let comparePassive=isNaN(((countPas - _countPas) / _countPas ) * 100)?0:_countPas>0?Math.round(((countPas - _countPas) / _countPas ) * 100):0
        let compareInactive=isNaN(((countInact - _countInact) / _countInact ) * 100)?0:_countInact>0?Math.round(((countInact - _countInact) / _countInact ) * 100):0
        listData = _.orderBy(listData, ['daily','fullname'], ['desc','asc']);
        const overViewData: Array<any> = []
        overViewData['all'] = countAll
        overViewData['active'] = countAct
        overViewData['passive'] = countPas
        overViewData['inactive'] = countInact
        overViewData['compareactive'] = compareActive
        overViewData['comparepassive'] = comparePassive
        overViewData['compareinactive'] = compareInactive
        commit('setInsightsOpenRateSetting', {
          active: act_open_rate,
          passive: pass_open_rate
        });
        
        commit('setFeedbackReplyRateSetting', {
          active: act_feedback_rate,
          passive: pass_feedback_rate
        });

        
        commit('setActiveOverview', overViewData);
        let results: Array<any> = [];
        results = listData
        
        if (state.statusSelected !== "all") {
          if(state.statusSelected == 'active'){
            results = _.filter(results, (item): any => {
              if (item.active && item.active.match("Y")) {
                return true
              }
            });
          }else if(state.statusSelected == 'passive'){
            results = _.filter(results, (item): any => {
              if (item.passive && item.passive.match("Y")) {
                return true
              }
            });
          }else if(state.statusSelected == 'inactive'){
            results = _.filter(results, (item): any => {
              if (item.inactive && item.inactive.match("Y")) {
                return true
              }
            });
          }
        }
        // Calculate proactivity using the updated formula (replacing Insights Open Rate with Conversation Initiated and Peer Feedback)
        let proactivity = 0
        let feedbackComponent = 0
        let conversationInitiatedComponent = 0
        let peerFeedbackComponent = 0
        let performerComponent = 0
        
        if (data3 && data6) {
          const feedbackThirty = (data3.feedback && data3.feedback.thirty) || 0
          
          // Calculate conversation initiated and peer feedback averages
          let totalConversationInitiated = 0
          let totalPeerFeedback = 0
          let managerCount = 0
          
          for (let key in results) {
            const val = results[key];
            if (state.dataQualitybyTeam[val.email]) {
              managerCount++
              totalConversationInitiated += state.dataQualitybyTeam[val.email].conversations_initiated || 0
              
              // For peer feedback, convert to percentage (1+ requests = 100%, 0 = 0%)
              const peerFeedbackCount = state.dataQualitybyTeam[val.email].peerfeedback || 0
              totalPeerFeedback += peerFeedbackCount > 0 ? 100 : 0
            }
          }
          
          const avgConversationInitiated = managerCount > 0 ? totalConversationInitiated / managerCount : 0
          const avgPeerFeedback = managerCount > 0 ? totalPeerFeedback / managerCount : 0
          
          // Calculate performance feedback using exact same logic as getReviewCompleted()
          let memberbyteam = state.memberbyteam - 1;
          let dataQualitybyTeam = 0;
          
          // Handle team selection logic (same as getReviewCompleted)
          if (selectTeam == 'all' || selectTeam == state.teamHeight) {
            if (state.user_placeholder && state.user_placeholder.completed) {
              memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length;
              dataQualitybyTeam = dataQualitybyTeam + state.user_placeholder.completed;
            } else {
              memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length - 1;
            }
          }
          
          // Iterate through managers (same as getReviewCompleted using datalistSearchAll)
          for (let key in results) {
            const val = results[key];
            if (state.dataQualitybyTeam[val.email] && state.dataQualitybyTeam[val.email].performance_review.completed) {
              dataQualitybyTeam = dataQualitybyTeam + Number(state.dataQualitybyTeam[val.email].performance_review.completed);
            }
          }
          
          const avgReviewCompleted = memberbyteam > 0 ? (dataQualitybyTeam / memberbyteam > 100 ? 100 : dataQualitybyTeam / memberbyteam) : 0;
          
          // Updated proactivity formula with new weights:
          // When performance boosts enabled: 35% Feedback Reply Rate, 30% Conversation Initiated, 20% Peer Feedback, 15% Performance Feedback
          // When disabled: redistribute among 3 remaining components (35/85, 30/85, 20/85)
          const perfBoostEnabled = state.performanceBoostEnabled
          if (perfBoostEnabled) {
            feedbackComponent = feedbackThirty / 100 * 0.35
            conversationInitiatedComponent = avgConversationInitiated / 100 * 0.3
            peerFeedbackComponent = avgPeerFeedback / 100 * 0.2
            performerComponent = avgReviewCompleted / 100 * 0.15
          } else {
            feedbackComponent = feedbackThirty / 100 * (35 / 85)
            conversationInitiatedComponent = avgConversationInitiated / 100 * (30 / 85)
            peerFeedbackComponent = avgPeerFeedback / 100 * (20 / 85)
            performerComponent = 0
          }
          const calculatedProactivity = (feedbackComponent + conversationInitiatedComponent + peerFeedbackComponent + performerComponent) * 100
          
          // Use the calculated value instead of stored value
          proactivity = calculatedProactivity
        } 
        
        
        // let proactivity=data8.proactivity//((data3.feedback.thirty/100)*0.4+((((data3.report_daily_boss.thirty*5) + (data3.report_weekly_boss.thirty)) / 6)/100)*0.4+((data6.topPerformerRecognition)/100)*0.2)*100
        const overViewData1: Array<any> = []
        
        overViewData1['insight'] = {...data3,review:review}
        overViewData1['performerRecognition']=data6
        overViewData1['proactivityRatingValue']=Math.round(proactivity)
        // Calculate performance feedback using exact same logic as getReviewCompleted()
        let memberbyteam = state.memberbyteam - 1;
        let dataQualitybyTeam = 0;
        
        // Handle team selection logic (same as getReviewCompleted)
        if (selectTeam == 'all' || selectTeam == state.teamHeight) {
          if (state.user_placeholder && state.user_placeholder.completed) {
            memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length;
            dataQualitybyTeam = dataQualitybyTeam + state.user_placeholder.completed;
          } else {
            memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length - 1;
          }
        }
        
        // Iterate through managers (same as getReviewCompleted using datalistSearchAll)
        for (let key in results) {
          const val = results[key];
          if (state.dataQualitybyTeam[val.email] && state.dataQualitybyTeam[val.email].performance_review.completed) {
            dataQualitybyTeam = dataQualitybyTeam + Number(state.dataQualitybyTeam[val.email].performance_review.completed);
          }
        }
        
        const avgReviewCompleted = memberbyteam > 0 ? Math.round(dataQualitybyTeam / memberbyteam > 100 ? 100 : dataQualitybyTeam / memberbyteam) : 0;

        // Store individual proactivity components for tooltip
        // Recalculate conversationInitiated and peerFeedback for the tooltip display
        let totalConversationInitiatedTooltip = 0
        let totalPeerFeedbackTooltip = 0
        let managerCountTooltip = 0
        
        for (let key in results) {
          const val = results[key];
          if (state.dataQualitybyTeam[val.email]) {
            managerCountTooltip++
            totalConversationInitiatedTooltip += state.dataQualitybyTeam[val.email].conversations_initiated || 0
            
            // For peer feedback, convert to percentage (1+ requests = 100%, 0 = 0%)
            const peerFeedbackCount = state.dataQualitybyTeam[val.email].peerfeedback || 0
            totalPeerFeedbackTooltip += peerFeedbackCount > 0 ? 100 : 0
          }
        }
        
        const avgConversationInitiatedTooltip = managerCountTooltip > 0 ? Math.round(totalConversationInitiatedTooltip / managerCountTooltip) : 0
        const avgPeerFeedbackTooltip = managerCountTooltip > 0 ? Math.round(totalPeerFeedbackTooltip / managerCountTooltip) : 0
        
        const perfBoostEnabledForComponents = state.performanceBoostEnabled
        overViewData1['proactivityComponents'] = {
          feedbackReplyRate: (data3.feedback && data3.feedback.thirty) || 0,
          conversationInitiated: avgConversationInitiatedTooltip,
          peerFeedback: avgPeerFeedbackTooltip,
          topPerformerRecognition: perfBoostEnabledForComponents ? avgReviewCompleted : 0
        }
        //console.log("overViewData1",overViewData1)
        commit("setInsight",overViewData1)

        // // commit('setloadingresponse', false);
        // commit('setDataList', results.slice(0, state.size_page));
        // commit('setDataListAll', listData);
        // commit('setDataListSearchAll', results);
        // commit("setManagerResults", results.length);
        // console.log('results',results)]
        // console.log("before delay 3000")
        // setTimeout(() => {
          // console.log("in delay 3000");
          commit('setDataList', results.slice(0, state.size_page));
          commit('setDataListAll', listData);
          commit('setDataListSearchAll', results);
          commit("setManagerResults", results.length);

          commit('loadingManager', false);
          commit('setloadingManagerInsight', false);
        // }, 3000);
      
    });
    },
    async getNudges({ commit, dispatch, rootState, state }: any, selectTeam: any){
      const data6:Array<any> = []
      let count=0
      let boss=state.boss
      await firebase.firestore().collectionGroup('notifications').where("companyId", "==", rootState.authen.user.company).where("createdDate","==",format((new Date()), 'YYYY-MM-DD')).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const data = doc.data()
           
            if (data6[data.email] === undefined) {
              data6[data.email] = []
            }
            data6[data.email].push(data)
            
        });
        for(const v in boss){
          if(data6[boss[v].email]){
            count=count+data6[boss[v].email].length
          } 
        }

        commit('setNudgesData',{datalist:data6,count:count})
       // state.loadingManagerNudges=false
      });
    },
    async processWeeklyData({ commit, dispatch, rootState, state }: any, selectTeam: any){
      dispatch('getrespornse', "").then(async ()=>{
        let weekly_data={};
        let weeklyData:Array<any>=[];
        await firebase.firestore().collection('insight_manager_team').where("company_id", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              const data = doc.data();
              if(data.type==`${rootState.authen.user.company}_send_review_gem`){}else{
                if(data.date){
                  var result = format(new Date(startOfWeek(new Date(data.date))), 'YYYY-MM-DD')
                  if(!weekly_data[result]){
                    weekly_data[result]={TotalRES:0,TotalRES_time:0,replyQuality:0,date:result}
                  }
                  weekly_data[result].TotalRES=weekly_data[result].TotalRES+(data.TotalRES?data.TotalRES:0)
                  weekly_data[result].TotalRES_time=weekly_data[result].TotalRES_time+(data.TotalRES_time?data.TotalRES_time:0)
                  //console.log('insight_manager_team',data)
                }

              }
              
            });

            for(const i in state.responseToday){
              let today = format(startOfWeek(new Date()), 'YYYY-MM-DD')
              weekly_data[today].TotalRES=weekly_data[today].TotalRES+state.responseToday[i].TotalRES
              weekly_data[today].TotalRES_time=weekly_data[today].TotalRES_time+state.responseToday[i].TotalRES_time
            }

            weekly_data= _.orderBy(weekly_data, function(dateObj) {
              return new Date(dateObj.date);
            },['desc'])
            const label:Array<any>=[]
            const validDataPoints:Array<any>=[]
            for(let i=0;i<8;i++){
              if(weekly_data[i] && weekly_data[i].TotalRES_time > 0){
                // Only include data points where we have actual data (TotalRES_time > 0)
                var d = addDays(new Date(weekly_data[i].date),1);
                var date = d.getDate();
                var day = d.getDay();
                var weekOfMonth = Math.ceil((date - 1 - day) / 7);
                
                if(!label[format(new Date(weekly_data[i].date), 'MMM')]){
                  label[format(new Date(weekly_data[i].date), 'MMM')]=[]
                }
                label[format(new Date(weekly_data[i].date), 'MMM')].push(weekOfMonth)
                
                let _replyQuality:any=isNaN((weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))?0:(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time>100?100:Math.round(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))
                weeklyData.push(_replyQuality)
                validDataPoints.push(weekly_data[i])
              }
              // Skip data points where there's no actual data (don't push anything)
            }

            const _label:Array<any>=[]
            for(const i in label){
              if(label[i].length>4){
                for(const j in label[i]){
                  label[i][j]=label[i][j]+1
                  const stringData=i+" W"+label[i][j]
                  _label.push(stringData)
                }
              }else{
                for(const j in label[i]){
                  label[i][j]=label[i][j]
                  const stringData=i+" W"+label[i][j]
                  _label.push(stringData)
                }
              }
            }

           
            commit('setLabel',_label.reverse())
            commit('setweeklyData',weeklyData.reverse())
          });
      });
    },
    async getDataOverview({ commit, dispatch, rootState, state }: any, selectTeam: any){
      commit('setLoadingManagerOverview', true);
      dispatch('getLabelweek')
      state.loadingManagerNudges=true
      let boss=state.boss
      const allUser =rootState.dashboard.memberAndTeam.users
      //console.log('user_all',allUser)
      let nudges=0
      state.nudgesAll=[]
      let _data1:Array<any>=[]
      let data1:Array<any>=[]
      const databyteam={}
      const dataResponse={}
      const _data={
         notToSay:0,
         skip_total:0,
         openEnd:0,
         openEndAll:0,
         pastopenEnd:0,
         pastopenEndAll:0,
         superReply:0,
         superFeedbackOverall:0,
         super_feedback:0,
         feedback:0,
         _superReply:0,
         _super_feedback:0,
         anonymous:0,
         TotalRES:0,
         TotalRES_time:0,
         _TotalRES:0,
         _TotalRES_time:0,

      }
      const performance_review={}
      //console.log('selectTeam',selectTeam)
      let weekly_data={}
      let weeklyData:Array<any>=[]
      await Promise.all([
        dispatch('getNudges', selectTeam),
        dispatch('getDataOverviewToday', selectTeam)
      ])

      await firebase.firestore().collection('insight_manager_team').where("company_id", "==", rootState.authen.user.company).get()
        .then(function (querySnapshot) {

          querySnapshot.forEach(function (doc) {
            const data = doc.data()
              if(data.type==`${rootState.authen.user.company}_send_review_gem`){
                if(!performance_review[data.email]){
                  performance_review[data.email]=data
                }
              }else{
                  if(data.date){
                    var result = format(new Date(startOfWeek(new Date(data.date))), 'YYYY-MM-DD')
                    if(!weekly_data[result]){
                      weekly_data[result]={TotalRES:0,TotalRES_time:0,replyQuality:0,date:result}
                    }
                    weekly_data[result].TotalRES=weekly_data[result].TotalRES+(data.TotalRES?data.TotalRES:0)
                    weekly_data[result].TotalRES_time=weekly_data[result].TotalRES_time+(data.TotalRES_time?data.TotalRES_time:0)
                  }
                  
                  if(!dataResponse[data.boss]){
                    dataResponse[data.boss]={response:0,total:0,past_response:0,past_total:0}
                  }
                  if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
                    // if(data.boss=='jopd@pandora.net'){
                    //   console.log('data.response',data.response)
                    //   console.log('data.total_response',data.total_response)
                    // }
                    dataResponse[data.boss].response+=data.response?data.response:0
                    dataResponse[data.boss].total+=data.total_response?data.total_response:0

                    
                  }else{
                    dataResponse[data.boss].past_response+=data.response?data.response:0
                    dataResponse[data.boss].past_total+=data.total_response?data.total_response:0
                    
                  }
                // }
              
                // if(_head){
                  if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
                      _data.notToSay=_data.notToSay+(data.not_to_say?data.not_to_say:0)
                      _data.skip_total=_data.skip_total+(data.skip_total?data.skip_total:0)
                      _data.openEnd=_data.openEnd+(data.open_end?data.open_end:0)
                      _data.openEndAll=_data.openEndAll+(data.open_end_all?data.open_end_all:0)
                      _data.superReply=_data.superReply+(data.super_reply?data.super_reply:0)
                      _data.superFeedbackOverall=_data.superFeedbackOverall+(data.super_feedback_overall?data.super_feedback_overall:0)
                      _data.super_feedback= _data.super_feedback+(data.super_feedback?data.super_feedback:0)
                      _data.feedback=_data.feedback+(data.feedback?data.feedback:0)
                      _data.anonymous=_data.anonymous+(data.anonymous?data.anonymous:0)
                      nudges=nudges+data.nudge,
                      _data.TotalRES=_data.TotalRES+(data.TotalRES?data.TotalRES:0)
                      _data.TotalRES_time=_data.TotalRES_time+(data.TotalRES_time?data.TotalRES_time:0)
                      // console.log('data',data.open_end)
                    // state.nudgesAll.push({nudge:data.nudge,team:data.team_id})
                      data1.push(data)
                      if(data.boss){
                        if(!databyteam[data.boss]){
                          databyteam[data.boss]={superReply:0,superFeedbackOverall:0,TotalRES:0,TotalRES_time:0,open_end_boss:0,open_end_all_boss:0,peerfeedback:0}
                        }
                      
                        databyteam[data.boss].superReply=databyteam[data.boss].superReply+data.super_reply
                        databyteam[data.boss].superFeedbackOverall=databyteam[data.boss].superFeedbackOverall+data.super_feedback_overall
                        databyteam[data.boss].TotalRES=databyteam[data.boss].TotalRES+(data.TotalRES?data.TotalRES:0)
                        databyteam[data.boss].TotalRES_time=databyteam[data.boss].TotalRES_time+(data.TotalRES_time?data.TotalRES_time:0)

                        databyteam[data.boss].open_end_boss=databyteam[data.boss].open_end_boss+(data.open_end_boss?data.open_end_boss:0)
                        databyteam[data.boss].open_end_all_boss=databyteam[data.boss].open_end_all_boss+(data.open_end_all_boss?data.open_end_all_boss:0)
                        
                        databyteam[data.boss].peerfeedback=databyteam[data.boss].peerfeedback+(data.peerfeedback?data.peerfeedback:0)
                        
                      }
                      
                    }else{
                      _data.pastopenEnd=_data.pastopenEnd+data.open_end
                      _data.pastopenEndAll=_data.pastopenEndAll+data.open_end_all
                      _data._superReply= _data._superReply+data.super_reply
                      _data._super_feedback=_data._super_feedback+data.super_feedback
                      _data._TotalRES=_data._TotalRES+(data.TotalRES?data.TotalRES:0)
                      _data._TotalRES_time=_data._TotalRES_time+(data.TotalRES_time?data.TotalRES_time:0)
                      _data1.push(data)

                  }
                // }
            }

          })

            //Today data////
           _data.openEnd=_data.openEnd+(state.openEndedFeedbackAll?state.openEndedFeedbackAll.openEnd:0)
           _data.openEndAll=_data.openEndAll+state.openEndedFeedbackAll.openEndAll
          _data.notToSay= _data.notToSay+state.openEndedFeedbackAll.notToSay
          _data.skip_total= _data.skip_total+state.openEndedFeedbackAll.skip_total_count
          _data.superFeedbackOverall=_data.superFeedbackOverall+state.ReplyQualityAll.today.superFeedbackOverall
          _data.superReply=_data.superReply+state.ReplyQualityAll.today.superReply
          _data.super_feedback=_data.super_feedback+state.superfeedbackAll.today.super_feedback
          _data.feedback=_data.feedback+state.superfeedbackAll.today.feedback
          _data.anonymous=_data.anonymous+state.openEndedFeedbackAll.anonymous


          for(const i in state.responseToday){
              dataResponse[i].response+=state.responseToday[i].response
              dataResponse[i].total+=state.responseToday[i].total_response
              databyteam[i].TotalRES=databyteam[i].TotalRES+state.responseToday[i].TotalRES
              databyteam[i].TotalRES_time=databyteam[i].TotalRES_time+state.responseToday[i].TotalRES_time
              let today = format(startOfWeek(new Date()), 'YYYY-MM-DD')
            
              weekly_data[today].TotalRES=weekly_data[today].TotalRES+state.responseToday[i].TotalRES
              weekly_data[today].TotalRES_time=weekly_data[today].TotalRES_time+state.responseToday[i].TotalRES_time
              

          }

          // @fixed The are 2 algorithm to find openEnd
          // @see changeTeamweeklyData
          //*
          commit("setDataAllByTeam",{
            datalist:data1,
            datalistpast:_data1});


        
        let notToSayRatio=isNaN(_data.notToSay*100/_data.skip_total)?0:Math.round(_data.notToSay*100/_data.skip_total);

        const openEndedFeedback=isNaN(_data.openEnd*100/_data.openEndAll)?0:Math.round(_data.openEnd*100/_data.openEndAll)
        const superFeedbackRate=isNaN(_data.super_feedback*100/_data.feedback)?0:Math.round(_data.super_feedback*100/_data.feedback)
        const anonymousPercent=isNaN(_data.anonymous*100/_data.openEndAll)?0:Math.round(_data.anonymous*100/_data.openEndAll)
        // const openEndedFeedback=isNaN(openEnd*100/openEndAll)?0:Math.round(openEnd*100/openEndAll);
        //const superFeedbackRate=isNaN(super_feedback*100/feedback)?0:Math.round(super_feedback*100/feedback);
        //const anonymousPercent=isNaN(anonymous*100/openEndAll)?0:Math.round(anonymous*100/openEndAll);

        const pastopenEndedFeedback=isNaN(_data.pastopenEnd*100/_data.pastopenEndAll)?0:Math.round(_data.pastopenEnd*100/_data.pastopenEndAll)
        // Fix: Check for zero/invalid TotalRES_time before division to avoid Infinity -> 100 bug
        const replyQuality= (!_data.TotalRES_time || _data.TotalRES_time === 0) ? 0 : ((_data.TotalRES/_data.TotalRES_time)>100)?100:Math.round((_data.TotalRES/_data.TotalRES_time))
       // console.log('replyQuality',_data.TotalRES,_data.TotalRES_time)
        //((_data.superReply/_data.superFeedbackOverall)*100>100)?100:Math.round((_data.superReply/_data.superFeedbackOverall)*100)
        const pastReplyQuality=(!_data._TotalRES_time || _data._TotalRES_time === 0) ? 0 : ((_data._TotalRES/_data._TotalRES_time)>100?100:Math.round((_data._TotalRES/_data._TotalRES_time)))
        //((_data._superReply/_data._super_feedback)*100>100)?100:Math.round(_data._superReply/_data._super_feedback*100)
        
        // Calculate Psychological Safety using new behavioral algorithm
        // Step 1: Compute raw sub-scores (0-100)
        const participation = Math.min(100, openEndedFeedback) // Already a percentage
        const skipPenalty = Math.max(0, 100 - Math.min(100, notToSayRatio * 2)) // Non-linear penalty
        const recognition = Math.min(100, superFeedbackRate) // Already a percentage

        // Step 2: Convert to component indices
        const participationIdx = (0.6 * participation) + (0.4 * skipPenalty)
        const voiceSafetyIdx = Math.max(0, Math.min(100, 100 - anonymousPercent)) // Direct inverse of anonymous rate

        // Step 3: Aggregate with weights
        let safetyRating = (0.55 * participationIdx) + (0.45 * voiceSafetyIdx)

        // Step 4: Apply smoothing and bounds
        safetyRating = Math.max(0, Math.min(100, Math.round(safetyRating)))

        const overViewData:any= {}


        overViewData['psychologicalRatingValue']=boss.length>0?Math.round(safetyRating):0
        overViewData['openEndedFeedback']={openEndedFeedback:isNaN(openEndedFeedback)?0:Math.round(openEndedFeedback),compare:isNaN(openEndedFeedback-pastopenEndedFeedback)?0:Math.round(openEndedFeedback-pastopenEndedFeedback)}
        overViewData['replyQuality']={replyQuality:isNaN(replyQuality)?0:replyQuality,compare:isNaN(replyQuality-pastReplyQuality)?0:replyQuality-pastReplyQuality}

        // Store psychological safety algorithm components for tooltip display
        overViewData['participationIndex'] = boss.length > 0 ? Math.round(participationIdx) : 0
        overViewData['voiceSafetyIndex'] = boss.length > 0 ? Math.round(voiceSafetyIdx) : 0
        overViewData['superFeedbackRate'] = boss.length > 0 ? Math.round(recognition) : 0
        overViewData['anonymousPercent'] = boss.length > 0 ? anonymousPercent : 0
        nudges=nudges+state.nudgesData.count

        weekly_data= _.orderBy(weekly_data, function(dateObj) {
          return new Date(dateObj.date);
        },['desc'])
        const label:Array<any>=[]
        for(let i=0;i<8;i++){

          if(weekly_data[i] && weekly_data[i].TotalRES_time > 0){
            // Only include data points where we have actual data (TotalRES_time > 0)
            let _replyQuality:any=isNaN((weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))?0:(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time>100?100:Math.round(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))
            weeklyData.push(_replyQuality)
          }
          // Skip data points where there's no actual data (don't push anything)
          
        }

        commit('setweeklyData',weeklyData.reverse())

      const dataQualitybyTeam={} 
      for(const i in databyteam){
        const email_key=i.replace(/\./g, "||");
        if(allUser[email_key]){
          if(allUser[email_key].placeholder==true){
            //console.log('performance_review[i]===',performance_review[i])
            commit('setUserPlaceholder',performance_review[i])
          }
        }
        const _find_new_user=_.filter(allUser,function(user){
          if(user.boss&&user.createdatetime){
            return user.boss==i&&user.createdatetime.slice(0,10)== format(new Date(), 'YYYY-MM-DD')
          }
        })
        if(_find_new_user.length>0){
          const member_of_team=_.filter(allUser,function(user){
            return user.boss==i
          })
          for(const ii of _find_new_user){
            //console.log('typeof member_of_team.length',typeof performance_review[i].reviewCompleted)
            performance_review[i].completed+=100
            performance_review[i].reviewCompleted=Number(performance_review[i].reviewCompleted)+(isNaN(100/member_of_team.length)?0:Number(Math.round(100/member_of_team.length)))
          }
        }
        //console.log('i',i)
        if(!dataQualitybyTeam[i]){
          dataQualitybyTeam[i]={replyQuality:0,superReply:0,superFeedbackOverall:0,boss:i,TotalRES:0,TotalRES_time:0,peerfeedback:0,conversations_initiated:0,performance_review:{}}
        }
      
        dataQualitybyTeam[i].superReply=dataQualitybyTeam[i].superReply+databyteam[i].superReply
        dataQualitybyTeam[i].superFeedbackOverall=dataQualitybyTeam[i].superFeedbackOverall+databyteam[i].superFeedbackOverall
        dataQualitybyTeam[i].TotalRES=dataQualitybyTeam[i].TotalRES+databyteam[i].TotalRES
        dataQualitybyTeam[i].TotalRES_time=dataQualitybyTeam[i].TotalRES_time+databyteam[i].TotalRES_time
        if(state.dataQualitybyTeamToday[i]){
          dataQualitybyTeam[i].superReply=dataQualitybyTeam[i].superReply+state.dataQualitybyTeamToday[i].superReply
          dataQualitybyTeam[i].superFeedbackOverall=dataQualitybyTeam[i].superFeedbackOverall+state.dataQualitybyTeamToday[i].superFeedbackOverall
        }
          // Fix: Check for zero TotalRES_time before division to avoid Infinity -> 100 bug
          const replyQuality=(!dataQualitybyTeam[i].TotalRES_time || dataQualitybyTeam[i].TotalRES_time === 0)?0:(dataQualitybyTeam[i].TotalRES/dataQualitybyTeam[i].TotalRES_time>100?100:Math.round(dataQualitybyTeam[i].TotalRES/dataQualitybyTeam[i].TotalRES_time))
          //isNaN(state.dataQualitybyTeam[i].superReply/state.dataQualitybyTeam[i].superFeedbackOverall)?0:Math.round((state.dataQualitybyTeam[i].superReply/state.dataQualitybyTeam[i].superFeedbackOverall)*100)

          dataQualitybyTeam[i].replyQuality=replyQuality>100?100:replyQuality
          if(state.openEndedFeedbackAll.data_open_end_boss[i]){
            databyteam[i].open_end_boss+=state.openEndedFeedbackAll.data_open_end_boss[i].open_end_boss
            databyteam[i].open_end_all_boss+=state.openEndedFeedbackAll.data_open_end_boss[i].open_end_all_boss
          }

          if(state.dataToday[i]){
            
            databyteam[i].peerfeedback+=state.dataToday[i].peerfeedback?state.dataToday[i].peerfeedback:0
            if(!performance_review[i]){
              // performance_review[i]={
              //   performance_review:{
              //     reviewCompleted:0,
              //     GoalsProgress:0,
              //     cultuerAdd:0,
              //     both:0
              //   }
              // }
            }
            if(performance_review[i]&&performance_review[i].performance_review){
              //console.log('state.dataToday[i]',state.dataToday[i])
              performance_review[i].reviewCompleted=Number(performance_review[i].reviewCompleted)+state.dataToday[i].performance_review&&state.dataToday[i].performance_review.reviewCompleted?state.dataToday[i].performance_review.reviewCompleted:0
              performance_review[i].GoalsProgress=Number(performance_review[i].GoalsProgress)+state.dataToday[i].performance_review&&state.dataToday[i].performance_review.GoalsProgress?state.dataToday[i].performance_review.GoalsProgress:0
              performance_review[i].cultuerAdd=Number(performance_review[i].cultuerAdd)+state.dataToday[i].performance_review&&state.dataToday[i].performance_review.cultuerAdd?state.dataToday[i].performance_review.cultuerAdd:0
              performance_review[i].both=Number(performance_review[i].both)+state.dataToday[i].performance_review&&state.dataToday[i].performance_review.both?state.dataToday[i].performance_review.both:0
              performance_review[i].DEBI+=state.dataToday[i].DEBI?state.dataToday[i].DEBI:0
              performance_review[i].completed=Number(performance_review[i].completed)+state.dataToday[i].completed?state.dataToday[i].completed:0
            }

            
          }
          dataQualitybyTeam[i].conversations_initiated=isNaN(((databyteam[i].open_end_boss*100)/databyteam[i].open_end_all_boss))?0:((databyteam[i].open_end_boss*100)/databyteam[i].open_end_all_boss>100?100:Math.round((databyteam[i].open_end_boss*100)/databyteam[i].open_end_all_boss))
          dataQualitybyTeam[i].peerfeedback=databyteam[i].peerfeedback?databyteam[i].peerfeedback:0
          dataQualitybyTeam[i].performance_review=performance_review[i]?performance_review[i]:{
            reviewCompleted: '0',
            GoalsProgress: '0',
            cultuerAdd: '0',
            completed: '0',
            both: '0'}
            
           // console.log('performance_review[i]',i,'===',performance_review[i])
          dataQualitybyTeam[i].DEBI=performance_review[i]?performance_review[i].DEBI:0


        }       
        //console.log('overViewData',overViewData)
        //console.log('dataQualitybyTeam',dataQualitybyTeam)
        commit('setdataQualitybyTeam',dataQualitybyTeam)
        commit('setNudges',nudges)
        commit('set_activeOverview', overViewData)

        // Recalculate Proactivity score now that dataQualitybyTeam is populated
        dispatch('recalculateProactivityScore', selectTeam)

        state.loadingManagerNudges=false
        const _data_1={response:0,total:0,past_response:0,past_total:0}

        commit("setResponseAll",dataResponse)
        for(const index in dataResponse){
          _data_1.response+=dataResponse[index].response
          _data_1.total+=dataResponse[index].total
          _data_1.past_response+=dataResponse[index].past_response
          _data_1.past_total+=dataResponse[index].past_total

            if(!state.response[index]){
              state.response[index]={response_day:0,boss:index}
            }
            
            if(dataResponse[index]){
            state.response[index].response_day=isNaN(Math.round(dataResponse[index].response/dataResponse[index].total))?0:((dataResponse[index].response/dataResponse[index].total)/24).toFixed(1)
            }

          }
          
          const response=isNaN(Math.round(_data_1.response/_data_1.total))?0:((_data_1.response/_data_1.total)/24)
          const past_response=isNaN(Math.round(_data_1.past_response/_data_1.past_total))?0:((_data_1.past_response/_data_1.past_total)/24)
          const compare=isNaN(response-past_response)?0:Math.round(response-past_response)

        commit("setInsightresponse",{response:response.toFixed(1),compare:compare.toFixed(1)})
        commit('setloadingresponse', false);
        // commit('loadingManager', false)
        commit('setLoadingManagerOverview', false);

        // data8={notToSayRatio:notToSayRatio,amount:notToSay,openEndedFeedback:openEndedFeedback,feedbackCompare:openEndedFeedback-pastopenEndedFeedback}
        })
    },
    async recalculateProactivityScore({ commit, dispatch, rootState, state }: any, selectTeam: any) {
      // This function recalculates the Proactivity score after dataQualitybyTeam is populated
      if (!state.insight || !state.insight.insight) {
        return; // No insight data available yet
      }

      const data3 = state.insight.insight;
      const results = state.datalistSearchAll;
      
      if (data3.feedback) {
        const feedbackThirty = (data3.feedback && data3.feedback.thirty) || 0
        
        // Calculate conversation initiated and peer feedback averages
        let totalConversationInitiated = 0
        let totalPeerFeedback = 0
        let managerCount = 0
        
        for (let key in results) {
          const val = results[key];
          if (state.dataQualitybyTeam[val.email]) {
            managerCount++
            totalConversationInitiated += state.dataQualitybyTeam[val.email].conversations_initiated || 0
            
            // For peer feedback, convert to percentage (1+ requests = 100%, 0 = 0%)
            const peerFeedbackCount = state.dataQualitybyTeam[val.email].peerfeedback || 0
            totalPeerFeedback += peerFeedbackCount > 0 ? 100 : 0
          }
        }
        
        const avgConversationInitiated = managerCount > 0 ? totalConversationInitiated / managerCount : 0
        const avgPeerFeedback = managerCount > 0 ? totalPeerFeedback / managerCount : 0
        
        // Calculate performance feedback using exact same logic as getReviewCompleted()
        let memberbyteam = state.memberbyteam - 1;
        let dataQualitybyTeam = 0;
        
        // Handle team selection logic (same as getReviewCompleted)
        if (selectTeam == 'all' || selectTeam == state.teamHeight) {
          if (state.user_placeholder && state.user_placeholder.completed) {
            memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length;
            dataQualitybyTeam = dataQualitybyTeam + state.user_placeholder.completed;
          } else {
            memberbyteam = Object.keys(rootState.dashboard.memberAndTeam.users).length - 1;
          }
        }
        
        // Iterate through managers (same as getReviewCompleted using datalistSearchAll)
        for (let key in results) {
          const val = results[key];
          if (state.dataQualitybyTeam[val.email] && state.dataQualitybyTeam[val.email].performance_review.completed) {
            dataQualitybyTeam = dataQualitybyTeam + Number(state.dataQualitybyTeam[val.email].performance_review.completed);
          }
        }
        
        const avgReviewCompleted = memberbyteam > 0 ? (dataQualitybyTeam / memberbyteam > 100 ? 100 : dataQualitybyTeam / memberbyteam) : 0;
        
        // Updated proactivity formula with new weights:
        // When performance boosts enabled: 35% Feedback Reply Rate, 30% Conversation Initiated, 20% Peer Feedback, 15% Performance Feedback
        // When disabled: redistribute among 3 remaining components (35/85, 30/85, 20/85)
        const perfBoostEnabled = state.performanceBoostEnabled
        let feedbackComponent, conversationInitiatedComponent, peerFeedbackComponent, performerComponent
        if (perfBoostEnabled) {
          feedbackComponent = feedbackThirty / 100 * 0.35
          conversationInitiatedComponent = avgConversationInitiated / 100 * 0.3
          peerFeedbackComponent = avgPeerFeedback / 100 * 0.2
          performerComponent = avgReviewCompleted / 100 * 0.15
        } else {
          feedbackComponent = feedbackThirty / 100 * (35 / 85)
          conversationInitiatedComponent = avgConversationInitiated / 100 * (30 / 85)
          peerFeedbackComponent = avgPeerFeedback / 100 * (20 / 85)
          performerComponent = 0
        }
        const calculatedProactivity = (feedbackComponent + conversationInitiatedComponent + peerFeedbackComponent + performerComponent) * 100

        // Update the insight data with the recalculated values
        const updatedInsight = { ...state.insight };
        updatedInsight.proactivityRatingValue = Math.round(calculatedProactivity);

        // Update proactivity components with the new components
        updatedInsight.proactivityComponents = {
          feedbackReplyRate: feedbackThirty,
          conversationInitiated: Math.round(avgConversationInitiated),
          peerFeedback: Math.round(avgPeerFeedback),
          topPerformerRecognition: perfBoostEnabled ? Math.round(avgReviewCompleted) : 0
        };
        
        commit("setInsight", updatedInsight);
      }
    },
    getLabelweek({ commit, dispatch, rootState, state }: any){
      // This method generates labels for all 8 weeks regardless of data availability
      // It's used as a fallback when no specific data-driven labels are generated
      const _label:Array<any>=[]
      for(let i=0;i<8;i++){
        let today = format(startOfWeek(new Date()), 'YYYY-MM-DD')
        var d1 = addDays(new Date(today),1);
        var d = addDays(new Date(d1),-7*i);

        const month=format(new Date(d), 'MMM')
        var date = d.getDate();
  
        var day = d.getDay();
        var weekOfMonth = Math.ceil((date - 1 - day) / 7);
        
        
        const stringData=month+" W"+weekOfMonth

        _label.push(stringData)
          
        
        
      }

        
      commit('setLabel',_label.reverse())
    },
    async getDataOverviewToday({ commit, dispatch, rootState, state }: any, selectTeam: any){
      commit('setLoadingManagerOverview', true);
      let boss=state.boss//await dispatch('getMemberTeam',selectTeam)
      const allUser =rootState.dashboard.memberAndTeam.users
      let company = state.companyData
      if(!company || Object.keys(company).length === 0){
        company = await getCompany(rootState.authen.user.company)
        commit('setCompanyData', company)
      }
      
      //peerfeedbacktoday
      var promise1 = new Promise(async function(resolve, reject){
        const dataToday={}
        await firebase.firestore().collection('users_questions').where("company", "==",rootState.authen.user.company).where("quest_id","==",'-L1u2Xa5_pSCnitgF3u6').where("date",">=",format(new Date(), 'YYYY-MM-DD')).get().then(async function (querySnapshot) {
        //firebase.firestore().collection('peerfeedback').where("company", "==",rootState.authen.user.company).where("createdate",">=",format(new Date(), 'YYYY-MM-DD')).get().then(async function (querySnapshot) {
          querySnapshot.forEach( function (doc) {
              const data = doc.data()
              const emailKey_boss=data.users.replace(/\./g, "||");
              if(boss[emailKey_boss]){
                  if(!dataToday[`${data.users}`]){
                    dataToday[`${data.users}`]={peerfeedback:0}
                  }
                  dataToday[`${data.users}`].peerfeedback++
              }
          })
        
          resolve(dataToday)
      })
      



      });


      var promise2 = new Promise(async function(resolve, reject){
        const dataIndex:Array<any>=[]
        const DEBI_weight = { // DEBI
          'DPSRRS':0.34,
          'OFRS':0.22,
          'OFES':0.11,
          'RPRS':0.22,
          'VAS':0.11,
        }
        const DEBI_max = { // DEBI
          'DPSRRS':1,
          'OFRS':0.8,
          'OFES':1,
          'RPRS':1,
          'VAS':0.8,
        }
        const engagementIndexDay = await getEngagementIndexDay(rootState.authen.user.company,format(addDays(new Date(), -1), 'YYYY-MM-DD'),format(addDays(new Date(), -1), 'YYYY-MM-DD'))
        for(const key in engagementIndexDay){
          const data = engagementIndexDay[key]
          const emailKey=data.email.replace(/\./g, "||")
          if(allUser[emailKey]){
            const bossKey=(allUser[emailKey].boss).replace(/\./g, "||")
            const teamboss=allUser[bossKey]?allUser[bossKey].team:''
            if(teamboss){
              if(!dataIndex[teamboss]){
                dataIndex[teamboss]={
                  score:0,
                  DPSRRS:{total:0,answer:0},
                  OFRS:{total:0,answer:0},
                  OFES:{total:0,answer:0},
                  RPRS:{total:0,answer:0},
                  VAS:{total:0,answer:0},
                }
              }
              if(data.type){
                dataIndex[teamboss][data.type].total+= (data.answer !== undefined) ? data.total : 0;
                if(data.answer){
                    dataIndex[teamboss][data.type].answer+= (data.answer !== undefined) ? data.answer : 0;
                }
              }
            }
          }
        }
        for(const team in dataIndex){
          for(let x=0; x<5; x++){
            const type = Object.keys(DEBI_weight)[x]
            const weight = DEBI_weight[Object.keys(DEBI_weight)[x]]
            const max = DEBI_max[Object.keys(DEBI_max)[x]]
            if(type == 'OFES'){
              if(dataIndex[team][type].answer && dataIndex[team] && dataIndex[team]['OFRS'].answer){
                let score = (dataIndex[team][type].answer /dataIndex[team]['OFRS'].answer)
                if(score > max){
                  score = 1
                }else{
                  score = score/max
                }
                score = score * weight
                dataIndex[team].score += score
              }
            }else if(type == 'VAS'){
              if(dataIndex[team][type].answer && dataIndex[team]['RPRS'] && dataIndex[team]['RPRS'].answer){
                let score = (dataIndex[team][type].answer / dataIndex[team]['RPRS'].answer)
                if(score > max){
                  score = 1
                }else{
                  score = score/max
                }
                score = score * weight
                dataIndex[team].score += score
              }
            }else{
              if(dataIndex[team][type].answer && dataIndex[team][type].total){
                let score = (dataIndex[team][type].answer / dataIndex[team][type].total)
                if(score > max){
                  score = 1
                }else{
                  score = score/max
                }
                score = score * weight
                dataIndex[team].score += score
              }
            }
          }
        }
        resolve(dataIndex)
      });


      var promise3 = new Promise(async function(resolve, reject){
        const dataAll:Array<any>=[]
        const tableData={}
        firebase.firestore().collection('send_review_gem').where("company", "==",rootState.authen.user.company).where("createdate",">=",format(new Date(), 'YYYY-MM-DD')).get().then(async function (querySnapshot){
          querySnapshot.forEach( function (doc) {
              const data = doc.data()
                dataAll.push(data)
                //console.log('data-----',data)
          })
          //console.log("dataAll",dataAll)
          const  receiver = _.groupBy(dataAll, function (b) {
            return b.receiver;
          });
          for(const emailKey in allUser){
 
            if(receiver[allUser[emailKey].email]){
              const newData =_.orderBy(receiver[allUser[emailKey].email], function(dateObj) {
                return new Date(dateObj.createdate);
              },['desc'])
             
              if(newData){
                const lastData = newData[0]
                             
                const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
                const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
                if(moment(lastData.createdate).isAfter(moment().add(-time_peding,'months'))){
                  
                  if(lastData.goal){
                    allUser[emailKey].goal_Original=lastData.goal
                    allUser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
                    
                  }
                  if(lastData.culture){
                    allUser[emailKey].culture_Original=lastData.culture
                    allUser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
                    
                  }
  
                  if(lastData.goal&&lastData.culture){
                    if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                      allUser[emailKey].both=100
                    }else{
                      allUser[emailKey].both=0
                    }
                  }   


                  allUser[emailKey].reviews_status='Completed'
                }else if(moment(lastData.createdate).isAfter(moment().add(-time_overdue,'months'))){
                  

                  if(lastData.goal){
                    allUser[emailKey].goal_Original=lastData.goal
                    allUser[emailKey].goal=lastData.goal==4||lastData.goal==3?100:lastData.goal==2?50:0
                    
                  }
                  if(lastData.culture){
                    allUser[emailKey].culture_Original=lastData.culture
                    allUser[emailKey].culture=lastData.culture==4||lastData.culture==3?100:lastData.culture==2?50:0
                    
                  }
  
                  if(lastData.goal&&lastData.culture){
                    if((lastData.culture==3||lastData.culture==4)&&(lastData.goal==3||lastData.goal==4)){
                      allUser[emailKey].both=100
                    }else{
                      allUser[emailKey].both=0
                    }
                  }   
                  allUser[emailKey].reviews_status='Pending'
                }else{
                    
                  allUser[emailKey].reviews_status='Overdue'
                }
              }else{
           
                allUser[emailKey].reviews_status='Overdue'
              }
            }else{
              const time_peding=company.performance_review&&company.performance_review.pending?company.performance_review.pending:1
              const time_overdue=company.performance_review&&company.performance_review.overdue?company.performance_review.overdue:2
              if(moment(allUser[emailKey].createdatetime).isAfter(moment().add(-time_overdue,'months'))){

                allUser[emailKey].reviews_status='Pending'
              }else{
               
                allUser[emailKey].reviews_status='Overdue'
              }

            }
          }




          let cultuerAdd:any=0
            let reviewCompleted:any=0
            let GoalsProgress:any=0
            let both:any=0
              const boss = _.groupBy(allUser, function (b) {
                return b.boss;
              });
              for(const key in boss){
                GoalsProgress=0
                cultuerAdd=0
                both=0
                reviewCompleted=0
                if(key!='undefined'){
                    for(const key2 in boss[key]){                
                      
                      GoalsProgress+=boss[key][key2].goal?boss[key][key2].goal:0
                      boss[key][key2].goal_Original=boss[key][key2].goal_Original?boss[key][key2].goal_Original:0
                      boss[key][key2].culture_Original=boss[key][key2].culture_Original?boss[key][key2].culture_Original:0
                      cultuerAdd+=boss[key][key2].culture?boss[key][key2].culture:0
                      reviewCompleted+=boss[key][key2].reviews_status=='Completed'?100:0
                      reviewCompleted+=boss[key][key2].reviews_status=='Pending'?100:0
                      both+=boss[key][key2].both?boss[key][key2].both:0
                     
                     
                     
                    }
                    const emailKey=key.replace(/\./g, "||")
                    // console.log('alluser[emailKey]s',alluser[emailKey])
                    if(allUser[emailKey]){
                      if(!tableData[allUser[emailKey].email]){
                        tableData[allUser[emailKey].email]={
                          reviewCompleted: Number((reviewCompleted/boss[key].length).toFixed()),
                          GoalsProgress: Number((GoalsProgress/boss[key].length).toFixed()),
                          both: Number((both/boss[key].length).toFixed()),
                          completed: reviewCompleted,
                          cultuerAdd: Number((cultuerAdd/boss[key].length).toFixed()),
                      }
                    }
                  }
                }
              }
         
          resolve(tableData)
        })
      })




      Promise.all([promise1,promise2,promise3]).then((values) => {
        const DataToday={}
        
        const data1:any=values[0]
        const data2:any=values[1]
        const data3:any=values[2]
  
        for(const i in boss){

          if(!DataToday[boss[i].email]){
            DataToday[boss[i].email]={
              peerfeedback:0,
              DEBI:0,
              performance_review:{reviewCompleted:0,GoalsProgress:0,cultuerAdd:0,both:0}
            }
            DataToday[boss[i].email].peerfeedback=data1&&data1[boss[i].email]?data1[boss[i].email].peerfeedback:0
            DataToday[boss[i].email].DEBI=data2&&data2[boss[i].team]?data2[boss[i].team].score:0
            DataToday[boss[i].email].performance_review=data3[boss[i].email]?data3[boss[i].email]:{reviewCompleted:0,GoalsProgress:0,cultuerAdd:0,both:0}
          }
        }
        commit('setDataToday',DataToday)
        //console.log('DataToday',DataToday)

      })



      let openEndData:Array<any> = []
      let openEndDataAll:Array<any> = []
      let postOpenEndData:Array<any> = []
      let postOpenEndDataAll:Array<any> = []
      let notToSayAll:Array<any> = []
      let skip_totalAll:Array<any> = []
      let notToSay=0
      let skip_total=0
      let openEnd=0
      let openEndAll=0
      let pastopenEnd=0
      let pastopenEndAll=0
      let anonymous=0
      let data_open_end_boss={}
      
      let data8 :any={}//{notToSayRatio:0,amount:0,openEndedFeedback:0,feedbackCompare:0}
      let data9:any ={}
     await firebase.firestore().collection('users_questions').where("company", "==", rootState.authen.user.company).where("date",">=",format(new Date(), 'YYYY-MM-DD')).where("type","==","Text Area Field").get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const data = doc.data()
          const emailKey=data.users.replace(/\./g, "||");
          //console.log("emailKey",emailKey)
          let _head= _.find(boss, function (v) {
            return v.team == data.team;
          });
          // if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
            if(data.status=="close"){
              
            
            if(_head){
                if(data.tag=="FOLLOW-UP"){
                  if(data.answer=="I prefer not to answer, sorry."){
                    notToSay++
                    skip_total++
                    
                  }else if(!data.answer){
                    skip_total++
                  }
                 }
                 if(data.send_anonymous==1){
                  anonymous++
                }
                if(data.tag !== 'FOLLOW-UP'){
                  if(data.answer){
                    openEnd++
                  }
                openEndAll++
                }
            }
            if(data.tag=="FOLLOW-UP"){
              if(data.answer=="I prefer not to answer, sorry."){
                notToSayAll.push(data)
                skip_totalAll.push(data)
              }else if(!data.answer){
                skip_totalAll.push(data)
              }
            }
            if(data.tag !== 'FOLLOW-UP'){
              if(data.answer){
                openEndData.push(data)
              }
              openEndDataAll.push(data)
            }
            let bossData= _.find(boss, function (v) {
              return v.email == data.users;
            });
       
            if(bossData&&data.tag!=="FOLLOW-UP"){
              if(!data_open_end_boss[bossData.email]){
                data_open_end_boss[bossData.email]={
                  open_end_boss:0,
                  open_end_all_boss:0
                }
              }
              if(data.answer){
           
                    data_open_end_boss[bossData.email].open_end_boss++ 
              }
              if(doc.data().read||doc.data().status=="close"){
                data_open_end_boss[bossData.email].open_end_all_boss++}
             
            }
            }

        });
       
   
        let notToSayRatio=isNaN(notToSay*100/skip_total)?0:Math.round(notToSay*100/skip_total)
        const openEndedFeedback=isNaN(openEnd*100/openEndAll)?0:Math.round(openEnd*100/openEndAll)
        const pastopenEndedFeedback=isNaN(pastopenEnd*100/pastopenEndAll)?0:Math.round(pastopenEnd*100/pastopenEndAll)
        data8={notToSayRatio:notToSayRatio,amount:notToSay,openEndedFeedback:openEndedFeedback,feedbackCompare:openEndedFeedback-pastopenEndedFeedback}
        //console.log("openEndDataAllToday",openEndDataAll)
        commit("setOpenEndedFeedbackAll",{
          openEnd:openEnd,
          openEndAll:openEndAll,
          notToSay:notToSay,
          skip_total_count:skip_total,
          notToSayRatio:notToSayAll,
          skip_total:skip_totalAll,
          openEndData:openEndData,
          openEndDataAll:openEndDataAll,
          anonymous:anonymous,
          data_open_end_boss:data_open_end_boss,
          past:{
            openEndData:postOpenEndData,
            openEndDataAll:postOpenEndDataAll
          }})

      });

      let super_feedbackAll:Array<any> =[]
      let feedbackAll:Array<any> =[]
      let superReplyAll:Array<any> =[]
      let _superReplyAll:Array<any> =[]
      let _super_feedbackAll:Array<any> =[]
      let superFeedbackOverallData:Array<any>=[]
      let superReply=0
      let super_feedback=0
      let _superReply=0
      let _super_feedback=0
      let feedback=0
      let superFeedbackOverall=0
    await firebase.firestore().collection('toneanalyze').where("company", "==", rootState.authen.user.company).where("date","==",format(new Date(), 'YYYY-MM-DD')).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          const data = doc.data()

          const emailKey=data.email.replace(/\./g, "||");
          if(!state.dataQualitybyTeamToday[allUser[emailKey].boss]){
            state.dataQualitybyTeamToday[allUser[emailKey].boss]={superReply:0,superFeedbackOverall:0}
          }
   
            var head= _.find(boss, function (v) {
              return v.email == data.email;
            });
            
          
            if(head){
              if(data.type == 'reply-messages'&&Number(data.effort)>=100){
               // superReplyAll.push(data)
                superReply++
              }
              if(Number(data.effort)>=100){
                superFeedbackOverall++
              }
              if(Number(data.effort)>=100&& data.type =="question"){
              //super_feedbackAll.push(data)
               super_feedback++
              }
              if(Number(data.effort)>=0 && data.type =="question"){
               // feedbackAll.push(data)
               feedback++
              }
             
             //ALL
             if(data.type == 'reply-messages'&&Number(data.effort)>=100){
                superReplyAll.push(data)
                state.dataQualitybyTeamToday[allUser[emailKey].boss].superReply++
              }
              if(Number(data.effort)>=100){
                superFeedbackOverallData.push(data)
                state.dataQualitybyTeamToday[allUser[emailKey].boss].superFeedbackOverall++
              }
              if(Number(data.effort)>=100&& data.type =="question"){
              super_feedbackAll.push(data)
              }
              if(Number(data.effort)>=0 && data.type =="question"){
                feedbackAll.push(data)
              }
              }

        });

        commit('setReplyQualityAll',{superReply:superReplyAll,superFeedbackOverallData:superFeedbackOverallData,past:{superReplyAll:_superReplyAll,super_feedbackAll:_super_feedbackAll},today:{superReply:superReply,superFeedbackOverall:superFeedbackOverall}})
        commit('setSuperfeedbackAll',{superFeedbackAll:super_feedbackAll,feedbackAll:feedbackAll,today:{super_feedback:super_feedback,feedback:feedback,}})

      });

      


    },
    async getrespornse({ commit, dispatch, rootState, state }: any, selectTeam: any){
      let subTeam:any = {}
      subTeam[selectTeam] = true
      let organization1level = (state.teamOneLevel && state.teamOneLevel.parent && state.teamOneLevel.parent) ? state.teamOneLevel.parent : subTeam
      let allUser = {}
      if(Object.keys(rootState.main.allUser).length === 0) {
        allUser = await getUserAll(rootState.authen.user.company)
      }else{
        allUser = rootState.main.allUser
      }
      var promise1 = new Promise(function(resolve, reject) {
        
        const dataValue={}
        const data={response:0,total:0,past_response:0,past_total:0}
        const response={}
        if(state.teamHeight !== selectTeam){
     
          for(const team in organization1level){
            const boss =_.filter(state.boss, { team: team });
            for(const bossId in boss)
            if(state.responseAll[boss[bossId].email]){
              data.response+=state.responseAll[boss[bossId].email].response
              data.total+=state.responseAll[boss[bossId].email].total
              data.past_response+=state.responseAll[boss[bossId].email].past_response
              data.past_total+=state.responseAll[boss[bossId].email].past_total
            }
          }
          const response=isNaN(Math.round(data.response/data.total))?0:((data.response/data.total)/24)
          const past_response=isNaN(Math.round(data.past_response/data.past_total))?0:(data.past_response/data.past_total)
          const compare=isNaN(response-past_response)?0:Math.round(response-past_response)
          resolve({response:response,compare:compare})
          
        }else{
        firebase.firestore().collection('messages').where("company", "==", rootState.authen.user.company).where("createdate","==",format(new Date(), 'YYYY-MM-DD')).get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            const emailKey=data.user.replace(/\./g, "||")
            if(allUser[emailKey] && allUser[emailKey].team){
              let _emailKey=''
              if(allUser[emailKey].boss){
                 _emailKey=allUser[emailKey].boss.replace(/\./g, "||")
              }              
                if(data.answers&&data.answers.length>1){
            
                  if(data.answers[1].user==allUser[emailKey].boss){
                    
                    if (dataValue[allUser[emailKey].boss] === undefined) {
                      dataValue[allUser[emailKey].boss] = {response:0,total:0,past_response:0,past_total:0,TotalRES:0,
                        TotalRES_time:0,}
                    }
                    dataValue[allUser[emailKey].boss].total++
                    const result = differenceInHours(new Date(data.answers[1].date),new Date(data.answers[0].date))
                    dataValue[allUser[emailKey].boss].response+=result
                   
                  }
                 
                }
                if(data.replyinsights&&data.replyinsights.TotalRES){
                  if(!dataValue[allUser[emailKey].boss]){
                    dataValue[allUser[emailKey].boss]={
                          response:0,
                          total_response:0,
                          TotalRES:0,
                          TotalRES_time:0
                      }
                  } 
                  dataValue[allUser[emailKey].boss].TotalRES+=data.replyinsights.TotalRES
                  dataValue[allUser[emailKey].boss].TotalRES_time++
              }
              
            }
          })
          state.responseToday=dataValue

          // for(const index in dataValue){
          //   data.response+=dataValue[index].response
          //   data.total+=dataValue[index].total
          //   data.past_response+=dataValue[index].past_response
          //   data.past_total+=dataValue[index].past_total

          //   if(!state.response[index]){
          //     state.response[index]={response_day:0}
          //   }
            
          //   if(dataValue[index]){
          //   state.response[index].response_day=isNaN(Math.round(dataValue[index].response/dataValue[index].total))?0:((dataValue[index].response/dataValue[index].total)/24).toFixed(1)
          //   }

          // }
          // const response=isNaN(Math.round(data.response/data.total))?0:((data.response/data.total)/24)
          // const past_response=isNaN(Math.round(data.past_response/data.past_total))?0:((data.past_response/data.past_total)/24)
          // const compare=isNaN(response-past_response)?0:Math.round(response-past_response)
          resolve('')
        })

        }
        
      
      });
      Promise.all([ promise1]).then((values)=> {
        const data1:any = values[0]
       
        
        
      })
    },
    // async getDataOverview1({ commit, dispatch, rootState, state }: any, selectTeam: any){
    //   commit('setLoadingManagerOverview', true);
    //   let boss=state.boss//await dispatch('getMemberTeam',selectTeam)
    //   const allUser =rootState.dashboard.memberAndTeam.users
    //   let openEndData:Array<any> = []
    //   let openEndDataAll:Array<any> = []
    //   let postOpenEndData:Array<any> = []
    //   let postOpenEndDataAll:Array<any> = []
    //   let notToSayAll:Array<any> = []
    //   let skip_totalAll:Array<any> = []
    //   let notToSay=0
    //   let skip_total=0
    //   let openEnd=0
    //   let openEndAll=0
    //   let pastopenEnd=0
    //   let pastopenEndAll=0
    //   let data8 :any={}//{notToSayRatio:0,amount:0,openEndedFeedback:0,feedbackCompare:0}
    //   let data9:any ={}
    //  await firebase.firestore().collection('users_questions').where("company", "==", rootState.authen.user.company).where("date",">=",format(addDays(new Date(), -60), 'YYYY-MM-DD')).where("type","==","Text Area Field").where("status","==","close").get()
    //   .then(function (querySnapshot) {
    //     querySnapshot.forEach(function (doc) {
    //       const data = doc.data()
    //       let _head= _.find(boss, function (v) {
    //         return v.team == data.team;
    //       });
    //       if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
    //         if(_head){
    //           if(data.tag=="FOLLOW-UP"){
    //             if(data.answer=="I prefer not to answer, sorry."){
    //               notToSay++
    //               skip_total++
                  
    //             }else if(!data.answer){
    //               skip_total++
    //             }
    //            }
    //            if(data.answer){
    //             openEnd++
    //            }
    //            openEndAll++
    //         }
    //         if(data.tag=="FOLLOW-UP"){
    //           if(data.answer=="I prefer not to answer, sorry."){
    //             notToSayAll.push(data)
    //             skip_totalAll.push(data)
    //           }else if(!data.answer){
    //             skip_totalAll.push(data)
    //           }
    //         }
    //         if(data.answer){
    //           openEndData.push(data)
    //         }
    //         openEndDataAll.push(data)
    //       }else{
    //         if(_head){
    //           if(data.answer){
    //             pastopenEnd++
    //           }
    //           pastopenEndAll++
    //         }
    //         if(data.answer){
    //           postOpenEndData.push(data)
    //         }
    //         postOpenEndDataAll.push(data)
    //       }
    
    //     });

 
    //     let notToSayRatio=isNaN(notToSay*100/skip_total)?0:Math.round(notToSay*100/skip_total)
    //     const openEndedFeedback=isNaN(openEnd*100/openEndAll)?0:Math.round(openEnd*100/openEndAll)
    //     const pastopenEndedFeedback=isNaN(pastopenEnd*100/pastopenEndAll)?0:Math.round(pastopenEnd*100/pastopenEndAll)
    //     data8={notToSayRatio:notToSayRatio,amount:notToSay,openEndedFeedback:openEndedFeedback,feedbackCompare:openEndedFeedback-pastopenEndedFeedback}
    //     commit("setOpenEndedFeedbackAll",{
    //       notToSayRatio:notToSayAll,
    //       skip_total:skip_totalAll,
    //       openEndData:openEndData,
    //       openEndDataAll:openEndDataAll,
    //       past:{
    //         openEndData:postOpenEndData,
    //         openEndDataAll:postOpenEndDataAll
    //       }})

    //   });

    //   let super_feedbackAll:Array<any> =[]
    //   let feedbackAll:Array<any> =[]
    //   let superReplyAll:Array<any> =[]
    //   let _superReplyAll:Array<any> =[]
    //   let _super_feedbackAll:Array<any> =[]
    //   let superFeedbackOverallData:Array<any>=[]
    //   let superReply=0
    //   let super_feedback=0
    //   let _superReply=0
    //   let _super_feedback=0
    //   let feedback=0
    //   let superFeedbackOverall=0
    // await firebase.firestore().collection('toneanalyze').where("company", "==", rootState.authen.user.company).where("date",">=",format(addDays(new Date(), -60), 'YYYY-MM-DD')).get()
    //   .then(function (querySnapshot) {
    //     querySnapshot.forEach(function (doc) {
    //       const data = doc.data()
    //       const emailKey=data.email.replace(/\./g, "||");
          
    //       if(allUser[emailKey]){
    //         var head= _.find(boss, function (v) {
    //           return v.team == allUser[emailKey].team;
    //         });
    //       }
    //       if(format(new Date(data.date), 'YYYY-MM-DD')>=format(addDays(new Date(), -30), 'YYYY-MM-DD')){
    //         if(head){
    //           if(data.type == 'reply-messages'){
 
    //            // superReplyAll.push(data)
    //             superReply++
    //           }
    //           if(data.effort=="100"){
    //             superFeedbackOverall++
    //           }
    //           if(data.effort=="100"&& data.type =="question"){
    //           //super_feedbackAll.push(data)
    //            super_feedback++
    //           }
    //           if(Number(data.effort)>=0 && data.type =="question"){
    //            // feedbackAll.push(data)
    //            feedback++
    //           }
    //          }
    //          //ALL
    //          if(data.type == 'reply-messages'){
    //             superReplyAll.push(data)
    //           }
    //           if(data.effort=="100"){
    //             superFeedbackOverallData.push(data)
    //           }
    //           if(data.effort=="100"&& data.type =="question"){
    //           super_feedbackAll.push(data)
    //           }
    //           if(Number(data.effort)>=0 && data.type =="question"){
    //             feedbackAll.push(data)
    //           }
    //       }else{
    //         if(head){
    //           if(data.type == 'reply-messages'){
    //             _superReply++
    //           }
    //           if(data.effort=="100"&& data.type =="question"){
    //             _super_feedback++
    //           }
    //          }

    //         if(data.type == 'reply-messages'){
    //           _superReplyAll.push(data)
    //         }
    //         if(data.effort=="100"){
    //           _super_feedbackAll.push(data)
    //         }
            

    //       }
    //     });


  
    //     const replyQuality=((superReply/superFeedbackOverall)*100>100)?100:Math.round((superReply/superFeedbackOverall)*100)
    //     const pastReplyQuality=((_superReply/_super_feedback)*100>100)?100:Math.round(_superReply/_super_feedback*100)
    //     const superFeedbackRate=isNaN(super_feedback*100/feedback)?0:Math.round(super_feedback*100/feedback)
    //     commit('setReplyQualityAll',{superReply:superReplyAll,superFeedbackOverallData:superFeedbackOverallData,past:{superReplyAll:_superReplyAll,super_feedbackAll:_super_feedbackAll}})
    //     commit('setSuperfeedbackAll',{superFeedbackAll:super_feedbackAll,feedbackAll:feedbackAll})
    //     // data9={superFeedbackRate:superFeedbackRate,replyQuality:replyQuality,pastReplyQuality:pastReplyQuality}
    //     // let feedbackRate=data8.openEndedFeedback>80?0.8:data8.openEndedFeedback/100
    //     // let superFeedback=data9.superFeedbackRate>80?0.8:data9.superFeedbackRate/100
    //     // let skip:any=0.0
    //     // if(data8.amount>2){
    //     //   skip=1-(data8.notToSayRatio/100)
    //     // }else{
    //     //   skip=(1-(data8.notToSayRatio/100)*0)
    //     // }

    //     // let  safetyRating=((feedbackRate*(10/8)*0.4)+(superFeedback*(10/8)*0.3)+(skip*0.3))*100
    //     // safetyRating =isNaN(safetyRating)?0:safetyRating
    //     // const overViewData:any= {}
    //     // console.log("replyQuality",replyQuality)
    //     // console.log("pastReplyQuality",pastReplyQuality)
    //     // overViewData['psychologicalRatingValue']=boss.length>0?Math.round(safetyRating):0
    //     // overViewData['openEndedFeedback']={openEndedFeedback:isNaN(data8.openEndedFeedback)?0:Math.round(data8.openEndedFeedback),compare:isNaN(data8.feedbackCompare)?0:Math.round(data8.feedbackCompare)}
    //     // overViewData['replyQuality']={replyQuality:isNaN(data9.replyQuality)?0:data9.replyQuality,compare:isNaN(data9.replyQuality-data9.pastReplyQuality)?0:data9.replyQuality-data9.pastReplyQuality}
    //     // console.log('overViewData=====',overViewData)  
    //     // commit('set_activeOverview', overViewData) 
    //     // commit('setLoadingManagerOverview', false) 
    //   });
    // },
    async getMemberTeam({ commit, dispatch, rootState, state }: any, selectTeam: any){
      //const allUser =rootState.dashboard.memberAndTeam.users
      let bossAll = state.bossDirectory
      if(!bossAll || Object.keys(bossAll).length === 0){
        bossAll = (await firebase.database().ref(`boss/${rootState.authen.user.company}`).once('value')).val() || {}
        commit('setBossDirectory', bossAll)
      }
      
      const teams =rootState.dashboard.memberAndTeam.teams
      let boss:Array<any>=[]
      let teamOneLevel: any = [];
      if (!selectTeam) {
        if(rootState.authen.user.user_type == 'leadership'){
          selectTeam = rootState.authen.user.team
          commit('setTeamHeight', selectTeam)
        }else{
          if (!state.teamHeight) {
            if (rootState.team.teamsfixedall.length > 0) {
              let topmostArr: Array<any> = [];
              _.forEach(rootState.team.teamsfixedall, (value) => {
                if (value.parent == '') {
                  topmostArr.push(value.key)
                }
              });
              selectTeam = topmostArr[0]
              if(topmostArr.length > 1){
                selectTeam = _.find(topmostArr, (value) => {
                  const chk_topmost = _.find(rootState.team.teamsfixedall, { parent: value });
                  return !!chk_topmost;
                });
              }
              commit('setTeamHeight', selectTeam)
            } else {
              let topmostArr: Array<any> = [];
              for(const x in teams){
                if(!teams[x].parent){
                  topmostArr.push(x)
                }
              }
              selectTeam = topmostArr[0]
              if(topmostArr.length > 1){
                selectTeam = _.find(topmostArr, (value) => {
                  const chk_topmost = _.find(teams, { parent: value });
                  return !!chk_topmost;
                });
              }
              commit('setTeamHeight', selectTeam)
            }
          } else {
            selectTeam = state.teamHeight
          }
        }
      }
      await firebase.firestore().collection('organization1level').doc(`${rootState.authen.user.company}-${selectTeam}`).get()
      .then(function (doc) {
        teamOneLevel = doc.data()
        if(doc.data()){
          if(!state.organization[teamOneLevel.team_id]){
            state.organization[teamOneLevel.team_id]=teamOneLevel.parent
          }
          let _boss=_.filter(bossAll,(o=>{return o.team==teamOneLevel.team_id}))
          if(_boss){
            for(const i in _boss){
              const data={
                email:_boss[i].email,
                team:_boss[i].team
              }
              boss.push(data)
            }
            
          }
          for(const v in teamOneLevel.parent ){
            let _boss=_.filter(bossAll,(o=>{return o.team==v}))
            if(_boss){
              for(const i in _boss){
              const data={
                email:_boss[i].email,
                team:_boss[i].team
              }
              boss.push(data)
              }
            }
          }
        }
      });
      
      if(!teamOneLevel){
        let _boss=_.filter(bossAll,(o=>{return o.team==selectTeam}))
        if(_boss){
          for(const i in _boss){
          const data={
            email:_boss[i].email,
            team:_boss[i].team
          }
          boss.push(data)
        }
      }
      }
      state.teamOneLevel=teamOneLevel
      boss=_.uniqBy(boss, "email");

     
      commit('setBoss', boss)
     
    },
    async changeTeam({ commit, dispatch, rootState, state }: any, selectTeam: any){
      commit('setSelectedteam', selectTeam)
      const all_user=rootState.dashboard.memberAndTeam.users
      state.loadingManagerNudges=true
      let subTeam:any = {}
      subTeam[selectTeam] = true
      let organization1level = (state.teamOneLevel && state.teamOneLevel.parent && state.teamOneLevel.parent) ? state.teamOneLevel.parent : subTeam
      let nudges=0
      let boss=state.boss//await dispatch('getMemberTeam',selectTeam)
      const allUser =rootState.dashboard.memberAndTeam.users
      let superReply=0
      let super_feedback=0
      let _superReply=0
      let _super_feedback=0
      let openEnd=0
      let openEndAll=0
      let pastopenEnd=0
      let pastopenEndAll=0
      let feedback=0
      let notToSay=0
      let skip_total=0
      let superFeedbackOverall=0
      let anonymous=0
      let TotalRES=0
      let TotalRES_time=0
      let _TotalRES=0
      let _TotalRES_time=0
      let weekly_data={}
      let weeklyData:Array<any>=[]
      const team =_.groupBy(boss,'team')

      for(let teamid in team){
        
        let filterData= _.filter(state.dataAllByTeam.datalist, function (data) {
          return data.boss == team[teamid][0].email
        });
        for(const i in filterData){
          if(filterData[i]){
            nudges=nudges+(filterData[i].nudge?filterData[i].nudge:0)
            openEnd=openEnd+(filterData[i].open_end?filterData[i].open_end:0)
            openEndAll=openEndAll+(filterData[i].open_end_all?filterData[i].open_end_all:0)
            notToSay=notToSay+(filterData[i].not_to_say?filterData[i].not_to_say:0)
            skip_total=skip_total+(filterData[i].skip_total?filterData[i].skip_total:0)
            superReply=superReply+(filterData[i].super_reply?filterData[i].super_reply:0)
            superFeedbackOverall=superFeedbackOverall+(filterData[i].super_feedback_overall?filterData[i].super_feedback_overall:0)
            super_feedback=super_feedback+(filterData[i].super_feedback?filterData[i].super_feedback:0)
            feedback=feedback+(filterData[i].feedback?filterData[i].feedback:0)
            anonymous=anonymous+(filterData[i].anonymous?filterData[i].anonymous:0)
            TotalRES=TotalRES+(filterData[i].TotalRES?filterData[i].TotalRES:0)
            TotalRES_time=TotalRES_time+(filterData[i].TotalRES_time?filterData[i].TotalRES_time:0)

            if(filterData[i].date){
              
              var result = format(new Date(startOfWeek(new Date(filterData[i].date))), 'YYYY-MM-DD')
              if(!weekly_data[result]){
                weekly_data[result]={TotalRES:0,TotalRES_time:0,replyQuality:0,date:result}
              }
              weekly_data[result].TotalRES=weekly_data[result].TotalRES+(filterData[i].TotalRES?filterData[i].TotalRES:0)
              weekly_data[result].TotalRES_time=weekly_data[result].TotalRES_time+(filterData[i].TotalRES_time?filterData[i].TotalRES_time:0)
            }
           }
        }

        let _filterData= _.filter(state.dataAllByTeam.datalistpast, function (data) {
          return data.boss ==team[teamid][0].email
        });
        for(const i in _filterData){
          if(_filterData[i]){
          pastopenEnd=pastopenEnd+_filterData[i].open_end
          pastopenEndAll=pastopenEndAll+_filterData[i].open_end_all
          _superReply=_superReply+_filterData[i].super_reply
          _super_feedback=_super_feedback+_filterData[i].super_feedback_overall
          _TotalRES=_TotalRES+(_filterData[i].TotalRES?_filterData[i].TotalRES:0)
          _TotalRES_time=_TotalRES_time+(_filterData[i].TotalRES_time?_filterData[i].TotalRES_time:0)
          }
          if(_filterData[i].date){
              
            var result = format(new Date(startOfWeek(new Date(_filterData[i].date))), 'YYYY-MM-DD')
            if(!weekly_data[result]){
              weekly_data[result]={TotalRES:0,TotalRES_time:0,replyQuality:0,date:result}
            }
            weekly_data[result].TotalRES=weekly_data[result].TotalRES+(_filterData[i].TotalRES?_filterData[i].TotalRES:0)
            weekly_data[result].TotalRES_time=weekly_data[result].TotalRES_time+(_filterData[i].TotalRES_time?_filterData[i].TotalRES_time:0)
          }

        }

      }
      for (let v in boss){
        
        //nudges
        if(state.nudgesData&&state.nudgesData.datalist&&state.nudgesData.datalist[boss[v].email]){
          nudges=nudges+state.nudgesData.datalist[boss[v].email].length
        } 
        if(state.openEndedFeedbackAll){
          if(state.openEndedFeedbackAll.openEndData){
          //open-end 
          let filterOpenEndData= _.filter(state.openEndedFeedbackAll.openEndData, function (data) {
            return data.team ==boss[v].team
           });
          if(filterOpenEndData){
            openEnd=openEnd+filterOpenEndData.length
         }
        }

        if(state.openEndedFeedbackAll.openEndDataAll){
        let filterFeedbackAll= _.filter(state.openEndedFeedbackAll.openEndDataAll, function (data) {
          return data.team ==boss[v].team
        });
        if(filterFeedbackAll){
          openEndAll=openEndAll+filterFeedbackAll.length
        }
             //anonymous
          let filterAnonymous= _.filter(filterFeedbackAll, function (data) {
            return data.send_anonymous==0
          });
          anonymous=anonymous+filterAnonymous.length
          
        }

        if(state.openEndedFeedbackAll.past&&state.openEndedFeedbackAll.past.openEndData){
          //past open-end 
          let pastfilterOpenEndData= _.filter(state.openEndedFeedbackAll.past.openEndData, function (data) {
            return data.team ==boss[v].team
          });
          if(pastfilterOpenEndData){
            pastopenEnd=pastopenEnd+pastfilterOpenEndData.length
          }
        }

        if(state.openEndedFeedbackAll.past&&state.openEndedFeedbackAll.past.openEndDataAll){
          let pastfilterFeedbackAll= _.filter(state.openEndedFeedbackAll.past.openEndDataAll, function (data) {
            return data.team ==boss[v].team
          });
          if(pastfilterFeedbackAll){
            pastopenEndAll=pastopenEndAll+pastfilterFeedbackAll.length
          }
        }
        if(state.openEndedFeedbackAll.notToSayRatio){
          //notToSay
          let filterNotToSayRatio= _.filter(state.openEndedFeedbackAll.notToSayRatio, function (data) {
            return data.team ==boss[v].team
          });
          if(filterNotToSayRatio){
            notToSay=notToSay+filterNotToSayRatio.length
          }
        }
        if(state.openEndedFeedbackAll.skip_total){
          //skip_total
          let filterskip_total= _.filter(state.openEndedFeedbackAll.skip_total, function (data) {
            return data.team ==boss[v].team
          });
          if(filterskip_total){
            skip_total=skip_total+filterskip_total.length
          }
        }
        
          
        }
        
      }
      //superReply
      for(let user in state.ReplyQualityAll.superReply){
        
        const emailKey=state.ReplyQualityAll.superReply[user].email.replace(/\./g, "||");
        if(allUser[emailKey]){
          let head= _.find(boss, function (v) {
            return v.team == allUser[emailKey].team;
          });
          if(head){
           
            superReply++
          }
        }
      }

      //super_feedback Overall
      for(let user in state.ReplyQualityAll.superFeedbackOverallData){
        const emailKey=state.ReplyQualityAll.superFeedbackOverallData[user].email.replace(/\./g, "||");
        if(allUser[emailKey]){
          let head= _.find(boss, function (v) {
            return v.team == allUser[emailKey].team;
          });
          if(head){
            superFeedbackOverall++
          }
        }
      }

      //super_feedback
      for(let user in state.superfeedbackAll.superFeedbackAll){
        const emailKey=state.superfeedbackAll.superFeedbackAll[user].email.replace(/\./g, "||");
        if(allUser[emailKey]){
          let head= _.find(boss, function (v) {
            return v.team == allUser[emailKey].team;
          });
          if(head){
            super_feedback++
          }
        }
      }

      for(let user in state.superfeedbackAll.feedbackAll){
        const emailKey=state.superfeedbackAll.feedbackAll[user].email.replace(/\./g, "||");
        if(allUser[emailKey]){
          let head= _.find(boss, function (v) {
            return v.team == allUser[emailKey].team;
          });
          if(head){
            feedback++
          }
        }
      }

      //past
      //superReply
      if(state.ReplyQualityAll&&state.ReplyQualityAll.past&&state.ReplyQualityAll.past.superReplyAll){
        for(let user in state.ReplyQualityAll.past.superReplyAll){
          const emailKey=state.ReplyQualityAll.past.superReplyAll[user].email.replace(/\./g, "||");
          if(allUser[emailKey]){
            let head= _.find(boss, function (v) {
              return v.team == allUser[emailKey].team;
            });
            if(head){
              _superReply++
            }
          }
        }
      }
      
      if(state.ReplyQualityAll&&state.ReplyQualityAll.past&&state.ReplyQualityAll.past.super_feedbackAll){
        //super_feedback
        for(let user in state.ReplyQualityAll.past.super_feedbackAll){
          const emailKey=state.ReplyQualityAll.past.super_feedbackAll[user].email.replace(/\./g, "||");
          if(allUser[emailKey]){
            let head= _.find(boss, function (v) {
              return v.team == allUser[emailKey].team;
            });
            if(head){
              //console.log("_super_feedback-----",_super_feedback)
              _super_feedback++
            }
          }
        }
      }
     
      // Fix: Check for zero TotalRES_time before division to avoid Infinity -> 100 bug
      const replyQuality=(!TotalRES_time || TotalRES_time === 0)?0:(TotalRES/TotalRES_time>100?100:Math.round(TotalRES/TotalRES_time))
      //((superReply/superFeedbackOverall)*100>100)?100:Math.round((superReply/superFeedbackOverall)*100)
      const pastReplyQuality=(!_TotalRES_time || _TotalRES_time === 0)?0:(_TotalRES/_TotalRES_time>100?100:Math.round(_TotalRES/_TotalRES_time))
      const superFeedbackRate=isNaN(super_feedback*100/feedback)?0:Math.round(super_feedback*100/feedback)
      

      const notToSayRatio=isNaN(notToSay*100/skip_total)?0:Math.round(notToSay*100/skip_total)
      const openEndedFeedback=isNaN(openEnd*100/openEndAll)?0:Math.round(openEnd*100/openEndAll)
      const anonymousPercent=isNaN(anonymous*100/openEndAll)?0:Math.round(anonymous*100/openEndAll)
      const pastopenEndedFeedback=isNaN(pastopenEnd*100/pastopenEndAll)?0:Math.round(pastopenEnd*100/pastopenEndAll)

      // Calculate Psychological Safety using new behavioral algorithm (consistent with getDataOverview)
      // Step 1: Compute raw sub-scores (0-100)
      const participation = Math.min(100, openEndedFeedback) // Already a percentage
      const skipPenalty = Math.max(0, 100 - Math.min(100, notToSayRatio * 2)) // Non-linear penalty
      const recognition = Math.min(100, superFeedbackRate) // Already a percentage

      // Step 2: Convert to component indices
      const participationIdx = (0.6 * participation) + (0.4 * skipPenalty)
      const voiceSafetyIdx = Math.max(0, Math.min(100, 100 - anonymousPercent)) // Direct inverse of anonymous rate

      // Step 3: Aggregate with weights
      let safetyRating = (0.55 * participationIdx) + (0.45 * voiceSafetyIdx)

      // Step 4: Apply smoothing and bounds
      safetyRating = Math.max(0, Math.min(100, Math.round(safetyRating)))
      
      // console.log("weekly_data",weekly_data)
      weekly_data= _.orderBy(weekly_data, function(dateObj) {
        return new Date(dateObj.date);
      },['desc'])
      for(let i=7;i>=0;i--){
        if(weekly_data[i] && weekly_data[i].TotalRES_time > 0){
          // Only include data points where we have actual data (TotalRES_time > 0)
          let _replyQuality:any=isNaN((weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))?0:(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time>100?100:Math.round(weekly_data[i].TotalRES/weekly_data[i].TotalRES_time))
          weeklyData.push(_replyQuality)          
        }
        // Skip data points where there's no actual data (don't push anything)
      }
      
      if (!selectTeam) {
        await dispatch('processWeeklyData', selectTeam);
      } else {
        //console.log('weeklyData',weeklyData)
        commit('setweeklyData',weeklyData)
      }

      const overViewData:any= {}
      commit('setNudges',Math.round(nudges))
      // overViewData['nudges']=Math.round(nudges)
      //console.log("nudges",nudges)
      overViewData['psychologicalRatingValue']=boss.length>0?Math.round(safetyRating):0
      overViewData['openEndedFeedback']={openEndedFeedback:isNaN(openEndedFeedback)?0:openEndedFeedback,compare:isNaN(openEndedFeedback-pastopenEndedFeedback)?0:openEndedFeedback-pastopenEndedFeedback}//Math.round(data8.openEndedFeedback),compare:Math.round(data8.feedbackCompare)}
      overViewData['replyQuality']={replyQuality:isNaN(replyQuality)?0:replyQuality,compare:isNaN(replyQuality-pastReplyQuality)?0:replyQuality-pastReplyQuality}
      
      // Store psychological safety algorithm components for tooltip display
      overViewData['participationIndex'] = boss.length > 0 ? Math.round(participationIdx) : 0
      overViewData['voiceSafetyIndex'] = boss.length > 0 ? Math.round(voiceSafetyIdx) : 0
      overViewData['superFeedbackRate'] = boss.length > 0 ? Math.round(recognition) : 0
      overViewData['anonymousPercent'] = boss.length > 0 ? anonymousPercent : 0
      //console.log('changeteam',overViewData)
      commit('set_activeOverview', overViewData)
      commit('setLoadingManagerOverview', false);
      state.loadingManagerNudges=false 
      const data={response:0,total:0,past_response:0,past_total:0}
      let memberbyteam=0
      for(const team in organization1level){
        const boss =_.filter(state.boss, { team: team });
        const filterdata=_.filter(all_user, { team: team });
        memberbyteam+=filterdata?filterdata.length:0
        //delete boss
        //memberbyteam=memberbyteam-1
        for(const bossId in boss)
        if(state.responseAll[boss[bossId].email]){
          data.response+=state.responseAll[boss[bossId].email].response
          data.total+=state.responseAll[boss[bossId].email].total
          data.past_response+=state.responseAll[boss[bossId].email].past_response
          data.past_total+=state.responseAll[boss[bossId].email].past_total
        }
      }
      const response=isNaN(Math.round(data.response/data.total))?0:((data.response/data.total)/24)
      const past_response=isNaN(Math.round(data.past_response/data.past_total))?0:(data.past_response/data.past_total/24)
      const compare=isNaN(response-past_response)?0:Math.round(response-past_response)
      commit("setInsightresponse",{response:response.toFixed(1),compare:compare.toFixed(1)})
      commit('setloadingresponse', false);
      commit('loadingManager', false)
      commit('setLoadingManagerOverview', false);
      commit ('setmemberbyteam',memberbyteam)
      
    },
    currentManagerChange({ commit, state }: any, page: any) {
      let size = state.size_page
      let start_row = (page - 1) * size
      let end_row = ((page - 1) * size) + size
      let results: Array<any> = [];
      results = state.datalistAll
      if (state.statusSelected !== "all") {
        if(state.statusSelected == 'active'){
          results = _.filter(state.datalistAll, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'passive'){
          results = _.filter(state.datalistAll, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'inactive'){
          results = _.filter(state.datalistAll, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      if (state.inputSearchManager.length > 2) {
        let re = new RegExp(state.inputSearchManager, 'gi')
        let response = _.filter(state.datalistAll, (item): any => {
          if (item.fullname.match(re)) {
            return true
          } else if (item.firstname != undefined && item.firstname.match(re)) {
            return true
          } else if (item.lastname != undefined && item.lastname.match(re)) {
            return true
          }
        });
        results = response
      } 
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }

      if(field == 'response_day'){
        let _users:any=[]
        let response:any=[]
        for (const i in state.response) {
          const _userFind=_.find(results, function (v) {
            return v.email == state.response[i].boss;
          });
          if(_userFind&&_userFind.feedback=='-'){
            response.push({...state.response[i],soryby:'-1'})
          }else{
            response.push({...state.response[i],soryby:state.response[i].response_day})
          }
        }
        const _orderTime = _.orderBy(response, ['soryby'], [order,'asc']);
        for(const i in _orderTime){
          const _userFind=_.find(results, function (v) {
            return v.email == _orderTime[i].boss;
          });
          if(_userFind){
            _users.push(_userFind)
          }
        }
        commit('setManagerPage', page)
        commit('setDataList', _users.slice(start_row, end_row))

      }else if(field == 'replyQuality'){
        let _users:any=[]
        let data:any=[]
        for(const i in state.dataQualitybyTeam){
          const _userFind=_.find(results, function (v) {
            return v.email == state.dataQualitybyTeam[i].boss;
          });
    
          if(_userFind){
            if(_userFind.feedback=='-'||(_userFind.feedback_check=='N'&&_userFind.feedback==0)){
              state.dataQualitybyTeam[i]['replyQuality']=-1
            }
            
            data.push(state.dataQualitybyTeam[i])
          }
        }
        const _orderTime = _.orderBy(data, [field], [order,'asc']);
        for(const i in _orderTime){
          const _userFind=_.find(results, function (v) {
            return v.email == _orderTime[i].boss;
          });
         
          if(_userFind){
            _users.push(_userFind)
          }
        }
        commit('setManagerPage', page)
        commit('setDataList', _users.slice(start_row, end_row))  
        

      }else if(field =='feedback'){
        for(const data in results){
          if(results[data].sortFeedback==undefined)results[data].sortFeedback=0
          results[data].sortFeedback=results[data].feedback=='-'?100:results[data].feedback
        }
        results = _.orderBy(results, ['sortFeedback','fullname'], [order,'asc']);
        commit('setManagerPage', page)
        commit('setDataList', results.slice(start_row, end_row))  
      }else{
        results = _.orderBy(results, [field,'fullname'], [order,'asc']);
      commit('setManagerPage', page)
      commit('setDataList', results.slice(start_row, end_row))  

      }

      
    },
    searchManager({ commit, state, dispatch }: any, data: any) {
      clearTimeout(state.managerTypingStatus)
      state.managerTypingStatus = setTimeout(() => {
        commit('setManagerPage', 1)
          dispatch('sortManager', {
            0: state.managerSortField,
            1: state.managerSortOrder,
            3: data.value
          })
      }, data.typingTimeout)
    },
    sortManager({ commit, state }: any, value: any) {
      
      let results: Array<any> = [];
      results = state.datalistAll
      if (state.statusSelected !== "all") {
        if(state.statusSelected == 'active'){
          results = _.filter(results, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'passive'){
          results = _.filter(results, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'inactive'){
          results = _.filter(results, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let textSearching = value[3] || state.inputSearchManager;
      if (textSearching.length > 0) {
        if (results.length > 0) {
          let re = new RegExp(textSearching, 'gi')
          let response = _.filter(results, (item): any => {
            if (item.fullname.match(re)) {
              return true
            } else if (item.firstname != undefined && item.firstname.match(re)) {
              return true
            } else if (item.lastname != undefined && item.lastname.match(re)) {
              return true
            }
          });
          results = response
        }
      }

      let field = value[0]
      commit('setManagerSortField', field)
      let order = value[1]
      commit('setManagerSortOrder', order)
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      if(field == 'response_day'){
        let _users:any=[]
        let response:any=[]
        for (const i in state.response) {
          const _userFind=_.find(results, function (v) {
            return v.email == state.response[i].boss;
          });
          if(_userFind&&_userFind.feedback=='-'){
            response.push({...state.response[i],soryby:'-1'})
          }else{
            response.push({...state.response[i],soryby:state.response[i].response_day})
          }
        }
        const _orderTime = _.orderBy(response, ['soryby'], [order,'asc']);
        
        for(const i in _orderTime){
          const _userFind=_.find(results, function (v) {
            return v.email == _orderTime[i].boss;
          });
         
          if(_userFind){
            _users.push(_userFind)
          }
        }
        //console.log('_users',_users)
        commit('setManagerResults', _users.length)
        commit('setDataList', _users.slice(0, state.size_page))
        commit('setDataListSearchAll', _users)

      }else if(field == 'replyQuality'){
        let _users:any=[]
        let data:any=[]
        for(const i in state.dataQualitybyTeam){
          const _userFind=_.find(results, function (v) {
            return v.email == state.dataQualitybyTeam[i].boss;
          });
    
          if(_userFind){
            if(_userFind.feedback=='-'||(_userFind.feedback_check=='N'&&_userFind.feedback==0)){
              state.dataQualitybyTeam[i]['replyQuality']=-1
            }
            
            data.push(state.dataQualitybyTeam[i])
          }
        }
        const _orderTime = _.orderBy(data, [field], [order,'asc']);
        for(const i in _orderTime){
          const _userFind=_.find(results, function (v) {
            return v.email == _orderTime[i].boss;
          });
         
          if(_userFind){
            _users.push(_userFind)
          }
        }
        commit('setManagerResults', _users.length)
        commit('setDataList', _users.slice(0, state.size_page))
        commit('setDataListSearchAll', _users)
        

      }else if(field =='feedback'){
        for(const data in results){
          if(results[data].sortFeedback==undefined)results[data].sortFeedback=0
          results[data].sortFeedback=results[data].feedback=='-'?100:results[data].feedback
        }
        let _users
        _users = _.orderBy(results, ['sortFeedback','fullname'], [order,'asc']);
        commit('setManagerResults', _users.length)
        commit('setDataList', _users.slice(0, state.size_page))
        commit('setDataListSearchAll', _users)
      }else{
        let _users
        _users = _.orderBy(results, [field,'fullname'], [order,'asc']);
        commit('setManagerResults', _users.length)
        commit('setDataList', _users.slice(0, state.size_page))
        commit('setDataListSearchAll', _users)

      }
      
    },
    setManagerClassificationSettings({ dispatch, commit, rootState, state }: any, setting) {
      firebase.database().ref(`/company/${rootState.authen.user.company}`).update({
        "manager_classification":{
          active_open_rate: Number(setting.insightActiveLower),
          passive_open_rate: Number(setting.insightPassiveUpper),
          active_feedback_rate: Number(setting.feedbackActiveLower),
          passive_feedback_rate: Number(setting.feedbackPassiveUpper),
        },
        updated:format(new Date(), 'YYYY-MM-DD HH:mm')
      })
      commit('setInsightsOpenRateSetting', {
        active: Number(setting.insightActiveLower),
        passive: Number(setting.insightPassiveUpper)
      });
      commit('setFeedbackReplyRateSetting', {
        active: Number(setting.feedbackActiveLower),
        passive: Number(setting.feedbackPassiveUpper)
      });
      dispatch('getDataAll', state.teamHeight)
    },
    setTeamSorting({ commit }: any, selectTeam) {
      commit('setTeamSelected', selectTeam);
    },
    setStatusSorting({ commit, dispatch, state }: any, selectStatus) {
      commit('setStatusSelected', selectStatus);
      dispatch('reponseSearchAll', selectStatus).then((result) => {
        commit('setDataList', result[0])
        commit('setDataListSearchAll', result[1])
        commit('setManagerResults', result[2])
        
      });
    },
    async reponseSearchAll({ state }: any, status: any) {
      const data: Array<any> = []
      let listData = state.datalistAll
      if (status !== "all") {
        if(status == 'active'){
          listData = _.filter(listData, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(status == 'passive'){
          listData = _.filter(listData, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(status == 'inactive'){
          listData = _.filter(listData, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      listData = _.orderBy(listData, [field,'fullname'], [order,'asc']);
      data.push(listData.slice(0, state.size_page))
      data.push(listData)
      data.push(listData.length)
      return data
    },
    setSearchingText({ commit }: any, input) {
      commit('setInputSearchManager', input);
      commit('setWaitTypingSearchBox', true);
      setTimeout(() => {
        commit('setWaitTypingSearchBox', false);
      }, 500)
    },
    async getDataExport({ commit, dispatch, rootState, state }: any) {
      commit('setSnackbar', true)
      const data: Array<any> = []
      let listData = state.datalistAll

      if (state.statusSelected !== "all") {
        if(state.statusSelected == 'active'){
          listData = _.filter(listData, (item): any => {
            if (item.active && item.active.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'passive'){
          listData = _.filter(listData, (item): any => {
            if (item.passive && item.passive.match("Y")) {
              return true
            }
          });
        }else if(state.statusSelected == 'inactive'){
          listData = _.filter(listData, (item): any => {
            if (item.inactive && item.inactive.match("Y")) {
              return true
            }
          });
        }
      }
      let field = state.managerSortField
      let order = state.managerSortOrder
      
      if (order === "ascending") {
        order = 'asc'
      } else {
        order = 'desc'
      }
      if (field === "") {
        field = "daily"
      }
      listData = _.orderBy(listData, [field,'fullname'], [order,'asc']);
     
      commit('setDataExportAll', listData)
      dispatch('genDataExport')
    },
    async genDataExport({ commit, state, dispatch, rootState }: any) {
      const dataexportall = state.dataexportall
      const dataQualitybyTeam=state.dataQualitybyTeam
      const Excel = require('exceljs');
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet('mySheet');
      /*TITLE*/
      ws.mergeCells('B2', 'E2');
      ws.getRow(2).height = 25
      ws.getCell('B2').font = { name: 'Arial', size: 18, bold: true }
      ws.getCell('B2').alignment = { vertical: 'middle' }

      ws.getCell('B2').value = 'Insights Manager'
      // /*Column headers*/
      ws.getColumn('A').width = 5;
      let header:any = ['','Name','Team Name','Direct Reports','Conversations Initiated','Peer Feedback Requested','Reviews Complete','Goals Progress','Culture Contribution','Reply Rate','Insights Opened','DEBI Score','Action Items']
      ws.getRow(4).values = header

      /*Data*/
      _.forEach(dataexportall, (item, key)=> {
        let _tmp:any = [
          '',
          item.firstname+' '+item.lastname,
          item.team_name,
          item.directMember,
          (dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].conversations_initiated?dataQualitybyTeam[item.email].conversations_initiated:0)+'%',
          (dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].peerfeedback?dataQualitybyTeam[item.email].peerfeedback:0)+'%',
          (dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].performance_review?dataQualitybyTeam[item.email].performance_review.reviewCompleted:0)+'%',
          (dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].performance_review?dataQualitybyTeam[item.email].performance_review.GoalsProgress:0)+'%',
          (dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].performance_review?dataQualitybyTeam[item.email].performance_review.cultuerAdd:0)+'%',
          (item.feedback?item.feedback:0)+'%',
          (item.overall_rate?item.overall_rate:0)+'%',
          dataQualitybyTeam[item.email]&&dataQualitybyTeam[item.email].DEBI?dataQualitybyTeam[item.email].DEBI:0,
          item.critical_area
        ]
        ws.addRow(_tmp)
    });

      ws.eachRow(function (row) {
        if(row.number == 4){
          row.eachCell(function (cell) {
            ws.getCell(cell.address).font = { name: 'Arial', size: 11, bold: true }
          });
        }
        // else if(row.number > 4 ){
          // row.eachCell(function (cell) {
          //   if(cell.col == 2){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 11 }
          //   }else if(cell.col == 3){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
          //   }else if(cell.col > 3){
          //     ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
          //     ws.getCell(cell.address).alignment = { horizontal: 'right' };
          //   }
          // });
        // }
      });

      wb.xlsx.writeBuffer( {
        base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = 'Insights Manager' + ".xlsx";
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
              commit('setSnackbar', false)
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    // async setLastCoaching({ commit, dispatch, rootState, state }: any, user: any) {
      // const allCompany = (await firebase.database().ref('company').once('value')).val()
      // for(const companyId in allCompany){
      //   const allUser = (await firebase.database().ref('users').orderByChild("company").equalTo(companyId).once('value')).val()
      //   for(const key in allUser){
      //     firebase.firestore().collection('coaching').where("email", "==", `${allUser[key].email}`).orderBy('datetime','desc').limit(1).get()
      //     .then((querySnapshot) => {
      //       querySnapshot.forEach((doc) => {
      //         const data = doc.data();
      //         // if(allUser[key].email == 'wittawat_b@dhas.com'){
      //           firebase.firestore().collection('coachinglatest').doc(allUser[key].email).set(data).then(docRef => {
      //           });
      //         // }
      //       })
      //     });
      //   }
      // }
    // },
    getDataCoaching({ commit, dispatch, rootState, state }: any, email: any) {
      commit('loadingCoaching', true);
      let modalData: Array<any> = []
      modalData['user'] = new Array()
      modalData['user'].firstname = state.memberKey[email].firstname
      modalData['user'].lastname = state.memberKey[email].lastname
      modalData['user'].team_name = state.memberKey[email].team_name
      modalData['coaching'] = new Array()
      firebase.firestore().collection('coaching').where("email", "==", `${email}`).orderBy('datetime','desc').get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            const _temp = {};
            _temp['date'] = format(data.date, "MMMM D, YYYY")
            _temp['challenges'] = "Boost "+data.quest_type
            if(data.standard){
              _temp['standard'] = data.standard
            }else{
              // set standard for old data
              if(data.quest_type == 'Recognition'){
                _temp['standard'] = [75,50,50]
              }else if(data.quest_type == 'Personal Growth'){
                if(data.quest_follow_id && data.quest_follow_id == '-L0J42xtbRWVbsHdFWWR'){
                  _temp['standard'] = [70,40,40]
                }else{
                  _temp['standard'] = [80,50,50]
                }
              }else if(data.quest_type == 'Feedback'){
                _temp['standard'] = [80,60,60]
              }
            }
            if(data.status == 'open'){
              _temp['score'] = data.previous
              _temp['status'] = 'Pending'
            }else if(data.status == 'accept'){
              _temp['score'] = data.previous
              _temp['status'] = 'Active'
            }else if(data.status == 'congrat'){
              _temp['score'] = data.goal ? data.goal : data.previous
              _temp['status'] = 'Completed'
            }else if(data.status == 'tryagain'){
              _temp['score'] = data.notgoal ? data.notgoal : data.previous
              _temp['status'] = 'Try Again'
            }else if(data.status == 'close'){
              _temp['score'] = data.previous
              _temp['status'] = 'Close'
            }
            _temp['score'] = Math.round(Number(_temp['score'])) > 100 ? 100 : Math.round(Number(_temp['score']))
            modalData['coaching'].push(_temp)
          });
          commit('loadingCoaching', false);
          commit('setModalCoachingData', modalData)
        });
    },
    getChangeChartType({ commit, dispatch, rootState, state }: any, selectChart: any) {
      commit('loadingManager', true);
      let data:any = state.datalistAll
      let _data:Array<any> = []
      for (const i in data) {
        if(selectChart=='vs Open Rate'){
          data[i].y= data[i].open_rate?data[i].open_rate:0
        }else{
          data[i].y=state.dataQualitybyTeam[data[i].email]?state.dataQualitybyTeam[data[i].email].replyQuality:0;
        }
        _data.push(data[i])
      }

      commit("setDataListSearchAll", _data);
      commit('loadingManager', false);
    },
    async getPeerFeedbackHistory({ commit, dispatch, rootState, state }: any, val: any) {
      //console.log('getPeerFeedbackHistory',val)
      const datePrevious=format(subMonths(new Date(),5),"YYYY-MM-01")
      //console.log('datePrevious',datePrevious)
      const peerFeedbackHistory={}
      const querySnapshot=await firebase.firestore().collection('users_questions').where("company", "==",val.company).where("quest_id","==",'-L1u2Xa5_pSCnitgF3u6').where("date",">=",datePrevious).where("date","<=",format(new Date(),'YYYY-MM-DD')).get()


      for(const _data of querySnapshot.docs){
        const data=_data.data()
        
        const date=format(data.date,'YYYY-MM')  
        if(!peerFeedbackHistory[data.users]){
          peerFeedbackHistory[data.users]={}
        }
        if(!peerFeedbackHistory[data.users][date]){
          peerFeedbackHistory[data.users][date]=0
        }
        if(data.answer){
                                    
          peerFeedbackHistory[data.users][date]+=data.answer.length
      }
      }
      commit('setPeerFeedbackHistory',peerFeedbackHistory)



    },

    // Calculate historical proactivity and psychological safety ratings for the last 3 months
    // TODO: ENGINEER VERIFICATION NEEDED
    // ==================================
    // This function calculates historical metrics from Firebase data. Please verify:
    // 1. The date filtering logic is working correctly (checking docDate >= startDate && docDate <= endDate)
    // 2. The calculated monthly values match what the current/overall scores show for the same time period
    // 3. The component calculations (feedback, conversation, peer, performance, psychological) use the correct formulas
    // 4. The weighted formulas match the current calculation exactly
    // 5. Edge cases: What happens when there's no data for a month? Should it be 0 or excluded?
    // 6. The peer feedback calculation - verify if it should be binary (100/0) or percentage-based
    //
    // To verify: Compare the "Overall Rating" with the chart's "current month" value - they should be similar
    // if measuring overlapping time periods. If they're significantly different, investigate the calculation.
    async getHistoricalProactivityRatings({ commit, dispatch, rootState, state }: any, payload: any = {}) {
      try {
        const selectedteam=state.selectedteam?state.selectedteam:state.teamHeight
        let dataThisMonth:any={}
        if(!state.dataThisMonth || Object.keys(state.dataThisMonth).length === 0){
          dataThisMonth=await dispatch('getPsychologicalTrendDataThisMonth')
        }else{
          dataThisMonth=state.dataThisMonth

        }
        
        const trendData=await dispatch('getProactivityTrendData')
        const dataThisMonthSelected=dataThisMonth&&dataThisMonth[selectedteam]?dataThisMonth[selectedteam]:null
        console.log('trendData',trendData)
        console.log('dataThisMonthSelected',dataThisMonthSelected)
        const historicalRatings:any=[]
        for(let i=2;i>=0;i--){
          const month=format(subMonths(new Date(),i),'YYYY-MM')
          if(i==0){
            historicalRatings.push({
              month: month,
              rating:dataThisMonthSelected.proactivity,
              psychologicalSafety: dataThisMonthSelected.safetyRating,
              
          })

          }else{
            historicalRatings.push({
              month: month,
              rating: trendData[month].proactivity,
              psychologicalSafety: trendData[month].safetyRating,
              
            })

          }
          
      }
    return historicalRatings

        //commit('setProactivityTrendData',{trendData:trendData[selectedteam],dataThisMonthSelected:dataThisMonthSelected})


        

        // // Get the last 3 complete months
        // const now = new Date();
        // const months: Array<{startDate: string, endDate: string, label: string}> = [];
        // for (let i = 2; i >= 0; i--) {
        //   const monthDate = subMonths(now, i);
        //   const startDate = format(new Date(monthDate.getFullYear(), monthDate.getMonth(), 1), 'YYYY-MM-DD');
        //   const endDate = format(lastDayOfMonth(monthDate), 'YYYY-MM-DD');
        //   months.push({ startDate, endDate, label: format(monthDate, 'MMM') });
        // }

        // // Calculate the earliest date we need (3 months ago)
        // const earliestDate = months[0].startDate;
        // console.log(`🔍 Fetching data from ${earliestDate} onwards for company: ${company}`);

        // // Fetch all data once with simple queries (no composite indexes needed)
        // // Then filter in memory by month and date

        // // 1. Fetch all feedback data for the company (filter by date in memory)
        // const allFeedbackSnapshot = await firebase.firestore().collection('insight_manager_today')
        //   .where('company', '==', company)
        //   .where('type', '==', 'feedback')
        //   .get();

        // // 2. Fetch all team conversation data for the period
        // const allTeamSnapshot = await firebase.firestore().collection('insight_manager_team')
        //   .where('company_id', '==', company)
        //   .get();

        // // 3. Fetch all peer feedback data for the period
        // const allPeerFeedbackSnapshot = await firebase.firestore().collection('users_questions')
        //   .where('company', '==', company)
        //   .where('quest_id', '==', '-L1u2Xa5_pSCnitgF3u6')
        //   .get();

        // // 4. Fetch all performance reviews for the period
        // const allReviewSnapshot = await firebase.firestore().collection('send_review_gem')
        //   .where('company', '==', company)
        //   .get();

        // console.log(`📦 Fetched ${allFeedbackSnapshot.size} feedback docs, ${allTeamSnapshot.size} team docs, ${allPeerFeedbackSnapshot.size} peer docs, ${allReviewSnapshot.size} review docs`);

        // Calculate proactivity for each month by filtering in memory
        //const historicalRatings: Array<any> = [];

        // for (const month of months) {
        //   console.log(`🔍 Calculating data for ${month.label}: ${month.startDate} to ${month.endDate}`);

        //   // 1. Filter and calculate Feedback Reply Rate for this month
        //   const feedbackByEmail: any = {};
        //   allFeedbackSnapshot.forEach((doc) => {
        //     const data = doc.data();
        //     const docDate = data.date;
        //     // Filter by date range in memory
        //     if (docDate >= month.startDate && docDate <= month.endDate) {
        //       const userEmail = data.email;
        //       if (!feedbackByEmail[userEmail]) {
        //         feedbackByEmail[userEmail] = { read: 0, receive: 0 };
        //       }
        //       feedbackByEmail[userEmail].read += data.read || 0;
        //       feedbackByEmail[userEmail].receive += data.receive || 0;
        //     }
        //   });

        //   // Calculate average feedback reply rate across all managers
        //   let managerFeedbackCount = 0;
        //   let totalFeedbackRate = 0;
        //   for (const userEmail in feedbackByEmail) {
        //     const fb = feedbackByEmail[userEmail];
        //     if (fb.receive > 0) {
        //       managerFeedbackCount++;
        //       totalFeedbackRate += Math.min(100, (fb.read / fb.receive) * 100);
        //     }
        //   }
        //   const avgFeedbackReplyRate = managerFeedbackCount > 0 ? totalFeedbackRate / managerFeedbackCount : 0;

        //   // 2. Filter and calculate Conversation Initiated + Psychological Safety data for this month
        //   let totalConversationInitiated = 0;
        //   let conversationManagerCount = 0;

        //   // Psychological Safety aggregates
        //   let totalOpenEnd = 0;
        //   let totalOpenEndAll = 0;
        //   let totalNotToSay = 0;
        //   let totalSkipTotal = 0;
        //   let totalAnonymous = 0;
        //   let totalSuperFeedback = 0;
        //   let totalFeedbackCount = 0;

        //   allTeamSnapshot.forEach((doc) => {
        //     const data = doc.data();
        //     const docDate = data.date;
        //     // Filter by date range in memory
        //     if (docDate >= month.startDate && docDate <= month.endDate) {
        //       // Conversation Initiated
        //       if (data.open_end_boss >= 0 && data.open_end_all_boss > 0) {
        //         conversationManagerCount++;
        //         const conversationRate = Math.min(100, (data.open_end_boss / data.open_end_all_boss) * 100);
        //         totalConversationInitiated += conversationRate;
        //       }

        //       // Psychological Safety components
        //       totalOpenEnd += data.open_end || 0;
        //       totalOpenEndAll += data.open_end_all || 0;
        //       totalNotToSay += data.not_to_say || 0;
        //       totalSkipTotal += data.skip_total || 0;
        //       totalAnonymous += data.anonymous || 0;
        //       totalSuperFeedback += data.super_feedback || 0;
        //       totalFeedbackCount += data.feedback || 0;
        //     }
        //   });
        //   const avgConversationInitiated = conversationManagerCount > 0 ? totalConversationInitiated / conversationManagerCount : 0;

        //   // Calculate Psychological Safety Rating using the same algorithm as current
        //   const openEndedFeedback = totalOpenEndAll > 0 ? Math.round((totalOpenEnd / totalOpenEndAll) * 100) : 0;
        //   const notToSayRatio = totalSkipTotal > 0 ? Math.round((totalNotToSay / totalSkipTotal) * 100) : 0;
        //   const anonymousPercent = totalOpenEndAll > 0 ? Math.round((totalAnonymous / totalOpenEndAll) * 100) : 0;
        //   const superFeedbackRate = totalFeedbackCount > 0 ? Math.round((totalSuperFeedback / totalFeedbackCount) * 100) : 0;

        //   const participation = Math.min(100, openEndedFeedback);
        //   const skipPenalty = Math.max(0, 100 - Math.min(100, notToSayRatio * 2));
        //   const anonPenalty = Math.max(0, 100 - Math.min(100, anonymousPercent * 1.5));
        //   const recognition = Math.min(100, superFeedbackRate);

        //   const participationIdx = (0.6 * participation) + (0.4 * skipPenalty);
        //   const voiceSafetyIdx = (0.7 * anonPenalty) + (0.3 * recognition);
        //   const psychologicalSafetyRating = Math.max(0, Math.min(100, Math.round((0.55 * participationIdx) + (0.45 * voiceSafetyIdx))));

        //   console.log(`   Psychological Safety for ${month.label}: ${psychologicalSafetyRating} (open:${openEndedFeedback}, skip:${notToSayRatio}, anon:${anonymousPercent}, super:${superFeedbackRate})`);

        //   // 3. Filter and calculate Peer Feedback for this month
        //   const peerFeedbackByUser: any = {};
        //   let peerDocsInDateRange = 0;
        //   allPeerFeedbackSnapshot.forEach((doc) => {
        //     const data = doc.data();
        //     const docDate = data.date;
        //     // Filter by date range in memory
        //     if (docDate >= month.startDate && docDate <= month.endDate) {
        //       peerDocsInDateRange++;
        //       const users = data.users;
        //       if (!peerFeedbackByUser[users]) {
        //         peerFeedbackByUser[users] = 0;
        //       }
        //       peerFeedbackByUser[users]++;
        //     }
        //   });

        //   console.log(`   Peer docs in ${month.label} date range: ${peerDocsInDateRange} out of ${allPeerFeedbackSnapshot.size} total`);

        //   // Convert to percentage (1+ requests = 100%, 0 = 0%)
        //   let totalPeerFeedback = 0;
        //   let peerFeedbackManagerCount = 0;
        //   let managersWithPeerFeedback = 0;
        //   for (const key in results) {
        //     const val = results[key];
        //     peerFeedbackManagerCount++;
        //     const peerCount = peerFeedbackByUser[val.email] || 0;
        //     if (peerCount > 0) {
        //       managersWithPeerFeedback++;
        //       totalPeerFeedback += 100;
        //     }
        //   }
        //   const avgPeerFeedback = peerFeedbackManagerCount > 0 ? totalPeerFeedback / peerFeedbackManagerCount : 0;

        //   console.log(`   Peer feedback for ${month.label}: ${managersWithPeerFeedback}/${peerFeedbackManagerCount} managers have peer feedback (${Math.round(avgPeerFeedback)}%)`);
        //   console.log(`   Unique users in peerFeedbackByUser:`, Object.keys(peerFeedbackByUser).slice(0, 5), '... total:', Object.keys(peerFeedbackByUser).length);

        //   // 4. Filter and calculate Performance Reviews for this month
        //   const reviewsByManager: any = {};
        //   allReviewSnapshot.forEach((doc) => {
        //     const data = doc.data();
        //     const docDate = data.createdate;
        //     // Filter by date range in memory
        //     if (docDate >= month.startDate && docDate <= month.endDate) {
        //       const manager = data.reviewer;
        //       if (!reviewsByManager[manager]) {
        //         reviewsByManager[manager] = { completed: 0, total: 0 };
        //       }
        //       reviewsByManager[manager].total++;
        //       if (data.status === 'completed' || data.completed) {
        //         reviewsByManager[manager].completed++;
        //       }
        //     }
        //   });

        //   let totalReviewRate = 0;
        //   let reviewManagerCount = 0;
        //   for (const manager in reviewsByManager) {
        //     reviewManagerCount++;
        //     const rate = reviewsByManager[manager].total > 0
        //       ? Math.min(100, (reviewsByManager[manager].completed / reviewsByManager[manager].total) * 100)
        //       : 0;
        //     totalReviewRate += rate;
        //   }
        //   const avgReviewCompleted = reviewManagerCount > 0 ? totalReviewRate / reviewManagerCount : 0;

        //   // Calculate proactivity rating using the weighted formula
        //   const feedbackComponent = avgFeedbackReplyRate / 100 * 0.35;
        //   const conversationComponent = avgConversationInitiated / 100 * 0.3;
        //   const peerComponent = avgPeerFeedback / 100 * 0.2;
        //   const performanceComponent = avgReviewCompleted / 100 * 0.15;
        //   const proactivityRating = Math.round((feedbackComponent + conversationComponent + peerComponent + performanceComponent) * 100);

        //   historicalRatings.push({
        //     month: month.label,
        //     startDate: month.startDate,
        //     endDate: month.endDate,
        //     rating: proactivityRating,
        //     psychologicalSafety: psychologicalSafetyRating,
        //     components: {
        //       feedbackReplyRate: Math.round(avgFeedbackReplyRate),
        //       conversationInitiated: Math.round(avgConversationInitiated),
        //       peerFeedback: Math.round(avgPeerFeedback),
        //       performanceReview: Math.round(avgReviewCompleted)
        //     },
        //     psychologicalComponents: {
        //       openEndedFeedback,
        //       notToSayRatio,
        //       anonymousPercent,
        //       superFeedbackRate,
        //       participationIndex: Math.round(participationIdx),
        //       voiceSafetyIndex: Math.round(voiceSafetyIdx)
        //     }
        //   });

        //   console.log(`📊 Historical Proactivity for ${month.label} (${month.startDate} to ${month.endDate}):`, {
        //     rating: proactivityRating,
        //     feedback: Math.round(avgFeedbackReplyRate),
        //     conversation: Math.round(avgConversationInitiated),
        //     peer: Math.round(avgPeerFeedback),
        //     performance: Math.round(avgReviewCompleted),
        //     feedbackManagers: Object.keys(feedbackByEmail).length,
        //     conversationManagers: conversationManagerCount,
        //     peerFeedbackManagers: Object.keys(peerFeedbackByUser).length,
        //     reviewManagers: Object.keys(reviewsByManager).length
        //   });
        // }

        // console.log('📈 Final historical ratings:', historicalRatings);
        // return historicalRatings;
      } catch (error) {
        console.error('Error calculating historical proactivity ratings:', error);
        return [];
      }
    },
    async getProactivityTrendData({ commit, dispatch, rootState, state }: any) {
      const trendData={}
      const selectedteam=state.selectedteam?state.selectedteam:state.teamHeight
      console.log('selectedteam',selectedteam)
      const past2month=format(endOfMonth(subMonths(new Date(),2)),"YYYY-MM-DD")
      const past1month=format(endOfMonth(subMonths(new Date(),1)),"YYYY-MM-DD")
      const past=[past2month,past1month]
      const data=await firebase.firestore().collection('proactivity_psychological_rating').where("date","in",past).where("team_id", "==",selectedteam).get()


      for(const _data of data.docs){
        const data=_data.data()
        const date=format(data.date,'YYYY-MM')
        if(!trendData[date]){
          trendData[date]={
            proactivity:0,
            safetyRating:0,
          
          }
        }
        console.log(data)
        trendData[date].proactivity=data.proactivity
        trendData[date].safetyRating=data.psychological
      }
      
      console.log('trendData',trendData)
      return trendData
    },


    // async getProactivityTrendData({ commit, dispatch, rootState, state }: any) {
    //   const trendData={}
    //   const selectedteam=state.selectedteam?state.selectedteam:state.teamHeight
    //   const past2month=format(endOfMonth(subMonths(new Date(),2)),"YYYY-MM-DD")
    //   const past1month=format(endOfMonth(subMonths(new Date(),1)),"YYYY-MM-DD")
    //   const past=[past2month,past1month]
    //   const pastMonth=format(subMonths(new Date(),2),'YYYY-MM-01')
    //   const data=await firebase.firestore().collection('proactivity_psychological_rating').where("team_id", "==",selectedteam).get()


    //   for(const _data of data.docs){
    //     const data=_data.data()
    //     const date=format(data.date,'YYYY-MM')
    //     if(format(data.date,'YYYY-MM-DD')>=pastMonth){
    //       if(!trendData[date]){
    //         trendData[date]={
    //           proactivity:0,
    //           psychological:0,
            
    //         }
    //       }
    //       console.log(data)
    //       trendData[date].proactivity=data.proactivity
    //       trendData[date].psychological=data.psychological
    //     }
    //   }
      
    //   console.log('trendData',trendData)
    //   return trendData
    // },


    async getPsychologicalTrendDataThisMonth({ commit, dispatch, rootState, state }: any) {
      console.log('getPsychologicalTrendDataThisMonth')
      const thisMonth=format(new Date(),'YYYY-MM-01')
      const com_id=rootState.authen.user.company
      const users=await getUserAll(com_id)
      const _boss=_.groupBy(users,'boss')
      const reviewData=state.dataQualitybyTeam
      
      
      const organization1levelSnapshot = await firebase.firestore().collection('organization1level').where("company", "==", com_id).get()
      const organization1level: any = {}
      organization1levelSnapshot.forEach((doc) => {
        const data = doc.data()
        if(!organization1level[data.team_id]){
          organization1level[data.team_id] = data.parent
        }
        
      })


      //feedback
      const promises2=new Promise(async (resolve,reject)=>{
        const dataThirty:any=[]
        firebase.firestore().collection('insight_manager_today').where('company', '==', com_id).where("date", ">=",thisMonth).get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(async function (doc) {
                const data = doc.data()
                if(data.type=="feedback"){
                  
                  dataThirty.push(data)
                }
              }); 
              resolve(dataThirty)
            });

      })


      //open end data
      const promises3=new Promise(async (resolve,reject)=>{
        
        const openEndData:any=[]
        firebase.firestore().collection('users_questions').where('company', '==', com_id).where("date", ">=",thisMonth).where("type","==","Text Area Field").get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(async function (doc) {
                const data = doc.data()
                
                  const emailKey=data.users.replace(/\./g, "||");
                  if(users&&users[emailKey] !==null && users[emailKey] !==undefined){
                      const _emailKey=users[emailKey].boss.replace(/\./g, "||");
                      if(_emailKey&&data.status=="close"){
                          if(!openEndData[`${users[emailKey].boss}`]){
                              openEndData[`${users[emailKey].boss}`]={
                                  not_to_say:0,
                                  skip_total:0,
                                  open_end:0,
                                  open_end_all:0,
                                  anonymous:0,
                                  open_end_boss:0,
                                  open_end_all_boss:0
                              
                              }
                          }
                          if(data.tag=="FOLLOW-UP"){
                              if(data.answer=="I prefer not to answer, sorry."){
                                  openEndData[`${users[emailKey].boss}`].not_to_say++
                                  openEndData[`${users[emailKey].boss}`].skip_total++
                              
                              }else if(!data.answer){
                                  openEndData[`${users[emailKey].boss}`].skip_total++
                              }
                          }
                          if(data.send_anonymous==1){
                              openEndData[`${users[emailKey].boss}`].anonymous++
                              }
                          if(data.tag !== 'FOLLOW-UP'){
                              if(data.answer){
                                  openEndData[`${users[emailKey].boss}`].open_end++
                                  }
                                  openEndData[`${users[emailKey].boss}`].open_end_all++
                          }

                      }else if(_emailKey&&data.read&&data.tag !== 'FOLLOW-UP'){
                          if(!openEndData[`${users[emailKey].boss}`]){
                              openEndData[`${users[emailKey].boss}`]={
                                  not_to_say:0,
                                  skip_total:0,
                                  open_end:0,
                                  open_end_all:0,
                                  anonymous:0,
                                  open_end_boss:0,
                                  open_end_all_boss:0
                              
                              }
                          }
                          openEndData[`${users[emailKey].boss}`].open_end_all++
                      }
                  }


                  if(_boss[data.users]&&data.tag !== 'FOLLOW-UP'&&data.status=="close"){
                      if(!openEndData[`${data.users}`]){
                          openEndData[`${data.users}`]={
                                  not_to_say:0,
                                  skip_total:0,
                                  open_end:0,
                                  open_end_all:0,
                                  anonymous:0,
                                  open_end_boss:0,
                                  open_end_all_boss:0
                          }
                          
                      }
                      if(data.answer){
                          if(!openEndData[`${data.users}`].open_end_boss){
                              openEndData[`${data.users}`].open_end_boss=0
                          }
                          openEndData[`${data.users}`].open_end_boss++
                          
                      }
                      if(!openEndData[`${data.users}`].open_end_all_boss){
                          openEndData[`${data.users}`].open_end_all_boss=0
                      }
                      openEndData[`${data.users}`].open_end_all_boss++
                  }else if(_boss[data.users]&&data.tag !== 'FOLLOW-UP'&&data.read){
                      if(!openEndData[`${data.users}`]){
                          openEndData[`${data.users}`]={
                                  not_to_say:0,
                                  skip_total:0,
                                  open_end:0,
                                  open_end_all:0,
                                  anonymous:0,
                                  open_end_boss:0,
                                  open_end_all_boss:0
                          }
                          
                      }
                      openEndData[`${data.users}`].open_end_all_boss++
                  }



              
              }); 
              resolve(openEndData)
            });

      })


      //peer feedback data
      const promises4=new Promise(async (resolve,reject)=>{
        const peerFeedbackData:any=[]
        firebase.firestore().collection('users_questions').where('company', '==', com_id).where("date", ">=",thisMonth).where("quest_id","==","-L1u2Xa5_pSCnitgF3u6").get()
            .then(function (querySnapshot) {
              querySnapshot.forEach(async function (doc) {
                  const data = doc.data()
                  const emailKey_boss=data.users.replace(/\./g, "||");
                 //console.log('data',data)
                  if(_boss[data.users]){
                    if(!peerFeedbackData[`${data.users}`]){
                        peerFeedbackData[`${data.users}`]={peerFeedback:0,peerFeedbackRate:0}
                    }
              
                    if(data.answer){
                      
                          peerFeedbackData[`${data.users}`].peerFeedback+=data.answer.length
                    }
                        
                  }
              });
              for(const email in peerFeedbackData){
                peerFeedbackData[email].peerFeedbackRate=peerFeedbackData[email].peerFeedback>0?100:0
              }
             
              resolve(peerFeedbackData)
            });
      })

       //response
       const promise5 =new Promise((resolve, reject) => {
        const responseData={}
        firebase.firestore().collection('messages').where("company", "==", com_id).where("createdate",">=",thisMonth).get()
        .then(async function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
            const data = doc.data()
            const emailKey=data.user.replace(/\./g, "||")
            const company_id=data.company
            const date=format(data.createdate,'YYYY-MM-DD')     
            if(users&&users[emailKey]){
                const _emailKey=users[emailKey].boss.replace(/\./g, "||");
                if(data.answers&&data.answers.length>1){
                    if(data.answers[1].user==users[emailKey].boss){
                    if(!responseData[`${users[emailKey].boss}`]){
                        responseData[`${users[emailKey].boss}`]={
                            response:0,
                            total_response:0,
                            TotalRES:0,
                            TotalRES_time:0,
                        }
                    } 

                    responseData[`${users[emailKey].boss}`].total_response++
                    const result = differenceInHours(new Date(data.answers[1].date),new Date(data.answers[0].date))
                    responseData[`${users[emailKey].boss}`].response+=result
                 
                        if(data.replyinsights&&data.replyinsights.TotalRES){
                           
                            responseData[`${users[emailKey].boss}`].TotalRES+=data.replyinsights.TotalRES
                        }
                        
                        responseData[`${users[emailKey].boss}`].TotalRES_time++
                       
                    }
                  
                }
               
            }
            
            
            
        })
            resolve(responseData)
        })





        
    })

     return await Promise.all([promises2,promises3,promises4,promise5]).then(async (values)=>{
        
        const data2:any=values[0]
        const data3:any=values[1]
        const data4:any=values[2]
        
        const response:any=values[3]
        const team=await getTeamByCompany(rootState.authen.user.company)
        const bossmaster=(await firebase.database().ref(`/boss/${rootState.authen.user.company}`).once('value')).val();
        const dataThisMonth:any={}
       
        const datasafetyRating:any={}
        for(const key in team){

            if(!datasafetyRating[key]){
              datasafetyRating[key]={
                  notToSay:0,
                  skip_total:0,
                  notToSayRatio:0,
                  openEndedFeedback:0,
                  openEnd:0,
                  openEndAll:0,
                  superFeedbackRate:0,
                  super_feedback:0,
                  feedback:0,
                  anonymousPercent:0,
                  anonymous:0,
                  feedbackRate:0,
                  superFeedback:0,
                  skip:0,
                  safetyRating:0,
                  TotalRES:0,
                  TotalRES_time:0,
                  
              }
            }
            let totalfeedback:any=0
            let totalreviewCompleted:any=0
            let totalconversation:any=0
            let totalPeerFeedback:any=0
            let totalManager:any=0
            let avg={
                    feedback:0,
                    reviewCompleted:0,
                    conversation:0,
                    peerFeedback:0,
            }
            let feedback_read=0
            let feedback_receive=0
            if(organization1level[key]){
              
              for(const i in organization1level[key]){
                const feedback=_.filter(data2, { team: i })
                for(const j in feedback){
                  feedback_read+=Number(feedback[j].read)
                  feedback_receive+=Number(feedback[j].receive)
                }
                const boss=_.filter(bossmaster, { team: i })
               
                if(boss.length>0){
                  totalManager=totalManager+1
                  const email=boss[0].boss
                  const calculatedReviewCompleted=reviewData[email]&&reviewData[email].performance_review.reviewCompleted?Number(reviewData[email].performance_review.reviewCompleted/Object.keys(_boss).length):0
                  totalreviewCompleted=totalreviewCompleted+(isNaN(calculatedReviewCompleted)?0:Number(calculatedReviewCompleted.toFixed()))


                  let conversation_boss_open_end:any=0
                  let conversation_boss_open_end_all:any=0
                  if(data3&&data3[email]){
                    
                    conversation_boss_open_end=conversation_boss_open_end+Number(data3[email].open_end_boss)
                    conversation_boss_open_end_all=conversation_boss_open_end_all+Number(data3[email].open_end_all_boss)
                  }
                  const conversation_boss=conversation_boss_open_end*100/conversation_boss_open_end_all
                  totalconversation=totalconversation+(isNaN(conversation_boss)?0:Number(conversation_boss.toFixed()))
                  




                  const peerFeedbackCount = data4&&data4[email]&&data4[email].peerFeedbackRate?(Number(data4[email].peerFeedbackRate)):0
                  totalPeerFeedback=totalPeerFeedback+(isNaN(peerFeedbackCount)?0:Number(peerFeedbackCount.toFixed()))


                  


                  if(data3&&data3[email]){
               
                    datasafetyRating[key].notToSay=datasafetyRating[key].notToSay+data3[email].not_to_say
                    datasafetyRating[key].skip_total=datasafetyRating[key].skip_total+data3[email].skip_total
                    datasafetyRating[key].openEnd=datasafetyRating[key].openEnd+data3[email].open_end
                    datasafetyRating[key].openEndAll=datasafetyRating[key].openEndAll+data3[email].open_end_all
                    datasafetyRating[key].super_feedback=datasafetyRating[key].super_feedback+data3[email].super_feedback
                    datasafetyRating[key].feedback=datasafetyRating[key].feedback+data3[email].feedback
                    datasafetyRating[key].anonymous=datasafetyRating[key].anonymous+data3[email].anonymous
                    datasafetyRating[key].TotalRES=datasafetyRating[key].TotalRES+response&&response[email]?response[email].TotalRES:0
                    datasafetyRating[key].TotalRES_time=datasafetyRating[key].TotalRES_time+response&&response[email]?response[email].TotalRES_time:0


                  }











                }


              }
    
              totalfeedback=feedback_read*100/feedback_receive
              avg.feedback=isNaN(totalfeedback)?0:Number(totalfeedback.toFixed())
              avg.reviewCompleted=isNaN(totalreviewCompleted/totalManager)?0:Number(totalreviewCompleted/totalManager.toFixed())
              avg.conversation=isNaN(totalconversation/totalManager)?0:Number(totalconversation/totalManager.toFixed())
              avg.peerFeedback=isNaN(totalPeerFeedback/totalManager)?0:Number(totalPeerFeedback/totalManager.toFixed())
              if(key=='-L0Dg4P9voDNUxuEH8UV'||key=='-L03_NMxjQUY2RAhiemb'){
                console.log('team',team[key].name)
                console.log('totalPeerFeedback',totalPeerFeedback)
                console.log('totalreviewCompleted',totalreviewCompleted)
                console.log('totalManager',totalManager)
                console.log('avg',avg)
              }

              // if(key=='-L0Dg4P9voDNUxuEH8UV'||key=='-L03_NMxjQUY2RAhiemb')
              // console.log('key',key)
              // console.log('avg.feedback',avg.feedback)
              // console.log('avg.reviewCompleted',avg.reviewCompleted)
              // console.log('avg.conversation',avg.conversation)
              // console.log('avg.peerFeedback',avg.peerFeedback)



              const feedbackComponent =  avg.feedback / 100 * 0.35
              const conversationInitiatedComponent = avg.conversation / 100 * 0.3
              const peerFeedbackComponent = avg.peerFeedback / 100 * 0.2
              const performerComponent = avg.reviewCompleted / 100 * 0.15
              const calculatedProactivity = (feedbackComponent + conversationInitiatedComponent + peerFeedbackComponent + performerComponent) * 100

              



              datasafetyRating[key].notToSayRatio=isNaN(datasafetyRating[key].notToSay*100/datasafetyRating[key].skip_total)?0:Math.round(datasafetyRating[key].notToSay*100/datasafetyRating[key].skip_total)
              datasafetyRating[key].openEndedFeedback=isNaN(datasafetyRating[key].openEnd*100/datasafetyRating[key].openEndAll)?0:Math.round(datasafetyRating[key].openEnd*100/datasafetyRating[key].openEndAll)
              datasafetyRating[key].superFeedbackRate=isNaN(datasafetyRating[key].super_feedback*100/datasafetyRating[key].feedback)?0:Math.round(datasafetyRating[key].super_feedback*100/datasafetyRating[key].feedback)
              datasafetyRating[key].anonymousPercent=isNaN(datasafetyRating[key].anonymous*100/datasafetyRating[key].openEndAll)?0:Math.round(datasafetyRating[key].anonymous*100/datasafetyRating[key].openEndAll)
              datasafetyRating[key].feedbackRate=datasafetyRating[key].openEndedFeedback>80?0.8:datasafetyRating[key].openEndedFeedback/100
              datasafetyRating[key].superFeedback=datasafetyRating[key].superFeedbackRate>80?0.8:datasafetyRating[key].superFeedbackRate/100
              // Fix: Check for zero TotalRES_time before division to avoid Infinity -> 100 bug
              datasafetyRating[key].replyQuality=(!datasafetyRating[key].TotalRES_time || datasafetyRating[key].TotalRES_time === 0)?0:((datasafetyRating[key].TotalRES/datasafetyRating[key].TotalRES_time)>100?100:Math.round(datasafetyRating[key].TotalRES/datasafetyRating[key].TotalRES_time))
             


              const participation = Math.min(100,datasafetyRating[key].openEndedFeedback) // Already a percentage
              const skipPenalty = Math.max(0, 100 - Math.min(100, datasafetyRating[key].notToSayRatio * 2)) // Non-linear penalty
              const recognition = Math.min(100, datasafetyRating[key].superFeedbackRate) // Already a percentage

              const participationIdx = (0.6 * participation) + (0.4 * skipPenalty)
              const voiceSafetyIdx = Math.max(0, Math.min(100, 100 - datasafetyRating[key].anonymousPercent)) // Direct inverse of anonymous rate
              let safetyRating = (0.55 * participationIdx) + (0.45 * voiceSafetyIdx)
              safetyRating = Math.max(0, Math.min(100, Math.round(safetyRating)))

              dataThisMonth[key]={
                team:key,
                proactivity:Math.round(calculatedProactivity),
                feedback:avg.feedback,
                reviewCompleted:avg.reviewCompleted,
                conversation:avg.conversation,
                peerFeedback:avg.peerFeedback,
                safetyRating:safetyRating
              }

            }else{


                totalManager=totalManager+1
                const feedback=_.filter(data2, { team: key })
                for(const j in feedback){
                  feedback_read+=Number(feedback[j].read)
                  feedback_receive+=Number(feedback[j].receive)
                }
                const boss=_.filter(users, { team: key })
                
                if(boss.length>0){
                  const email=boss[0].boss
                  const calculatedReviewCompleted=reviewData[email]&&reviewData[email].performance_review.reviewCompleted?Number(reviewData[email].performance_review.reviewCompleted/Object.keys(_boss).length):0
                  totalreviewCompleted=totalreviewCompleted+(isNaN(calculatedReviewCompleted)?0:Number(calculatedReviewCompleted.toFixed()))


                  let conversation_boss_open_end:any=0
                  let conversation_boss_open_end_all:any=0
                  if(data3&&data3[email]){
                    conversation_boss_open_end=conversation_boss_open_end+Number(data3[email].open_end_boss)
                    conversation_boss_open_end_all=conversation_boss_open_end_all+Number(data3[email].open_end_all_boss)
                  }
                  const conversation_boss=conversation_boss_open_end*100/conversation_boss_open_end_all
                  totalconversation=totalconversation+(isNaN(conversation_boss)?0:Number(conversation_boss.toFixed()))





                  const peerFeedbackCount = data4&&data4[email]&&data4[email].peerFeedbackRate?(Number(data4[email].peerFeedbackRate)):0
                  totalPeerFeedback=totalPeerFeedback+(isNaN(peerFeedbackCount)?0:Number(peerFeedbackCount.toFixed()))


                  if(data3&&data3[email]){
                   
                    datasafetyRating[key].notToSay=datasafetyRating[key].notToSay+data3[email].not_to_say
                    datasafetyRating[key].skip_total=datasafetyRating[key].skip_total+data3[email].skip_total
                    datasafetyRating[key].openEnd=datasafetyRating[key].openEnd+data3[email].open_end
                    datasafetyRating[key].openEndAll=datasafetyRating[key].openEndAll+data3[email].open_end_all
                    datasafetyRating[key].super_feedback=datasafetyRating[key].super_feedback+data3[email].super_feedback
                    datasafetyRating[key].feedback=datasafetyRating[key].feedback+data3[email].feedback
                    datasafetyRating[key].anonymous=datasafetyRating[key].anonymous+data3[email].anonymous
                    datasafetyRating[key].TotalRES=datasafetyRating[key].TotalRES+response&&response[email]?response[email].TotalRES:0
                    datasafetyRating[key].TotalRES_time=datasafetyRating[key].TotalRES_time+response&&response[email]?response[email].TotalRES_time:0
                  }











                }
              

          
                totalfeedback=feedback_read*100/feedback_receive
                avg.feedback=isNaN(totalfeedback)?0:Number(totalfeedback.toFixed())
                avg.reviewCompleted=isNaN(totalreviewCompleted/totalManager)?0:Number(totalreviewCompleted/totalManager.toFixed())
                avg.conversation=isNaN(totalconversation/totalManager)?0:Number(totalconversation/totalManager.toFixed())
                avg.peerFeedback=isNaN(totalPeerFeedback/totalManager)?0:Number(totalPeerFeedback/totalManager.toFixed())
                

                const feedbackComponent =  avg.feedback / 100 * 0.35
                const conversationInitiatedComponent = avg.conversation / 100 * 0.3
                const peerFeedbackComponent = avg.peerFeedback / 100 * 0.2
                const performerComponent = avg.reviewCompleted / 100 * 0.15
                const calculatedProactivity = (feedbackComponent + conversationInitiatedComponent + peerFeedbackComponent + performerComponent) * 100

                



                datasafetyRating[key].notToSayRatio=isNaN(datasafetyRating[key].notToSay*100/datasafetyRating[key].skip_total)?0:Math.round(datasafetyRating[key].notToSay*100/datasafetyRating[key].skip_total)
                datasafetyRating[key].openEndedFeedback=isNaN(datasafetyRating[key].openEnd*100/datasafetyRating[key].openEndAll)?0:Math.round(datasafetyRating[key].openEnd*100/datasafetyRating[key].openEndAll)
                datasafetyRating[key].superFeedbackRate=isNaN(datasafetyRating[key].super_feedback*100/datasafetyRating[key].feedback)?0:Math.round(datasafetyRating[key].super_feedback*100/datasafetyRating[key].feedback)
                datasafetyRating[key].anonymousPercent=isNaN(datasafetyRating[key].anonymous*100/datasafetyRating[key].openEndAll)?0:Math.round(datasafetyRating[key].anonymous*100/datasafetyRating[key].openEndAll)
                datasafetyRating[key].feedbackRate=datasafetyRating[key].openEndedFeedback>80?0.8:datasafetyRating[key].openEndedFeedback/100
                datasafetyRating[key].superFeedback=datasafetyRating[key].superFeedbackRate>80?0.8:datasafetyRating[key].superFeedbackRate/100
                // Fix: Check for zero TotalRES_time before division to avoid Infinity -> 100 bug
              datasafetyRating[key].replyQuality=(!datasafetyRating[key].TotalRES_time || datasafetyRating[key].TotalRES_time === 0)?0:((datasafetyRating[key].TotalRES/datasafetyRating[key].TotalRES_time)>100?100:Math.round(datasafetyRating[key].TotalRES/datasafetyRating[key].TotalRES_time))
               
  
  
                const participation = Math.min(100,datasafetyRating[key].openEndedFeedback) // Already a percentage
                const skipPenalty = Math.max(0, 100 - Math.min(100, datasafetyRating[key].notToSayRatio * 2)) // Non-linear penalty
                const recognition = Math.min(100, datasafetyRating[key].superFeedbackRate) // Already a percentage

                const participationIdx = (0.6 * participation) + (0.4 * skipPenalty)
                const voiceSafetyIdx = Math.max(0, Math.min(100, 100 - datasafetyRating[key].anonymousPercent)) // Direct inverse of anonymous rate
                let safetyRating = (0.55 * participationIdx) + (0.45 * voiceSafetyIdx)
                safetyRating = Math.max(0, Math.min(100, Math.round(safetyRating)))

                dataThisMonth[key]={
                  team:key,
                  proactivity:Math.round(calculatedProactivity),
                  feedback:avg.feedback,
                  reviewCompleted:avg.reviewCompleted,
                  conversation:avg.conversation,
                  peerFeedback:avg.peerFeedback,
                  safetyRating:safetyRating
                }
               


            }

        }
        

        console.log('dataThisMonth',dataThisMonth)
        commit('setDataThisMonth',dataThisMonth)
        return dataThisMonth
      })
    },

    // Manager To-do List Actions
    async getManagerTodoList({ commit, state, rootState }: any, forceRefresh: boolean = false) {
      // Check if data is already cached and not forcing refresh
      if (!forceRefresh && Object.keys(state.managerTodoList).length > 0) {
        commit('setLoadingManagerTodos', false);
        return;
      }
      
      commit('setLoadingManagerTodos', true);
      try {
        const company = rootState.authen && rootState.authen.user && rootState.authen.user.company;
        if (!company) {
          console.warn('No company found for manager todo list');
          commit('setLoadingManagerTodos', false);
          return;
        }
        
        // Calculate date 30 days ago for client-side filtering
        const thirtyDaysAgo = format(addDays(new Date(), -30), 'YYYY-MM-DD');
        
        // Query by company only (no composite index needed), filter by date client-side
        // Note: This fetches all historical data once, then caches. Subsequent loads use cache.
        const querySnapshot = await firebase.firestore()
          .collection('report_weekly_manager_ai')
          .where('company', '==', company)
          .get();

        const managerWeeks: { [email: string]: string[] } = {};
        const stripHtml = (html: any) => typeof html === 'string' ? html.replace(/<[^>]*>/g, '').trim() : '';
        
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const email = data.email;
          const weekDate = data.date;
          
          // Skip if missing required fields or older than 30 days
          if (!email || !weekDate) return;
          if (weekDate < thirtyDaysAgo) return;
          
          // Track available weeks per manager
          if (!managerWeeks[email]) {
            managerWeeks[email] = [];
          }
          managerWeeks[email].push(weekDate);
          
          // Store the todo data, filtering out empty action items
          // Also add target="_blank" to all links for security
          const addTargetBlank = (html: string) => 
            html.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
          
          const rawTodoList = Array.isArray(data.todo_list) ? data.todo_list : [];
          const todoList = rawTodoList
            .filter((item: any) => 
              item && item.action && typeof item.action === 'string' && stripHtml(item.action) !== ''
            )
            .map((item: any) => ({
              ...item,
              action: addTargetBlank(item.action)
            }));
          commit('setManagerTodoList', {
            email,
            weekDate,
            data: {
              todoList,
              headline: data.headline || ''
            }
          });
        });
        
        // Set available weeks and select the latest week for each manager
        Object.keys(managerWeeks).forEach((email) => {
          const sortedWeeks = managerWeeks[email].sort().reverse();
          commit('setManagerTodoAvailableWeeks', { email, weeks: sortedWeeks });
          // Set the latest week as selected
          if (sortedWeeks.length > 0) {
            commit('setManagerTodoSelectedWeek', { email, weekDate: sortedWeeks[0] });
          }
        });
        
        commit('setLoadingManagerTodos', false);
      } catch (error) {
        console.error('Error fetching manager todo list:', error);
        commit('setLoadingManagerTodos', false);
      }
    },

    async fetchTodoForWeek({ commit, state, rootState }: any, { email, weekDate }: { email: string, weekDate: string }) {
      // Check if we already have this data cached
      if (state.managerTodoList[email] && state.managerTodoList[email][weekDate]) {
        commit('setManagerTodoSelectedWeek', { email, weekDate });
        return;
      }
      
      try {
        const company = rootState.authen.user.company;
        const querySnapshot = await firebase.firestore()
          .collection('report_weekly_manager_ai')
          .where('company', '==', company)
          .where('email', '==', email)
          .where('date', '==', weekDate)
          .get();
        
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs[0].data();
          // Filter out empty action items - strip HTML tags and check for actual text content
          const stripHtml = (html: any) => typeof html === 'string' ? html.replace(/<[^>]*>/g, '').trim() : '';
          const addTargetBlank = (html: string) => 
            html.replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
          
          const rawTodoList = Array.isArray(data.todo_list) ? data.todo_list : [];
          const todoList = rawTodoList
            .filter((item: any) => 
              item && item.action && typeof item.action === 'string' && stripHtml(item.action) !== ''
            )
            .map((item: any) => ({
              ...item,
              action: addTargetBlank(item.action)
            }));
          commit('setManagerTodoList', {
            email,
            weekDate,
            data: {
              todoList,
              headline: data.headline || ''
            }
          });
          commit('addManagerTodoAvailableWeek', { email, weekDate });
        }
        
        commit('setManagerTodoSelectedWeek', { email, weekDate });
      } catch (error) {
        console.error('Error fetching todo for week:', error);
      }
    },

    selectManagerTodoWeek({ commit }: any, { email, weekDate }: { email: string, weekDate: string }) {
      commit('setManagerTodoSelectedWeek', { email, weekDate });
    },

    /**
     * Load weekly manager responsiveness trend data
     * Fetches insight_manager_today data and aggregates by ISO week
     * Each manager is classified as active/passive/inactive based on their weekly metrics
     */
    async loadWeeklyResponsivenessData({ commit, dispatch, state, rootState }: any) {
      try {
        // Get the selected team for cache key
        const selectedTeam = state.teamSelected || 'all';
        const cacheKey = `weeklyResponsiveness_${selectedTeam}`;
        
        // Check cache first - don't reload if already have data for this team
        if (state.weeklyResponsivenessData && 
            state.weeklyResponsivenessData.length > 0 && 
            state.weeklyResponsivenessCacheKey === cacheKey) {
          return;
        }

        const company = rootState.authen.user.company;
        if (!company) {
          console.warn('No company found for weekly responsiveness data');
          commit('setWeeklyResponsivenessData', []);
          return;
        }

        // Ensure dashboard data is loaded first (same pattern as getDataAll)
        if (!rootState.dashboard.memberAndTeam.users && !rootState.dashboard.memberAndTeam.teams) {
          await dispatch("dashboard/getMemberAndTeam", rootState.authen.user, { root: true });
        }

        // Prefer company-backed thresholds so the trend does not race the main table initialization.
        let companyData = state.companyData;
        if (!companyData || Object.keys(companyData).length === 0) {
          companyData = await getCompany(company);
          commit('setCompanyData', companyData);
        }
        const managerClassification = companyData && companyData.manager_classification
          ? companyData.manager_classification
          : null;

        // Get classification thresholds from state
        const standards = state.standards_data || {};
        const openRate = standards.open_rate || {};
        const feedbackRate = standards.feedback_rate || {};
        const act_open_rate = managerClassification ? managerClassification.active_open_rate : (openRate.active || 0);
        const pass_open_rate = managerClassification ? managerClassification.passive_open_rate : (openRate.passive || 0);
        const act_feedback_rate = managerClassification ? managerClassification.active_feedback_rate : (feedbackRate.active || 40);
        const pass_feedback_rate = managerClassification ? managerClassification.passive_feedback_rate : (feedbackRate.passive || 10);

        // Get all users to filter valid managers
        const memberAndTeam = rootState.dashboard && rootState.dashboard.memberAndTeam ? rootState.dashboard.memberAndTeam : {};
        const allUser = memberAndTeam.users || {};
        const allTeams = memberAndTeam.teams || {};
        
        // Build team hierarchy: for each team, collect all descendant team IDs
        // This allows us to filter users who are in the selected team or any of its children
        const buildTeamDescendants = (parentTeamId: string): Set<string> => {
          const descendants = new Set<string>();
          descendants.add(parentTeamId);
          
          // Find all direct children and recursively add their descendants
          for (const teamId in allTeams) {
            if (allTeams[teamId] && allTeams[teamId].parent === parentTeamId) {
              const childDescendants = buildTeamDescendants(teamId);
              childDescendants.forEach(id => descendants.add(id));
            }
          }
          return descendants;
        };
        
        // Build the set of valid team IDs for the selected team
        const validTeamIds = (selectedTeam && selectedTeam !== 'all') 
          ? buildTeamDescendants(selectedTeam)
          : null;

        // Helper to get ISO week key (YYYY-WW)
        const getWeekKey = (dateStr: string): string => {
          const date = new Date(dateStr);
          const year = date.getFullYear();
          const startOfYear = new Date(year, 0, 1);
          const days = Math.floor((date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000));
          const weekNum = Math.ceil((days + startOfYear.getDay() + 1) / 7);
          return `${year}-W${weekNum.toString().padStart(2, '0')}`;
        };

        // Helper to format week label (just W# for cleaner display)
        const formatWeekLabel = (weekKey: string): string => {
          const [, week] = weekKey.split('-W');
          return `W${parseInt(week)}`;
        };

        // Fetch last 56 days of data (8 weeks) for trend visualization
        const startDate = format(addDays(new Date(), -56), 'YYYY-MM-DD');
        const today = format(new Date(), 'YYYY-MM-DD');

        const querySnapshot = await firebase.firestore()
          .collection('insight_manager_today')
          .where('company', '==', company)
          .where('date', '>=', startDate)
          .where('date', '<=', today)
          .orderBy('date')
          .get();

        // Group data by week and then by manager
        // Structure: { weekKey: { email: { read_feedback, receive_feedback, read_daily, receive_daily, read_weekly, receive_weekly } } }
        const weeklyManagerData: Record<string, Record<string, any>> = {};
        const allWeeks = new Set<string>();
        const allManagersInPeriod = new Set<string>(); // Track ALL managers who appear in any week

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          const emailKey = data.email ? data.email.replace(/\./g, '||') : '';
          
          // Only include valid users (not placeholders)
          if (!emailKey || !allUser[emailKey] || allUser[emailKey].placeholder) {
            return;
          }
          
          // Filter by selected team if not "all"
          if (validTeamIds) {
            const userData = allUser[emailKey];
            const userTeam = (userData && userData.team) ? userData.team : '';
            
            // Check if user's team is in the valid team hierarchy
            if (!validTeamIds.has(userTeam)) {
              // User is not in the selected team hierarchy - exclude them
              return;
            }
          }

          // Track this manager as part of the consistent set
          allManagersInPeriod.add(data.email);

          const weekKey = getWeekKey(data.date);
          allWeeks.add(weekKey);

          if (!weeklyManagerData[weekKey]) {
            weeklyManagerData[weekKey] = {};
          }

          if (!weeklyManagerData[weekKey][data.email]) {
            weeklyManagerData[weekKey][data.email] = {
              read_feedback: 0,
              receive_feedback: 0,
              read_report_daily_boss: 0,
              receive_report_daily_boss: 0,
              read_report_weekly_boss: 0,
              receive_report_weekly_boss: 0,
            };
          }

          const managerData = weeklyManagerData[weekKey][data.email];
          
          // Handle read > receive error
          const read = data.read > data.receive ? data.receive : data.read;
          const receive = data.receive;

          if (data.type === 'feedback') {
            managerData.read_feedback += read;
            managerData.receive_feedback += receive;
          } else if (data.type === 'report_daily_boss') {
            managerData.read_report_daily_boss += read;
            managerData.receive_report_daily_boss += receive;
          } else if (data.type === 'report_weekly_boss') {
            managerData.read_report_weekly_boss += read;
            managerData.receive_report_weekly_boss += receive;
          }
        });

        // Sort weeks chronologically
        const sortedWeeks = Array.from(allWeeks).sort();
        
        // Get current week key to exclude incomplete data
        const currentWeekKey = getWeekKey(today);
        
        // Filter out the current week (incomplete data would be misleading)
        const completedWeeks = sortedWeeks.filter(weekKey => weekKey !== currentWeekKey);
        
        // Get the consistent manager count (all managers who appear in any week)
        const consistentManagerCount = allManagersInPeriod.size;
        const allManagerEmails = Array.from(allManagersInPeriod);

        // Calculate classifications for each week using consistent manager set
        const weeklyResponsivenessData = completedWeeks.map((weekKey) => {
          const weekData = weeklyManagerData[weekKey] || {};
          let active = 0;
          let passive = 0;
          let inactive = 0;

          // Iterate through ALL managers, not just those with data this week
          allManagerEmails.forEach((email) => {
            const m = weekData[email];
            
            // If manager has no data for this week, count as inactive (minimal)
            if (!m) {
              inactive++;
              return;
            }

            // Calculate feedback rate
            let feedback = 100;
            if (m.receive_feedback > 0) {
              feedback = (m.read_feedback / m.receive_feedback) * 100;
              if (feedback > 100) feedback = 100;
            }

            // Calculate open rate (weighted: daily * 5 + weekly) / 6
            let report_daily_boss = 0;
            let report_weekly_boss = 0;
            if (m.receive_report_daily_boss > 0) {
              report_daily_boss = (m.read_report_daily_boss / m.receive_report_daily_boss) * 100;
              if (report_daily_boss > 100) report_daily_boss = 100;
            }
            if (m.receive_report_weekly_boss > 0) {
              report_weekly_boss = (m.read_report_weekly_boss / m.receive_report_weekly_boss) * 100;
              if (report_weekly_boss > 100) report_weekly_boss = 100;
            }

            const dailyData = Math.round(report_daily_boss);
            const weeklyData = Math.round(report_weekly_boss);
            const open_rate = ((dailyData * 5 + weeklyData)) / 6;

            // Classify manager based on thresholds
            const feedbackRounded = Math.round(feedback);
            const hasNoFeedback = m.receive_feedback === 0;

            if (open_rate >= act_open_rate && feedbackRounded >= act_feedback_rate) {
              // Special case: no feedback data and thresholds are 0
              if (hasNoFeedback && act_open_rate === 0 && pass_open_rate === 0) {
                passive++;
              } else {
                active++;
              }
            } else if (open_rate >= pass_open_rate && feedbackRounded >= pass_feedback_rate) {
              passive++;
            } else {
              inactive++;
            }
          });

          return {
            weekKey,
            weekLabel: formatWeekLabel(weekKey),
            active,
            passive,
            inactive,
            total: active + passive + inactive,
          };
        });

        commit('setWeeklyResponsivenessData', { data: weeklyResponsivenessData, cacheKey });
      } catch (error) {
        console.error('Error loading weekly responsiveness data:', error);
        commit('setWeeklyResponsivenessData', []);
      }
    }

  },
  getters: {
    datalistAll: ({ datalistAll }) => {
      return datalistAll
    },
    datalistSearchAll: ({ datalistSearchAll }) => {
      return datalistSearchAll
    },
    datalist: ({ datalist }) => {
      return datalist
    },
    inputSearchManager: ({ inputSearchManager }) => {
      return inputSearchManager
    },
    managerResults: ({ managerResults }) => {
      return managerResults
    },
    activeOverview: ({ activeOverview }) => {
      return activeOverview
    },
    teamList: (state: any) => {
      return state.teamList;
    },
    loadingManager: (state: any) => {
      return state.loadingManager;
    },
    loadingCoaching: (state: any) => {
      return state.loadingCoaching;
    },
    modalCoachingData: (state: any) => {
      return state.modalCoachingData;
    },
    getInsightsOpenRateSetting: (state: any) => {
      return state.insightsOpenRateSetting;
    },
    getFeedbackReplyRateSetting: (state: any) => {
      return state.feedbackReplyRateSetting;
    },
    tabManager: (state: any) => {
      return state.tabManager;
    },
    loadingManagerOverview: (state: any) => {
      return state.loadingManagerOverview;
    },
    _activeOverview: (state: any) => {
      return state._activeOverview;
    },
    loadingManagerNudges:(state: any) => {
      return state.loadingManagerNudges;
    },
    nudges:(state: any) => {
      return state.nudges;
    },
    loadingManagerInsight:(state: any) => {
      return state.loadingManagerInsight;
    },
    insight:(state: any) => {
      return state.insight;
    },
    loadingresponse:(state: any) => {
      return state.loadingresponse;
    },
    response:(state: any) => {
      return state.response;
    },
    dataQualitybyTeam:(state:any)=>{
      return state.dataQualitybyTeam
    },
    insightresponse:(state:any)=>{
      return state.insightresponse
    },
    label:(state:any)=>{
      return state.label
    },
    weeklyData:(state:any)=>{
      return state.weeklyData
    },
    standards_data:(state:any)=>{
      return state.standards_data
    },
    performanceBoostEnabled:(state:any)=>{
      return state.performanceBoostEnabled
    },
    memberbyteam:(state:any)=>{
      return state.memberbyteam
    },
    user_placeholder:(state:any)=>{
      return state.user_placeholder
    },
    teamHeight:(state:any)=>{
      return state.teamHeight
    },
    membersall : (state:any) => {
      return state.membersall
  },
  peerFeedbackHistory:(state:any)=>{
    return state.peerFeedbackHistory
  },
  // Manager To-do List getters
  managerTodoList:(state:any)=>{
    return state.managerTodoList
  },
  managerTodoSelectedWeek:(state:any)=>{
    return state.managerTodoSelectedWeek
  },
  managerTodoAvailableWeeks:(state:any)=>{
    return state.managerTodoAvailableWeeks
  },
  loadingManagerTodos:(state:any)=>{
    return state.loadingManagerTodos
  },
  /**
   * Get total action items summary across all managers
   * Filters by selected team using teamOneLevel hierarchy
   * Returns { totalItems, totalManagers, weeksCount, dateRange }
   */
  totalActionItemsSummary:(state:any, getters:any, rootState:any)=>{
    const todoList = state.managerTodoList || {};
    const teamOneLevel = state.teamOneLevel;
    const teamSelected = state.teamSelected;
    
    // Get valid team IDs for filtering
    let validTeamIds: Set<string> | null = null;
    if (teamSelected && teamSelected !== 'all' && teamOneLevel && teamOneLevel.parent) {
      validTeamIds = new Set(Object.keys(teamOneLevel.parent));
      // Also include the selected team itself
      if (teamOneLevel.team_id) {
        validTeamIds.add(teamOneLevel.team_id);
      }
    }
    
    // Get user data to check team membership
    const memberAndTeam = rootState.dashboard && rootState.dashboard.memberAndTeam ? rootState.dashboard.memberAndTeam : {};
    const allUsers = memberAndTeam.users || {};
    
    let totalItems = 0;
    let managersWithItems = 0;
    const allWeeks = new Set<string>();
    
    // Count all items across all managers and weeks
    Object.keys(todoList).forEach(email => {
      // Filter by team if a team is selected
      if (validTeamIds) {
        const emailKey = email.replace(/\./g, '||');
        const userData = allUsers[emailKey];
        const userTeam = userData && userData.team ? userData.team : '';
        
        // Skip if user is not in the selected team hierarchy
        if (!validTeamIds.has(userTeam)) {
          return;
        }
      }
      
      const managerData = todoList[email];
      let managerHasItems = false;
      
      Object.keys(managerData).forEach(weekDate => {
        const weekData = managerData[weekDate];
        const itemCount = weekData && weekData.todoList ? weekData.todoList.length : 0;
        if (itemCount > 0) {
          totalItems += itemCount;
          managerHasItems = true;
          allWeeks.add(weekDate);
        }
      });
      
      if (managerHasItems) {
        managersWithItems++;
      }
    });
    
    // Get date range from weeks
    const sortedWeeks = Array.from(allWeeks).sort();
    const weeksCount = sortedWeeks.length;
    
    return {
      totalItems,
      totalManagers: managersWithItems,
      weeksCount,
      dateRange: 'Past 4 weeks'
    };
  },
  // Manager Responsiveness Trend getter
  weeklyResponsivenessData:(state:any)=>{
    return state.weeklyResponsivenessData
  },
  /**
   * Get manager responsiveness trend data formatted for Chart.js
   * Returns { labels, datasets, summary: { totalWeeks, totalManagers }, weeklyTotals }
   */
  getManagerResponsivenessTrend: (state: any) => {
    const weeklyData = state.weeklyResponsivenessData || [];
    
    if (!weeklyData || weeklyData.length === 0) {
      return { labels: [], datasets: [], summary: { totalWeeks: 0, totalManagers: 0 }, weeklyTotals: [] };
    }

    // Sort by weekKey chronologically
    const sortedData = [...weeklyData].sort((a, b) => a.weekKey.localeCompare(b.weekKey));
    
    // Build labels and calculate totals
    const labels = sortedData.map((week: any) => week.weekLabel);
    const weeklyTotals = sortedData.map((week: any) => week.total);
    const totalManagers = sortedData.length > 0 ? sortedData[sortedData.length - 1].total : 0;
    
    // Calculate percentages for each category
    const responsiveData = sortedData.map((week: any) => {
      const total = week.total || 1;
      return Math.round((week.active / total) * 100 * 10) / 10;
    });
    const moderateData = sortedData.map((week: any) => {
      const total = week.total || 1;
      return Math.round((week.passive / total) * 100 * 10) / 10;
    });
    const minimalData = sortedData.map((week: any) => {
      const total = week.total || 1;
      return Math.round((week.inactive / total) * 100 * 10) / 10;
    });
    
    // Absolute counts for tooltips
    const responsiveAbsolute = sortedData.map((week: any) => week.active);
    const moderateAbsolute = sortedData.map((week: any) => week.passive);
    const minimalAbsolute = sortedData.map((week: any) => week.inactive);
    
    const datasets = [
      {
        label: 'Responsive',
        data: responsiveData,
        absoluteData: responsiveAbsolute,
        borderColor: 'transparent',
        backgroundColor: '#66bb6a',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 0,
        borderWidth: 0,
      },
      {
        label: 'Moderate',
        data: moderateData,
        absoluteData: moderateAbsolute,
        borderColor: 'transparent',
        backgroundColor: '#fbc02d',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 0,
        borderWidth: 0,
      },
      {
        label: 'Minimal',
        data: minimalData,
        absoluteData: minimalAbsolute,
        borderColor: 'transparent',
        backgroundColor: '#f44336',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 0,
        borderWidth: 0,
      },
    ];
    
    return {
      labels,
      datasets,
      summary: {
        totalWeeks: sortedData.length,
        totalManagers,
      },
      weeklyTotals,
    };
  },
  }
}
